import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CreditNoteType = /*#__PURE__*/function (CreditNoteType) {
  CreditNoteType[CreditNoteType["CREDIT_NOTE_UNSPECIFIED"] = 0] = "CREDIT_NOTE_UNSPECIFIED";
  CreditNoteType[CreditNoteType["CREDIT_NOTE_PRE_PAYMENT"] = 1] = "CREDIT_NOTE_PRE_PAYMENT";
  CreditNoteType[CreditNoteType["CREDIT_NOTE_POST_PAYMENT"] = 2] = "CREDIT_NOTE_POST_PAYMENT";
  return CreditNoteType;
}(CreditNoteType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Frequency = /*#__PURE__*/function (Frequency) {
  Frequency[Frequency["INVALID"] = 0] = "INVALID";
  Frequency[Frequency["MONTHLY"] = 1] = "MONTHLY";
  Frequency[Frequency["YEARLY"] = 2] = "YEARLY";
  Frequency[Frequency["ONE_TIME"] = 3] = "ONE_TIME";
  return Frequency;
}(Frequency || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Currency = /*#__PURE__*/function (Currency) {
  Currency[Currency["USD"] = 0] = "USD";
  Currency[Currency["CAD"] = 1] = "CAD";
  Currency[Currency["EUR"] = 2] = "EUR";
  Currency[Currency["AUD"] = 3] = "AUD";
  Currency[Currency["GBP"] = 4] = "GBP";
  Currency[Currency["NZD"] = 5] = "NZD";
  Currency[Currency["BRL"] = 6] = "BRL";
  Currency[Currency["CHF"] = 7] = "CHF";
  Currency[Currency["CNY"] = 8] = "CNY";
  Currency[Currency["CZK"] = 9] = "CZK";
  Currency[Currency["INR"] = 10] = "INR";
  Currency[Currency["JPY"] = 11] = "JPY";
  Currency[Currency["KHR"] = 12] = "KHR";
  Currency[Currency["KRW"] = 13] = "KRW";
  Currency[Currency["MXN"] = 14] = "MXN";
  Currency[Currency["NOK"] = 15] = "NOK";
  Currency[Currency["RUB"] = 16] = "RUB";
  Currency[Currency["SEK"] = 17] = "SEK";
  Currency[Currency["SGD"] = 18] = "SGD";
  Currency[Currency["TRY"] = 19] = "TRY";
  Currency[Currency["ZAR"] = 20] = "ZAR";
  Currency[Currency["DZD"] = 21] = "DZD";
  Currency[Currency["AWG"] = 22] = "AWG";
  Currency[Currency["FJD"] = 23] = "FJD";
  Currency[Currency["KYD"] = 24] = "KYD";
  return Currency;
}(Currency || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var FeeAmountType = /*#__PURE__*/function (FeeAmountType) {
  FeeAmountType[FeeAmountType["FEE_AMOUNT_TYPE_INVALID"] = 0] = "FEE_AMOUNT_TYPE_INVALID";
  FeeAmountType[FeeAmountType["FEE_AMOUNT_TYPE_FIXED"] = 1] = "FEE_AMOUNT_TYPE_FIXED";
  FeeAmountType[FeeAmountType["FEE_AMOUNT_TYPE_PERCENTAGE"] = 2] = "FEE_AMOUNT_TYPE_PERCENTAGE";
  return FeeAmountType;
}(FeeAmountType || {});
var FeeType = /*#__PURE__*/function (FeeType) {
  FeeType[FeeType["FEE_TYPE_INVALID"] = 0] = "FEE_TYPE_INVALID";
  FeeType[FeeType["FEE_TYPE_MANAGEMENT"] = 1] = "FEE_TYPE_MANAGEMENT";
  return FeeType;
}(FeeType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BillingStrategy = /*#__PURE__*/function (BillingStrategy) {
  BillingStrategy[BillingStrategy["BILLING_STRATEGY_NONE"] = 0] = "BILLING_STRATEGY_NONE";
  BillingStrategy[BillingStrategy["BILLING_STRATEGY_END_OF_PERIOD"] = 1] = "BILLING_STRATEGY_END_OF_PERIOD";
  BillingStrategy[BillingStrategy["BILLING_STRATEGY_START_OF_PERIOD"] = 2] = "BILLING_STRATEGY_START_OF_PERIOD";
  BillingStrategy[BillingStrategy["BILLING_STRATEGY_INSTANTLY"] = 3] = "BILLING_STRATEGY_INSTANTLY";
  BillingStrategy[BillingStrategy["BILLING_STRATEGY_END_OF_DAY"] = 4] = "BILLING_STRATEGY_END_OF_DAY";
  return BillingStrategy;
}(BillingStrategy || {});
var ProductPricingType = /*#__PURE__*/function (ProductPricingType) {
  ProductPricingType[ProductPricingType["PRODUCT_PRICING_TYPE_INVALID"] = 0] = "PRODUCT_PRICING_TYPE_INVALID";
  ProductPricingType[ProductPricingType["PRODUCT_PRICING_TYPE_STANDARD"] = 1] = "PRODUCT_PRICING_TYPE_STANDARD";
  ProductPricingType[ProductPricingType["PRODUCT_PRICING_TYPE_STAIRSTEP"] = 2] = "PRODUCT_PRICING_TYPE_STAIRSTEP";
  ProductPricingType[ProductPricingType["PRODUCT_PRICING_TYPE_TIERED"] = 3] = "PRODUCT_PRICING_TYPE_TIERED";
  return ProductPricingType;
}(ProductPricingType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SubscribeValidationStatus = /*#__PURE__*/function (SubscribeValidationStatus) {
  SubscribeValidationStatus[SubscribeValidationStatus["SUBSCRIBE_VALIDATION_STATUS_UNSET"] = 0] = "SUBSCRIBE_VALIDATION_STATUS_UNSET";
  SubscribeValidationStatus[SubscribeValidationStatus["SUBSCRIBE_VALIDATION_STATUS_CANNOT_INSTANT_BILL"] = 1] = "SUBSCRIBE_VALIDATION_STATUS_CANNOT_INSTANT_BILL";
  SubscribeValidationStatus[SubscribeValidationStatus["SUBSCRIBE_VALIDATION_STATUS_MISSING_MERCHANT_INFO"] = 2] = "SUBSCRIBE_VALIDATION_STATUS_MISSING_MERCHANT_INFO";
  SubscribeValidationStatus[SubscribeValidationStatus["SUBSCRIBE_VALIDATION_STATUS_MISSING_PAYMENT_INFO"] = 3] = "SUBSCRIBE_VALIDATION_STATUS_MISSING_PAYMENT_INFO";
  SubscribeValidationStatus[SubscribeValidationStatus["SUBSCRIBE_VALIDATION_STATUS_WILL_CAUSE_FUTURE_CHARGES"] = 4] = "SUBSCRIBE_VALIDATION_STATUS_WILL_CAUSE_FUTURE_CHARGES";
  return SubscribeValidationStatus;
}(SubscribeValidationStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Consumer = /*#__PURE__*/function (Consumer) {
  Consumer[Consumer["CONSUMER_WHOLESALE"] = 0] = "CONSUMER_WHOLESALE";
  Consumer[Consumer["CONSUMER_RETAIL"] = 1] = "CONSUMER_RETAIL";
  return Consumer;
}(Consumer || {});
var RenewalState = /*#__PURE__*/function (RenewalState) {
  RenewalState[RenewalState["RENEWAL_STATE_IMMEDIATE"] = 0] = "RENEWAL_STATE_IMMEDIATE";
  RenewalState[RenewalState["RENEWAL_STATE_DELAYED"] = 1] = "RENEWAL_STATE_DELAYED";
  return RenewalState;
}(RenewalState || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Source = /*#__PURE__*/function (Source) {
  Source[Source["SOURCE_UNSET"] = 0] = "SOURCE_UNSET";
  Source[Source["SOURCE_SYSTEM"] = 1] = "SOURCE_SYSTEM";
  Source[Source["SOURCE_USER"] = 2] = "SOURCE_USER";
  return Source;
}(Source || {});
var SubscriptionStatus = /*#__PURE__*/function (SubscriptionStatus) {
  SubscriptionStatus[SubscriptionStatus["SUBSCRIPTION_STATUS_UNSET"] = 0] = "SUBSCRIPTION_STATUS_UNSET";
  SubscriptionStatus[SubscriptionStatus["SUBSCRIPTION_STATUS_ACTIVE"] = 1] = "SUBSCRIPTION_STATUS_ACTIVE";
  SubscriptionStatus[SubscriptionStatus["SUBSCRIPTION_STATUS_EXPIRED"] = 2] = "SUBSCRIPTION_STATUS_EXPIRED";
  return SubscriptionStatus;
}(SubscriptionStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DiscountType = /*#__PURE__*/function (DiscountType) {
  DiscountType[DiscountType["DISCOUNT_TYPE_FIXED_AMOUNT"] = 0] = "DISCOUNT_TYPE_FIXED_AMOUNT";
  DiscountType[DiscountType["DISCOUNT_TYPE_PERCENT_AMOUNT"] = 1] = "DISCOUNT_TYPE_PERCENT_AMOUNT";
  DiscountType[DiscountType["DISCOUNT_TYPE_FIXED_NUMBER_OF_UNITS"] = 2] = "DISCOUNT_TYPE_FIXED_NUMBER_OF_UNITS";
  DiscountType[DiscountType["DISCOUNT_TYPE_FIXED_AMOUNT_PER_UNIT"] = 3] = "DISCOUNT_TYPE_FIXED_AMOUNT_PER_UNIT";
  return DiscountType;
}(DiscountType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ContractSubscriptionStatus = /*#__PURE__*/function (ContractSubscriptionStatus) {
  ContractSubscriptionStatus[ContractSubscriptionStatus["CONTRACT_SUBSCRIPTION_STATUS_UNSET"] = 0] = "CONTRACT_SUBSCRIPTION_STATUS_UNSET";
  ContractSubscriptionStatus[ContractSubscriptionStatus["CONTRACT_SUBSCRIPTION_STATUS_PENDING"] = 1] = "CONTRACT_SUBSCRIPTION_STATUS_PENDING";
  ContractSubscriptionStatus[ContractSubscriptionStatus["CONTRACT_SUBSCRIPTION_STATUS_SUCCEEDED"] = 2] = "CONTRACT_SUBSCRIPTION_STATUS_SUCCEEDED";
  ContractSubscriptionStatus[ContractSubscriptionStatus["CONTRACT_SUBSCRIPTION_STATUS_FAILED"] = 3] = "CONTRACT_SUBSCRIPTION_STATUS_FAILED";
  return ContractSubscriptionStatus;
}(ContractSubscriptionStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ProductSummaryBillingStrategy = /*#__PURE__*/function (ProductSummaryBillingStrategy) {
  ProductSummaryBillingStrategy[ProductSummaryBillingStrategy["CHARGE_AT_END_OF_BILLING_PERIOD"] = 0] = "CHARGE_AT_END_OF_BILLING_PERIOD";
  ProductSummaryBillingStrategy[ProductSummaryBillingStrategy["CHARGE_AT_START_OF_BILLING_PERIOD"] = 1] = "CHARGE_AT_START_OF_BILLING_PERIOD";
  ProductSummaryBillingStrategy[ProductSummaryBillingStrategy["CHARGE_INSTANTLY"] = 2] = "CHARGE_INSTANTLY";
  ProductSummaryBillingStrategy[ProductSummaryBillingStrategy["CHARGE_AT_END_OF_DAY"] = 3] = "CHARGE_AT_END_OF_DAY";
  return ProductSummaryBillingStrategy;
}(ProductSummaryBillingStrategy || {});
var ProductSummaryDiscountDiscountType = /*#__PURE__*/function (ProductSummaryDiscountDiscountType) {
  ProductSummaryDiscountDiscountType[ProductSummaryDiscountDiscountType["FIXED_AMOUNT"] = 0] = "FIXED_AMOUNT";
  ProductSummaryDiscountDiscountType[ProductSummaryDiscountDiscountType["PERCENT_AMOUNT"] = 1] = "PERCENT_AMOUNT";
  ProductSummaryDiscountDiscountType[ProductSummaryDiscountDiscountType["FIXED_NUMBER_OF_UNITS"] = 2] = "FIXED_NUMBER_OF_UNITS";
  ProductSummaryDiscountDiscountType[ProductSummaryDiscountDiscountType["FIXED_AMOUNT_PER_UNIT"] = 3] = "FIXED_AMOUNT_PER_UNIT";
  return ProductSummaryDiscountDiscountType;
}(ProductSummaryDiscountDiscountType || {});
var ProductSummaryProductType = /*#__PURE__*/function (ProductSummaryProductType) {
  ProductSummaryProductType[ProductSummaryProductType["BUNDLE"] = 0] = "BUNDLE";
  ProductSummaryProductType[ProductSummaryProductType["FEE"] = 1] = "FEE";
  ProductSummaryProductType[ProductSummaryProductType["PRODUCT"] = 2] = "PRODUCT";
  ProductSummaryProductType[ProductSummaryProductType["SUBSCRIPTION"] = 3] = "SUBSCRIPTION";
  ProductSummaryProductType[ProductSummaryProductType["VENDASTA_PRODUCT"] = 4] = "VENDASTA_PRODUCT";
  return ProductSummaryProductType;
}(ProductSummaryProductType || {});
var PricingRuleType = /*#__PURE__*/function (PricingRuleType) {
  PricingRuleType[PricingRuleType["STANDARD"] = 0] = "STANDARD";
  PricingRuleType[PricingRuleType["STAIRSTEP"] = 1] = "STAIRSTEP";
  PricingRuleType[PricingRuleType["TIERED"] = 2] = "TIERED";
  PricingRuleType[PricingRuleType["CUSTOM"] = 3] = "CUSTOM";
  return PricingRuleType;
}(PricingRuleType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PaymentCardCARD_TYPE = /*#__PURE__*/function (PaymentCardCARD_TYPE) {
  PaymentCardCARD_TYPE[PaymentCardCARD_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
  PaymentCardCARD_TYPE[PaymentCardCARD_TYPE["VISA"] = 1] = "VISA";
  PaymentCardCARD_TYPE[PaymentCardCARD_TYPE["MASTERCARD"] = 2] = "MASTERCARD";
  PaymentCardCARD_TYPE[PaymentCardCARD_TYPE["AMEX"] = 3] = "AMEX";
  PaymentCardCARD_TYPE[PaymentCardCARD_TYPE["DISCOVER"] = 4] = "DISCOVER";
  PaymentCardCARD_TYPE[PaymentCardCARD_TYPE["JCB"] = 5] = "JCB";
  PaymentCardCARD_TYPE[PaymentCardCARD_TYPE["DINERS_CLUB"] = 6] = "DINERS_CLUB";
  return PaymentCardCARD_TYPE;
}(PaymentCardCARD_TYPE || {});
var PaymentCardFUNDING_TYPE = /*#__PURE__*/function (PaymentCardFUNDING_TYPE) {
  PaymentCardFUNDING_TYPE[PaymentCardFUNDING_TYPE["FUNDING_TYPE_UNKNOWN"] = 0] = "FUNDING_TYPE_UNKNOWN";
  PaymentCardFUNDING_TYPE[PaymentCardFUNDING_TYPE["FUNDING_TYPE_CREDIT"] = 1] = "FUNDING_TYPE_CREDIT";
  PaymentCardFUNDING_TYPE[PaymentCardFUNDING_TYPE["FUNDING_TYPE_DEBIT"] = 2] = "FUNDING_TYPE_DEBIT";
  PaymentCardFUNDING_TYPE[PaymentCardFUNDING_TYPE["FUNDING_TYPE_PREPAID"] = 3] = "FUNDING_TYPE_PREPAID";
  return PaymentCardFUNDING_TYPE;
}(PaymentCardFUNDING_TYPE || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PaymentMethodType = /*#__PURE__*/function (PaymentMethodType) {
  PaymentMethodType[PaymentMethodType["PAYMENT_METHOD_TYPE_UNSET"] = 0] = "PAYMENT_METHOD_TYPE_UNSET";
  PaymentMethodType[PaymentMethodType["PAYMENT_METHOD_TYPE_CARD"] = 1] = "PAYMENT_METHOD_TYPE_CARD";
  PaymentMethodType[PaymentMethodType["PAYMENT_METHOD_TYPE_ACH_DEBIT"] = 2] = "PAYMENT_METHOD_TYPE_ACH_DEBIT";
  PaymentMethodType[PaymentMethodType["PAYMENT_METHOD_TYPE_ACSS_DEBIT"] = 3] = "PAYMENT_METHOD_TYPE_ACSS_DEBIT";
  return PaymentMethodType;
}(PaymentMethodType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ListInvoicesRequestFiltersDateFilterDateField = /*#__PURE__*/function (ListInvoicesRequestFiltersDateFilterDateField) {
  ListInvoicesRequestFiltersDateFilterDateField[ListInvoicesRequestFiltersDateFilterDateField["CREATED"] = 0] = "CREATED";
  ListInvoicesRequestFiltersDateFilterDateField[ListInvoicesRequestFiltersDateFilterDateField["ISSUED"] = 1] = "ISSUED";
  return ListInvoicesRequestFiltersDateFilterDateField;
}(ListInvoicesRequestFiltersDateFilterDateField || {});
var InvoiceStatus = /*#__PURE__*/function (InvoiceStatus) {
  InvoiceStatus[InvoiceStatus["DRAFT"] = 0] = "DRAFT";
  InvoiceStatus[InvoiceStatus["DUE"] = 1] = "DUE";
  InvoiceStatus[InvoiceStatus["PAID"] = 2] = "PAID";
  InvoiceStatus[InvoiceStatus["VOID"] = 3] = "VOID";
  return InvoiceStatus;
}(InvoiceStatus || {});
var LastPaymentStatus = /*#__PURE__*/function (LastPaymentStatus) {
  LastPaymentStatus[LastPaymentStatus["PAYMENT_UNSET"] = 0] = "PAYMENT_UNSET";
  LastPaymentStatus[LastPaymentStatus["PAYMENT_SUCCESS"] = 1] = "PAYMENT_SUCCESS";
  LastPaymentStatus[LastPaymentStatus["PAYMENT_PENDING"] = 2] = "PAYMENT_PENDING";
  LastPaymentStatus[LastPaymentStatus["PAYMENT_FAILED"] = 3] = "PAYMENT_FAILED";
  return LastPaymentStatus;
}(LastPaymentStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PayoutStatus = /*#__PURE__*/function (PayoutStatus) {
  PayoutStatus[PayoutStatus["PAYOUT_STATUS_NOT_SET"] = 0] = "PAYOUT_STATUS_NOT_SET";
  PayoutStatus[PayoutStatus["PAYOUT_STATUS_PAID"] = 1] = "PAYOUT_STATUS_PAID";
  PayoutStatus[PayoutStatus["PAYOUT_STATUS_PENDING"] = 2] = "PAYOUT_STATUS_PENDING";
  PayoutStatus[PayoutStatus["PAYOUT_STATUS_IN_TRANSIT"] = 3] = "PAYOUT_STATUS_IN_TRANSIT";
  PayoutStatus[PayoutStatus["PAYOUT_STATUS_CANCELED"] = 4] = "PAYOUT_STATUS_CANCELED";
  PayoutStatus[PayoutStatus["PAYOUT_STATUS_FAILED"] = 5] = "PAYOUT_STATUS_FAILED";
  return PayoutStatus;
}(PayoutStatus || {});
var PayoutType = /*#__PURE__*/function (PayoutType) {
  PayoutType[PayoutType["PAYOUT_TYPE_NOT_SET"] = 0] = "PAYOUT_TYPE_NOT_SET";
  PayoutType[PayoutType["PAYOUT_TYPE_BANK_ACCOUNT"] = 1] = "PAYOUT_TYPE_BANK_ACCOUNT";
  PayoutType[PayoutType["PAYOUT_TYPE_CARD"] = 2] = "PAYOUT_TYPE_CARD";
  return PayoutType;
}(PayoutType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 0] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 1] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MerchantType = /*#__PURE__*/function (MerchantType) {
  MerchantType[MerchantType["MERCHANT_TYPE_INVALID"] = 0] = "MERCHANT_TYPE_INVALID";
  MerchantType[MerchantType["MERCHANT_TYPE_WHOLESALE"] = 1] = "MERCHANT_TYPE_WHOLESALE";
  MerchantType[MerchantType["MERCHANT_TYPE_RETAIL"] = 2] = "MERCHANT_TYPE_RETAIL";
  return MerchantType;
}(MerchantType || {});
var SearchMerchantsRequestSortBy = /*#__PURE__*/function (SearchMerchantsRequestSortBy) {
  SearchMerchantsRequestSortBy[SearchMerchantsRequestSortBy["SEARCH_MERCHANTS_REQUEST_SORT_BY_MERCHANT_ID"] = 0] = "SEARCH_MERCHANTS_REQUEST_SORT_BY_MERCHANT_ID";
  SearchMerchantsRequestSortBy[SearchMerchantsRequestSortBy["SEARCH_MERCHANTS_REQUEST_SORT_BY_COMPANY_NAME"] = 1] = "SEARCH_MERCHANTS_REQUEST_SORT_BY_COMPANY_NAME";
  SearchMerchantsRequestSortBy[SearchMerchantsRequestSortBy["SEARCH_MERCHANTS_REQUEST_SORT_BY_CONTACT_NAME"] = 2] = "SEARCH_MERCHANTS_REQUEST_SORT_BY_CONTACT_NAME";
  SearchMerchantsRequestSortBy[SearchMerchantsRequestSortBy["SEARCH_MERCHANTS_REQUEST_SORT_BY_EMAIL_ADDRESS"] = 3] = "SEARCH_MERCHANTS_REQUEST_SORT_BY_EMAIL_ADDRESS";
  SearchMerchantsRequestSortBy[SearchMerchantsRequestSortBy["SEARCH_MERCHANTS_REQUEST_SORT_BY_COUNTRY"] = 4] = "SEARCH_MERCHANTS_REQUEST_SORT_BY_COUNTRY";
  SearchMerchantsRequestSortBy[SearchMerchantsRequestSortBy["SEARCH_MERCHANTS_REQUEST_SORT_BY_STATE"] = 5] = "SEARCH_MERCHANTS_REQUEST_SORT_BY_STATE";
  SearchMerchantsRequestSortBy[SearchMerchantsRequestSortBy["SEARCH_MERCHANTS_REQUEST_SORT_BY_CREATED"] = 6] = "SEARCH_MERCHANTS_REQUEST_SORT_BY_CREATED";
  SearchMerchantsRequestSortBy[SearchMerchantsRequestSortBy["SEARCH_MERCHANTS_REQUEST_SORT_BY_UPDATED"] = 7] = "SEARCH_MERCHANTS_REQUEST_SORT_BY_UPDATED";
  return SearchMerchantsRequestSortBy;
}(SearchMerchantsRequestSortBy || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Month = /*#__PURE__*/function (Month) {
  Month[Month["INVALID_MONTH"] = 0] = "INVALID_MONTH";
  Month[Month["JANUARY"] = 1] = "JANUARY";
  Month[Month["FEBRUARY"] = 2] = "FEBRUARY";
  Month[Month["MARCH"] = 3] = "MARCH";
  Month[Month["APRIL"] = 4] = "APRIL";
  Month[Month["MAY"] = 5] = "MAY";
  Month[Month["JUNE"] = 6] = "JUNE";
  Month[Month["JULY"] = 7] = "JULY";
  Month[Month["AUGUST"] = 8] = "AUGUST";
  Month[Month["SEPTEMBER"] = 9] = "SEPTEMBER";
  Month[Month["OCTOBER"] = 10] = "OCTOBER";
  Month[Month["NOVEMBER"] = 11] = "NOVEMBER";
  Month[Month["DECEMBER"] = 12] = "DECEMBER";
  return Month;
}(Month || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MerchantReportStatus = /*#__PURE__*/function (MerchantReportStatus) {
  MerchantReportStatus[MerchantReportStatus["FAILED"] = 0] = "FAILED";
  MerchantReportStatus[MerchantReportStatus["PENDING"] = 1] = "PENDING";
  MerchantReportStatus[MerchantReportStatus["COMPLETED"] = 2] = "COMPLETED";
  return MerchantReportStatus;
}(MerchantReportStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CardType = /*#__PURE__*/function (CardType) {
  CardType[CardType["CARD_TYPE_UNKNOWN"] = 0] = "CARD_TYPE_UNKNOWN";
  CardType[CardType["CARD_TYPE_VISA"] = 1] = "CARD_TYPE_VISA";
  CardType[CardType["CARD_TYPE_MASTERCARD"] = 2] = "CARD_TYPE_MASTERCARD";
  CardType[CardType["CARD_TYPE_AMEX"] = 3] = "CARD_TYPE_AMEX";
  CardType[CardType["CARD_TYPE_DISCOVER"] = 4] = "CARD_TYPE_DISCOVER";
  CardType[CardType["CARD_TYPE_JCB"] = 5] = "CARD_TYPE_JCB";
  CardType[CardType["CARD_TYPE_DINERS_CLUB"] = 6] = "CARD_TYPE_DINERS_CLUB";
  return CardType;
}(CardType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DisputeStatus = /*#__PURE__*/function (DisputeStatus) {
  DisputeStatus[DisputeStatus["DISPUTE_STATUS_UNSET"] = 0] = "DISPUTE_STATUS_UNSET";
  DisputeStatus[DisputeStatus["DISPUTE_STATUS_WARNING_NEEDS_RESPONSE"] = 1] = "DISPUTE_STATUS_WARNING_NEEDS_RESPONSE";
  DisputeStatus[DisputeStatus["DISPUTE_STATUS_WARNING_UNDER_REVIEW"] = 2] = "DISPUTE_STATUS_WARNING_UNDER_REVIEW";
  DisputeStatus[DisputeStatus["DISPUTE_STATUS_WARNING_CLOSED"] = 3] = "DISPUTE_STATUS_WARNING_CLOSED";
  DisputeStatus[DisputeStatus["DISPUTE_STATUS_NEEDS_RESPONSE"] = 4] = "DISPUTE_STATUS_NEEDS_RESPONSE";
  DisputeStatus[DisputeStatus["DISPUTE_STATUS_UNDER_REVIEW"] = 5] = "DISPUTE_STATUS_UNDER_REVIEW";
  DisputeStatus[DisputeStatus["DISPUTE_STATUS_CHARGE_REFUNDED"] = 6] = "DISPUTE_STATUS_CHARGE_REFUNDED";
  DisputeStatus[DisputeStatus["DISPUTE_STATUS_WON"] = 7] = "DISPUTE_STATUS_WON";
  DisputeStatus[DisputeStatus["DISPUTE_STATUS_LOST"] = 8] = "DISPUTE_STATUS_LOST";
  return DisputeStatus;
}(DisputeStatus || {});
var PaymentAllocationType = /*#__PURE__*/function (PaymentAllocationType) {
  PaymentAllocationType[PaymentAllocationType["PAYMENT_ALLOCATION_TYPE_UNSET"] = 0] = "PAYMENT_ALLOCATION_TYPE_UNSET";
  PaymentAllocationType[PaymentAllocationType["PAYMENT_ALLOCATION_TYPE_PURCHASE"] = 1] = "PAYMENT_ALLOCATION_TYPE_PURCHASE";
  PaymentAllocationType[PaymentAllocationType["PAYMENT_ALLOCATION_TYPE_INVOICE"] = 2] = "PAYMENT_ALLOCATION_TYPE_INVOICE";
  return PaymentAllocationType;
}(PaymentAllocationType || {});
var PaymentErrorCode = /*#__PURE__*/function (PaymentErrorCode) {
  PaymentErrorCode[PaymentErrorCode["PAYMENT_ERROR_CODE_UNSET"] = 0] = "PAYMENT_ERROR_CODE_UNSET";
  PaymentErrorCode[PaymentErrorCode["PAYMENT_ERROR_CODE_UNKNOWN"] = 1] = "PAYMENT_ERROR_CODE_UNKNOWN";
  PaymentErrorCode[PaymentErrorCode["PAYMENT_ERROR_CODE_NO_ACCOUNT"] = 2] = "PAYMENT_ERROR_CODE_NO_ACCOUNT";
  PaymentErrorCode[PaymentErrorCode["PAYMENT_ERROR_CODE_INSUFFICIENT_FUNDS"] = 3] = "PAYMENT_ERROR_CODE_INSUFFICIENT_FUNDS";
  PaymentErrorCode[PaymentErrorCode["PAYMENT_ERROR_CODE_DEBIT_NOT_AUTHORIZED"] = 4] = "PAYMENT_ERROR_CODE_DEBIT_NOT_AUTHORIZED";
  return PaymentErrorCode;
}(PaymentErrorCode || {});
var PaymentFacilitatorType = /*#__PURE__*/function (PaymentFacilitatorType) {
  PaymentFacilitatorType[PaymentFacilitatorType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  PaymentFacilitatorType[PaymentFacilitatorType["CUSTOM_STRIPE"] = 1] = "CUSTOM_STRIPE";
  PaymentFacilitatorType[PaymentFacilitatorType["STANDARD_STRIPE"] = 2] = "STANDARD_STRIPE";
  return PaymentFacilitatorType;
}(PaymentFacilitatorType || {});
var PaymentIntentStatus = /*#__PURE__*/function (PaymentIntentStatus) {
  PaymentIntentStatus[PaymentIntentStatus["PAYMENT_INTENT_STATUS_UNSET"] = 0] = "PAYMENT_INTENT_STATUS_UNSET";
  PaymentIntentStatus[PaymentIntentStatus["PAYMENT_INTENT_STATUS_PROCESSING"] = 1] = "PAYMENT_INTENT_STATUS_PROCESSING";
  PaymentIntentStatus[PaymentIntentStatus["PAYMENT_INTENT_STATUS_SUCCEEDED"] = 2] = "PAYMENT_INTENT_STATUS_SUCCEEDED";
  return PaymentIntentStatus;
}(PaymentIntentStatus || {});
var RetailPaymentPaymentMethodDetailsType = /*#__PURE__*/function (RetailPaymentPaymentMethodDetailsType) {
  RetailPaymentPaymentMethodDetailsType[RetailPaymentPaymentMethodDetailsType["PAYMENT_METHOD_DETAILS_TYPE_UNSET"] = 0] = "PAYMENT_METHOD_DETAILS_TYPE_UNSET";
  RetailPaymentPaymentMethodDetailsType[RetailPaymentPaymentMethodDetailsType["PAYMENT_METHOD_DETAILS_TYPE_CARD"] = 1] = "PAYMENT_METHOD_DETAILS_TYPE_CARD";
  RetailPaymentPaymentMethodDetailsType[RetailPaymentPaymentMethodDetailsType["PAYMENT_METHOD_DETAILS_TYPE_ACH_DEBIT"] = 2] = "PAYMENT_METHOD_DETAILS_TYPE_ACH_DEBIT";
  RetailPaymentPaymentMethodDetailsType[RetailPaymentPaymentMethodDetailsType["PAYMENT_METHOD_DETAILS_TYPE_ACSS_DEBIT"] = 3] = "PAYMENT_METHOD_DETAILS_TYPE_ACSS_DEBIT";
  return RetailPaymentPaymentMethodDetailsType;
}(RetailPaymentPaymentMethodDetailsType || {});
var PaymentSource = /*#__PURE__*/function (PaymentSource) {
  PaymentSource[PaymentSource["PAYMENT_SOURCE_NONE"] = 0] = "PAYMENT_SOURCE_NONE";
  PaymentSource[PaymentSource["PAYMENT_SOURCE_STRIPE"] = 1] = "PAYMENT_SOURCE_STRIPE";
  PaymentSource[PaymentSource["PAYMENT_SOURCE_VCASH"] = 2] = "PAYMENT_SOURCE_VCASH";
  return PaymentSource;
}(PaymentSource || {});
var PaymentStatus = /*#__PURE__*/function (PaymentStatus) {
  PaymentStatus[PaymentStatus["PAYMENT_STATUS_UNSET"] = 0] = "PAYMENT_STATUS_UNSET";
  PaymentStatus[PaymentStatus["PAYMENT_STATUS_SUCCEEDED"] = 1] = "PAYMENT_STATUS_SUCCEEDED";
  PaymentStatus[PaymentStatus["PAYMENT_STATUS_FAILED"] = 2] = "PAYMENT_STATUS_FAILED";
  PaymentStatus[PaymentStatus["PAYMENT_STATUS_REFUNDED"] = 3] = "PAYMENT_STATUS_REFUNDED";
  PaymentStatus[PaymentStatus["PAYMENT_STATUS_PARTIALLY_REFUNDED"] = 4] = "PAYMENT_STATUS_PARTIALLY_REFUNDED";
  PaymentStatus[PaymentStatus["PAYMENT_STATUS_PENDING"] = 5] = "PAYMENT_STATUS_PENDING";
  return PaymentStatus;
}(PaymentStatus || {});
var RetailPaymentReferenceType = /*#__PURE__*/function (RetailPaymentReferenceType) {
  RetailPaymentReferenceType[RetailPaymentReferenceType["RETAIL_PAYMENT_REFERENCE_TYPE_UNSET"] = 0] = "RETAIL_PAYMENT_REFERENCE_TYPE_UNSET";
  RetailPaymentReferenceType[RetailPaymentReferenceType["RETAIL_PAYMENT_REFERENCE_TYPE_INVOICE"] = 1] = "RETAIL_PAYMENT_REFERENCE_TYPE_INVOICE";
  RetailPaymentReferenceType[RetailPaymentReferenceType["RETAIL_PAYMENT_REFERENCE_TYPE_SALES_ORDER"] = 2] = "RETAIL_PAYMENT_REFERENCE_TYPE_SALES_ORDER";
  return RetailPaymentReferenceType;
}(RetailPaymentReferenceType || {});
var RetailRefundFailureReason = /*#__PURE__*/function (RetailRefundFailureReason) {
  RetailRefundFailureReason[RetailRefundFailureReason["RETAIL_REFUND_FAILURE_REASON_UNSET"] = 0] = "RETAIL_REFUND_FAILURE_REASON_UNSET";
  RetailRefundFailureReason[RetailRefundFailureReason["RETAIL_REFUND_FAILURE_REASON_LOST_OR_STOLEN_CARD"] = 1] = "RETAIL_REFUND_FAILURE_REASON_LOST_OR_STOLEN_CARD";
  RetailRefundFailureReason[RetailRefundFailureReason["RETAIL_REFUND_FAILURE_REASON_EXPIRED_OR_CANCELED_CARD"] = 2] = "RETAIL_REFUND_FAILURE_REASON_EXPIRED_OR_CANCELED_CARD";
  RetailRefundFailureReason[RetailRefundFailureReason["RETAIL_REFUND_FAILURE_REASON_UNKNOWN"] = 3] = "RETAIL_REFUND_FAILURE_REASON_UNKNOWN";
  return RetailRefundFailureReason;
}(RetailRefundFailureReason || {});
var RetailRefundReason = /*#__PURE__*/function (RetailRefundReason) {
  RetailRefundReason[RetailRefundReason["RETAIL_REFUND_REASON_UNSET"] = 0] = "RETAIL_REFUND_REASON_UNSET";
  RetailRefundReason[RetailRefundReason["RETAIL_REFUND_REASON_DUPLICATE"] = 1] = "RETAIL_REFUND_REASON_DUPLICATE";
  RetailRefundReason[RetailRefundReason["RETAIL_REFUND_REASON_FRAUDULENT"] = 2] = "RETAIL_REFUND_REASON_FRAUDULENT";
  RetailRefundReason[RetailRefundReason["RETAIL_REFUND_REASON_REQUESTED_BY_CUSTOMER"] = 3] = "RETAIL_REFUND_REASON_REQUESTED_BY_CUSTOMER";
  return RetailRefundReason;
}(RetailRefundReason || {});
var RetailRefundStatus = /*#__PURE__*/function (RetailRefundStatus) {
  RetailRefundStatus[RetailRefundStatus["RETAIL_REFUND_STATUS_UNSET"] = 0] = "RETAIL_REFUND_STATUS_UNSET";
  RetailRefundStatus[RetailRefundStatus["RETAIL_REFUND_STATUS_PENDING"] = 1] = "RETAIL_REFUND_STATUS_PENDING";
  RetailRefundStatus[RetailRefundStatus["RETAIL_REFUND_STATUS_SUCCEEDED"] = 2] = "RETAIL_REFUND_STATUS_SUCCEEDED";
  RetailRefundStatus[RetailRefundStatus["RETAIL_REFUND_STATUS_FAILED"] = 3] = "RETAIL_REFUND_STATUS_FAILED";
  RetailRefundStatus[RetailRefundStatus["RETAIL_REFUND_STATUS_REQUIRES_ACTION"] = 4] = "RETAIL_REFUND_STATUS_REQUIRES_ACTION";
  RetailRefundStatus[RetailRefundStatus["RETAIL_REFUND_STATUS_CANCELED"] = 5] = "RETAIL_REFUND_STATUS_CANCELED";
  return RetailRefundStatus;
}(RetailRefundStatus || {});
var RetailTransactionType = /*#__PURE__*/function (RetailTransactionType) {
  RetailTransactionType[RetailTransactionType["RETAIL_TRANSACTION_TYPE_UNSET"] = 0] = "RETAIL_TRANSACTION_TYPE_UNSET";
  RetailTransactionType[RetailTransactionType["RETAIL_TRANSACTION_TYPE_PAYMENT"] = 1] = "RETAIL_TRANSACTION_TYPE_PAYMENT";
  RetailTransactionType[RetailTransactionType["RETAIL_TRANSACTION_TYPE_REFUND"] = 2] = "RETAIL_TRANSACTION_TYPE_REFUND";
  RetailTransactionType[RetailTransactionType["RETAIL_TRANSACTION_TYPE_PAYOUT_FAILURE"] = 3] = "RETAIL_TRANSACTION_TYPE_PAYOUT_FAILURE";
  RetailTransactionType[RetailTransactionType["RETAIL_TRANSACTION_TYPE_ADJUSTMENT"] = 4] = "RETAIL_TRANSACTION_TYPE_ADJUSTMENT";
  return RetailTransactionType;
}(RetailTransactionType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ProductType = /*#__PURE__*/function (ProductType) {
  ProductType[ProductType["PRODUCT_TYPE_INVALID"] = 0] = "PRODUCT_TYPE_INVALID";
  ProductType[ProductType["PRODUCT_TYPE_STANDARD_PRODUCT"] = 1] = "PRODUCT_TYPE_STANDARD_PRODUCT";
  ProductType[ProductType["PRODUCT_TYPE_VENDASTA_PRODUCT"] = 2] = "PRODUCT_TYPE_VENDASTA_PRODUCT";
  ProductType[ProductType["PRODUCT_TYPE_SUBSCRIPTION"] = 3] = "PRODUCT_TYPE_SUBSCRIPTION";
  ProductType[ProductType["PRODUCT_TYPE_FEE"] = 4] = "PRODUCT_TYPE_FEE";
  ProductType[ProductType["PRODUCT_TYPE_PRIVATE_PRODUCT"] = 5] = "PRODUCT_TYPE_PRIVATE_PRODUCT";
  ProductType[ProductType["PRODUCT_TYPE_PARTNER_SUPPORT_SALES"] = 6] = "PRODUCT_TYPE_PARTNER_SUPPORT_SALES";
  ProductType[ProductType["PRODUCT_TYPE_PACKAGE"] = 7] = "PRODUCT_TYPE_PACKAGE";
  return ProductType;
}(ProductType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CreditType = /*#__PURE__*/function (CreditType) {
  CreditType[CreditType["CREDIT_TYPE_UNSET"] = 0] = "CREDIT_TYPE_UNSET";
  CreditType[CreditType["CREDIT_TYPE_CREDIT_NOTE"] = 1] = "CREDIT_TYPE_CREDIT_NOTE";
  CreditType[CreditType["CREDIT_TYPE_PROMOTIONAL"] = 2] = "CREDIT_TYPE_PROMOTIONAL";
  return CreditType;
}(CreditType || {});
var PurchaseStatus = /*#__PURE__*/function (PurchaseStatus) {
  PurchaseStatus[PurchaseStatus["PURCHASE_STATUS_UNSET"] = 0] = "PURCHASE_STATUS_UNSET";
  PurchaseStatus[PurchaseStatus["PURCHASE_STATUS_PENDING"] = 1] = "PURCHASE_STATUS_PENDING";
  PurchaseStatus[PurchaseStatus["PURCHASE_STATUS_DUE"] = 2] = "PURCHASE_STATUS_DUE";
  PurchaseStatus[PurchaseStatus["PURCHASE_STATUS_SUCCESS"] = 3] = "PURCHASE_STATUS_SUCCESS";
  PurchaseStatus[PurchaseStatus["PURCHASE_STATUS_DUNNING"] = 4] = "PURCHASE_STATUS_DUNNING";
  PurchaseStatus[PurchaseStatus["PURCHASE_STATUS_FAILED"] = 5] = "PURCHASE_STATUS_FAILED";
  return PurchaseStatus;
}(PurchaseStatus || {});
var ListPurchaseRequestState = /*#__PURE__*/function (ListPurchaseRequestState) {
  ListPurchaseRequestState[ListPurchaseRequestState["LIST_PURCHASE_REQUEST_STATE_ALL"] = 0] = "LIST_PURCHASE_REQUEST_STATE_ALL";
  ListPurchaseRequestState[ListPurchaseRequestState["LIST_PURCHASE_REQUEST_STATE_OVERDUE"] = 1] = "LIST_PURCHASE_REQUEST_STATE_OVERDUE";
  return ListPurchaseRequestState;
}(ListPurchaseRequestState || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ReferenceType = /*#__PURE__*/function (ReferenceType) {
  ReferenceType[ReferenceType["PURCHASE"] = 0] = "PURCHASE";
  ReferenceType[ReferenceType["PURCHASE_ITEM"] = 1] = "PURCHASE_ITEM";
  ReferenceType[ReferenceType["INVOICE"] = 2] = "INVOICE";
  return ReferenceType;
}(ReferenceType || {});
var RefundReason = /*#__PURE__*/function (RefundReason) {
  RefundReason[RefundReason["REQUESTED_BY_CUSTOMER"] = 0] = "REQUESTED_BY_CUSTOMER";
  RefundReason[RefundReason["DUPLICATE"] = 1] = "DUPLICATE";
  RefundReason[RefundReason["FRAUDULENT"] = 2] = "FRAUDULENT";
  return RefundReason;
}(RefundReason || {});
var RefundStatus = /*#__PURE__*/function (RefundStatus) {
  RefundStatus[RefundStatus["SUCCEEDED"] = 0] = "SUCCEEDED";
  RefundStatus[RefundStatus["FAILED"] = 1] = "FAILED";
  RefundStatus[RefundStatus["PENDING"] = 3] = "PENDING";
  return RefundStatus;
}(RefundStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SalesCreditNoteStatus = /*#__PURE__*/function (SalesCreditNoteStatus) {
  SalesCreditNoteStatus[SalesCreditNoteStatus["SALES_CREDIT_NOTE_STATUS_IN_PROGRESS"] = 0] = "SALES_CREDIT_NOTE_STATUS_IN_PROGRESS";
  SalesCreditNoteStatus[SalesCreditNoteStatus["SALES_CREDIT_NOTE_STATUS_READY_TO_POST"] = 1] = "SALES_CREDIT_NOTE_STATUS_READY_TO_POST";
  SalesCreditNoteStatus[SalesCreditNoteStatus["SALES_CREDIT_NOTE_STATUS_COMPLETE"] = 2] = "SALES_CREDIT_NOTE_STATUS_COMPLETE";
  SalesCreditNoteStatus[SalesCreditNoteStatus["SALES_CREDIT_NOTE_STATUS_DISCARDED"] = 3] = "SALES_CREDIT_NOTE_STATUS_DISCARDED";
  return SalesCreditNoteStatus;
}(SalesCreditNoteStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PaymentStatuses = /*#__PURE__*/function (PaymentStatuses) {
  PaymentStatuses[PaymentStatuses["PAYMENT_STATUSES_NOT_SET"] = 0] = "PAYMENT_STATUSES_NOT_SET";
  PaymentStatuses[PaymentStatuses["PAYMENT_STATUSES_UNPAID"] = 1] = "PAYMENT_STATUSES_UNPAID";
  PaymentStatuses[PaymentStatuses["PAYMENT_STATUSES_PAID"] = 2] = "PAYMENT_STATUSES_PAID";
  PaymentStatuses[PaymentStatuses["PAYMENT_STATUSES_PART_PAID"] = 3] = "PAYMENT_STATUSES_PART_PAID";
  PaymentStatuses[PaymentStatuses["PAYMENT_STATUSES_NOT_APPLICABLE"] = 4] = "PAYMENT_STATUSES_NOT_APPLICABLE";
  return PaymentStatuses;
}(PaymentStatuses || {});
var SalesInvoiceStatus = /*#__PURE__*/function (SalesInvoiceStatus) {
  SalesInvoiceStatus[SalesInvoiceStatus["SALES_INVOICE_STATUS_IN_PROGRESS"] = 0] = "SALES_INVOICE_STATUS_IN_PROGRESS";
  SalesInvoiceStatus[SalesInvoiceStatus["SALES_INVOICE_STATUS_READY_TO_POST"] = 1] = "SALES_INVOICE_STATUS_READY_TO_POST";
  SalesInvoiceStatus[SalesInvoiceStatus["SALES_INVOICE_STATUS_COMPLETE"] = 2] = "SALES_INVOICE_STATUS_COMPLETE";
  SalesInvoiceStatus[SalesInvoiceStatus["SALES_INVOICE_STATUS_DISCARDED"] = 3] = "SALES_INVOICE_STATUS_DISCARDED";
  return SalesInvoiceStatus;
}(SalesInvoiceStatus || {});
var SalesInvoiceType = /*#__PURE__*/function (SalesInvoiceType) {
  SalesInvoiceType[SalesInvoiceType["SALES_INVOICE_TYPE_UNSET"] = 0] = "SALES_INVOICE_TYPE_UNSET";
  SalesInvoiceType[SalesInvoiceType["SALES_INVOICE_TYPE_INVOICED"] = 1] = "SALES_INVOICE_TYPE_INVOICED";
  SalesInvoiceType[SalesInvoiceType["SALES_INVOICE_TYPE_INSTANT"] = 2] = "SALES_INVOICE_TYPE_INSTANT";
  return SalesInvoiceType;
}(SalesInvoiceType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var TaxRuleEntityType = /*#__PURE__*/function (TaxRuleEntityType) {
  TaxRuleEntityType[TaxRuleEntityType["TAX_RULE_ENTITY_TYPE_UNSET"] = 0] = "TAX_RULE_ENTITY_TYPE_UNSET";
  TaxRuleEntityType[TaxRuleEntityType["TAX_RULE_ENTITY_TYPE_CUSTOMER"] = 1] = "TAX_RULE_ENTITY_TYPE_CUSTOMER";
  TaxRuleEntityType[TaxRuleEntityType["TAX_RULE_ENTITY_TYPE_PRODUCT"] = 2] = "TAX_RULE_ENTITY_TYPE_PRODUCT";
  return TaxRuleEntityType;
}(TaxRuleEntityType || {});
var TaxRuleType = /*#__PURE__*/function (TaxRuleType) {
  TaxRuleType[TaxRuleType["TAX_RULE_TYPE_UNSET"] = 0] = "TAX_RULE_TYPE_UNSET";
  TaxRuleType[TaxRuleType["TAX_RULE_TYPE_EXEMPTION"] = 1] = "TAX_RULE_TYPE_EXEMPTION";
  return TaxRuleType;
}(TaxRuleType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PaymentProcessor = /*#__PURE__*/function (PaymentProcessor) {
  PaymentProcessor[PaymentProcessor["PAYMENT_PROCESSOR_INVALID"] = 0] = "PAYMENT_PROCESSOR_INVALID";
  PaymentProcessor[PaymentProcessor["PAYMENT_PROCESSOR_UNSET"] = 1] = "PAYMENT_PROCESSOR_UNSET";
  PaymentProcessor[PaymentProcessor["PAYMENT_PROCESSOR_STRIPE"] = 2] = "PAYMENT_PROCESSOR_STRIPE";
  return PaymentProcessor;
}(PaymentProcessor || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CollectionMethod = /*#__PURE__*/function (CollectionMethod) {
  CollectionMethod[CollectionMethod["COLLECTION_METHOD_INVALID"] = 0] = "COLLECTION_METHOD_INVALID";
  CollectionMethod[CollectionMethod["COLLECTION_METHOD_MANUAL"] = 1] = "COLLECTION_METHOD_MANUAL";
  CollectionMethod[CollectionMethod["COLLECTION_METHOD_EMAIL"] = 2] = "COLLECTION_METHOD_EMAIL";
  CollectionMethod[CollectionMethod["COLLECTION_METHOD_CHARGE_AUTOMATICALLY"] = 3] = "COLLECTION_METHOD_CHARGE_AUTOMATICALLY";
  return CollectionMethod;
}(CollectionMethod || {});
var Interval = /*#__PURE__*/function (Interval) {
  Interval[Interval["INTERVAL_INVALID"] = 0] = "INTERVAL_INVALID";
  Interval[Interval["INTERVAL_DAY"] = 1] = "INTERVAL_DAY";
  Interval[Interval["INTERVAL_WEEK"] = 2] = "INTERVAL_WEEK";
  Interval[Interval["INTERVAL_MONTH"] = 3] = "INTERVAL_MONTH";
  Interval[Interval["INTERVAL_YEAR"] = 4] = "INTERVAL_YEAR";
  return Interval;
}(Interval || {});
var RecurringInvoiceStatus = /*#__PURE__*/function (RecurringInvoiceStatus) {
  RecurringInvoiceStatus[RecurringInvoiceStatus["RECURRING_INVOICE_STATUS_INVALID"] = 0] = "RECURRING_INVOICE_STATUS_INVALID";
  RecurringInvoiceStatus[RecurringInvoiceStatus["RECURRING_INVOICE_STATUS_INACTIVE"] = 1] = "RECURRING_INVOICE_STATUS_INACTIVE";
  RecurringInvoiceStatus[RecurringInvoiceStatus["RECURRING_INVOICE_STATUS_ACTIVE"] = 2] = "RECURRING_INVOICE_STATUS_ACTIVE";
  RecurringInvoiceStatus[RecurringInvoiceStatus["RECURRING_INVOICE_STATUS_ARCHIVED"] = 3] = "RECURRING_INVOICE_STATUS_ARCHIVED";
  return RecurringInvoiceStatus;
}(RecurringInvoiceStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MerchantServicesReportRunStatus = /*#__PURE__*/function (MerchantServicesReportRunStatus) {
  MerchantServicesReportRunStatus[MerchantServicesReportRunStatus["MERCHANT_SERVICES_REPORT_RUN_STATUS_UNSPECIFIED"] = 0] = "MERCHANT_SERVICES_REPORT_RUN_STATUS_UNSPECIFIED";
  MerchantServicesReportRunStatus[MerchantServicesReportRunStatus["MERCHANT_SERVICES_REPORT_RUN_STATUS_PENDING"] = 1] = "MERCHANT_SERVICES_REPORT_RUN_STATUS_PENDING";
  MerchantServicesReportRunStatus[MerchantServicesReportRunStatus["MERCHANT_SERVICES_REPORT_RUN_STATUS_SUCCEEDED"] = 2] = "MERCHANT_SERVICES_REPORT_RUN_STATUS_SUCCEEDED";
  MerchantServicesReportRunStatus[MerchantServicesReportRunStatus["MERCHANT_SERVICES_REPORT_RUN_STATUS_FAILED"] = 3] = "MERCHANT_SERVICES_REPORT_RUN_STATUS_FAILED";
  return MerchantServicesReportRunStatus;
}(MerchantServicesReportRunStatus || {});
var MerchantServicesReportRunType = /*#__PURE__*/function (MerchantServicesReportRunType) {
  MerchantServicesReportRunType[MerchantServicesReportRunType["MERCHANT_SERVICES_REPORT_RUN_TYPE_UNSPECIFIED"] = 0] = "MERCHANT_SERVICES_REPORT_RUN_TYPE_UNSPECIFIED";
  MerchantServicesReportRunType[MerchantServicesReportRunType["MERCHANT_SERVICES_REPORT_RUN_TYPE_BALANCE_ITEMIZED"] = 1] = "MERCHANT_SERVICES_REPORT_RUN_TYPE_BALANCE_ITEMIZED";
  return MerchantServicesReportRunType;
}(MerchantServicesReportRunType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var EntityType = /*#__PURE__*/function (EntityType) {
  EntityType[EntityType["ENTITY_TYPE_INVALID"] = 0] = "ENTITY_TYPE_INVALID";
  EntityType[EntityType["ENTITY_TYPE_SUBSCRIPTION"] = 1] = "ENTITY_TYPE_SUBSCRIPTION";
  return EntityType;
}(EntityType || {});
var RelationshipType = /*#__PURE__*/function (RelationshipType) {
  RelationshipType[RelationshipType["RELATIONSHIP_TYPE_INVALID"] = 0] = "RELATIONSHIP_TYPE_INVALID";
  RelationshipType[RelationshipType["RELATIONSHIP_TYPE_ASSOCIATED_WITH"] = 1] = "RELATIONSHIP_TYPE_ASSOCIATED_WITH";
  return RelationshipType;
}(RelationshipType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AppliedReferenceType = /*#__PURE__*/function (AppliedReferenceType) {
  AppliedReferenceType[AppliedReferenceType["APPLIED_REFERENCE_TYPE_UNSPECIFIED"] = 0] = "APPLIED_REFERENCE_TYPE_UNSPECIFIED";
  AppliedReferenceType[AppliedReferenceType["APPLIED_REFERENCE_TYPE_INVOICE"] = 1] = "APPLIED_REFERENCE_TYPE_INVOICE";
  return AppliedReferenceType;
}(AppliedReferenceType || {});
var CreditNoteReason = /*#__PURE__*/function (CreditNoteReason) {
  CreditNoteReason[CreditNoteReason["CREDIT_NOTE_REASON_UNSPECIFIED"] = 0] = "CREDIT_NOTE_REASON_UNSPECIFIED";
  CreditNoteReason[CreditNoteReason["CREDIT_NOTE_REASON_DUPLICATE_CHARGE"] = 1] = "CREDIT_NOTE_REASON_DUPLICATE_CHARGE";
  CreditNoteReason[CreditNoteReason["CREDIT_NOTE_REASON_PRODUCT_UNSATISFACTORY"] = 2] = "CREDIT_NOTE_REASON_PRODUCT_UNSATISFACTORY";
  CreditNoteReason[CreditNoteReason["CREDIT_NOTE_REASON_ORDER_CHANGE"] = 3] = "CREDIT_NOTE_REASON_ORDER_CHANGE";
  CreditNoteReason[CreditNoteReason["CREDIT_NOTE_REASON_OTHER"] = 4] = "CREDIT_NOTE_REASON_OTHER";
  return CreditNoteReason;
}(CreditNoteReason || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$J(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ExportResponse {
  static fromProto(proto) {
    let m = new ExportResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class Note {
  static fromProto(proto) {
    let m = new Note();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
function enumStringToValue$I(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$H(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Commitment {
  static fromProto(proto) {
    let m = new Commitment();
    m = Object.assign(m, proto);
    if (proto.initial) {
      m.initial = parseInt(proto.initial, 10);
    }
    if (proto.recurring) {
      m.recurring = parseInt(proto.recurring, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.initial !== 'undefined') {
      toReturn['initial'] = this.initial;
    }
    if (typeof this.recurring !== 'undefined') {
      toReturn['recurring'] = this.recurring;
    }
    return toReturn;
  }
}
function enumStringToValue$G(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppliedFee {
  static fromProto(proto) {
    let m = new AppliedFee();
    m = Object.assign(m, proto);
    if (proto.appliedAmount) {
      m.appliedAmount = parseInt(proto.appliedAmount, 10);
    }
    if (proto.fee) {
      m.fee = Fee.fromProto(proto.fee);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appliedAmount !== 'undefined') {
      toReturn['appliedAmount'] = this.appliedAmount;
    }
    if (typeof this.fee !== 'undefined' && this.fee !== null) {
      toReturn['fee'] = 'toApiJson' in this.fee ? this.fee.toApiJson() : this.fee;
    }
    return toReturn;
  }
}
class Fee {
  static fromProto(proto) {
    let m = new Fee();
    m = Object.assign(m, proto);
    if (proto.amountType) {
      m.amountType = enumStringToValue$G(FeeAmountType, proto.amountType);
    }
    if (proto.feeType) {
      m.feeType = enumStringToValue$G(FeeType, proto.feeType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.amountType !== 'undefined') {
      toReturn['amountType'] = this.amountType;
    }
    if (typeof this.feeType !== 'undefined') {
      toReturn['feeType'] = this.feeType;
    }
    return toReturn;
  }
}
function enumStringToValue$F(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ComponentPricing {
  static fromProto(proto) {
    let m = new ComponentPricing();
    m = Object.assign(m, proto);
    if (proto.unitPrice) {
      m.unitPrice = parseInt(proto.unitPrice, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.componentId !== 'undefined') {
      toReturn['componentId'] = this.componentId;
    }
    if (typeof this.unitPrice !== 'undefined') {
      toReturn['unitPrice'] = this.unitPrice;
    }
    return toReturn;
  }
}
class CreatePricingPlanRequest {
  static fromProto(proto) {
    let m = new CreatePricingPlanRequest();
    m = Object.assign(m, proto);
    if (proto.defaultBillingStrategy) {
      m.defaultBillingStrategy = enumStringToValue$F(BillingStrategy, proto.defaultBillingStrategy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.defaultBillingStrategy !== 'undefined') {
      toReturn['defaultBillingStrategy'] = this.defaultBillingStrategy;
    }
    return toReturn;
  }
}
class CreatePricingPlanResponse {
  static fromProto(proto) {
    let m = new CreatePricingPlanResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetMultiPricingPlanRequest {
  static fromProto(proto) {
    let m = new GetMultiPricingPlanRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanIds !== 'undefined') {
      toReturn['pricingPlanIds'] = this.pricingPlanIds;
    }
    return toReturn;
  }
}
class GetMultiPricingPlanResponse {
  static fromProto(proto) {
    let m = new GetMultiPricingPlanResponse();
    m = Object.assign(m, proto);
    if (proto.plans) {
      m.plans = proto.plans.map(PricingPlan.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.plans !== 'undefined' && this.plans !== null) {
      toReturn['plans'] = 'toApiJson' in this.plans ? this.plans.toApiJson() : this.plans;
    }
    return toReturn;
  }
}
class PricingPlan {
  static fromProto(proto) {
    let m = new PricingPlan();
    m = Object.assign(m, proto);
    if (proto.defaultBillingStrategy) {
      m.defaultBillingStrategy = enumStringToValue$F(BillingStrategy, proto.defaultBillingStrategy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.defaultBillingStrategy !== 'undefined') {
      toReturn['defaultBillingStrategy'] = this.defaultBillingStrategy;
    }
    return toReturn;
  }
}
class PricingPlanProductPricing {
  static fromProto(proto) {
    let m = new PricingPlanProductPricing();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$F(ProductPricingType, proto.type);
    }
    if (proto.rules) {
      m.rules = proto.rules.map(ProductPricingRule.fromProto);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$F(Frequency, proto.frequency);
    }
    if (proto.fees) {
      m.fees = proto.fees.map(Fee.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.rules !== 'undefined' && this.rules !== null) {
      toReturn['rules'] = 'toApiJson' in this.rules ? this.rules.toApiJson() : this.rules;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.fees !== 'undefined' && this.fees !== null) {
      toReturn['fees'] = 'toApiJson' in this.fees ? this.fees.toApiJson() : this.fees;
    }
    return toReturn;
  }
}
class ProductPricingRule {
  static fromProto(proto) {
    let m = new ProductPricingRule();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    if (proto.minUnits) {
      m.minUnits = parseInt(proto.minUnits, 10);
    }
    if (proto.maxUnits) {
      m.maxUnits = parseInt(proto.maxUnits, 10);
    }
    if (proto.componentPricing) {
      m.componentPricing = proto.componentPricing.map(ComponentPricing.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.minUnits !== 'undefined') {
      toReturn['minUnits'] = this.minUnits;
    }
    if (typeof this.maxUnits !== 'undefined') {
      toReturn['maxUnits'] = this.maxUnits;
    }
    if (typeof this.componentPricing !== 'undefined' && this.componentPricing !== null) {
      toReturn['componentPricing'] = 'toApiJson' in this.componentPricing ? this.componentPricing.toApiJson() : this.componentPricing;
    }
    return toReturn;
  }
}
class UpdatePricingPlanRequest {
  static fromProto(proto) {
    let m = new UpdatePricingPlanRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.defaultBillingStrategy) {
      m.defaultBillingStrategy = enumStringToValue$F(BillingStrategy, proto.defaultBillingStrategy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.defaultBillingStrategy !== 'undefined') {
      toReturn['defaultBillingStrategy'] = this.defaultBillingStrategy;
    }
    return toReturn;
  }
}
class UpdatePricingPlanResponse {
  static fromProto(proto) {
    let m = new UpdatePricingPlanResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
function enumStringToValue$E(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ProductPrices {
  static fromProto(proto) {
    let m = new ProductPrices();
    m = Object.assign(m, proto);
    if (proto.prices) {
      m.prices = proto.prices.map(ProductPricing.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.prices !== 'undefined' && this.prices !== null) {
      toReturn['prices'] = 'toApiJson' in this.prices ? this.prices.toApiJson() : this.prices;
    }
    return toReturn;
  }
}
class ProductPricing {
  static fromProto(proto) {
    let m = new ProductPricing();
    m = Object.assign(m, proto);
    if (proto.strategy) {
      m.strategy = enumStringToValue$E(BillingStrategy, proto.strategy);
    }
    if (proto.pricingType) {
      m.pricingType = enumStringToValue$E(ProductPricingType, proto.pricingType);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$E(Currency, proto.currency);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$E(Frequency, proto.frequency);
    }
    if (proto.pricingRules) {
      m.pricingRules = proto.pricingRules.map(ProductPricingRule.fromProto);
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    if (proto.volumeCommitment) {
      m.volumeCommitment = parseInt(proto.volumeCommitment, 10);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    if (proto.fees) {
      m.fees = proto.fees.map(Fee.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.strategy !== 'undefined') {
      toReturn['strategy'] = this.strategy;
    }
    if (typeof this.pricingType !== 'undefined') {
      toReturn['pricingType'] = this.pricingType;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.pricingRules !== 'undefined' && this.pricingRules !== null) {
      toReturn['pricingRules'] = 'toApiJson' in this.pricingRules ? this.pricingRules.toApiJson() : this.pricingRules;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.isStartingPrice !== 'undefined') {
      toReturn['isStartingPrice'] = this.isStartingPrice;
    }
    if (typeof this.resolvedFrom !== 'undefined') {
      toReturn['resolvedFrom'] = this.resolvedFrom;
    }
    if (typeof this.volumeCommitment !== 'undefined') {
      toReturn['volumeCommitment'] = this.volumeCommitment;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.fees !== 'undefined' && this.fees !== null) {
      toReturn['fees'] = 'toApiJson' in this.fees ? this.fees.toApiJson() : this.fees;
    }
    return toReturn;
  }
}
class WholesaleCostItemRequest {
  static fromProto(proto) {
    let m = new WholesaleCostItemRequest();
    m = Object.assign(m, proto);
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$E(Frequency, proto.frequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    return toReturn;
  }
}
function enumStringToValue$D(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class SubscribeValidation {
  static fromProto(proto) {
    let m = new SubscribeValidation();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$D(SubscribeValidationStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
function enumStringToValue$C(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AlignmentSubscription {
  static fromProto(proto) {
    let m = new AlignmentSubscription();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class CanCreateSubscriptionsRequest {
  static fromProto(proto) {
    let m = new CanCreateSubscriptionsRequest();
    m = Object.assign(m, proto);
    if (proto.skus) {
      m.skus = Object.keys(proto.skus).reduce((obj, k) => {
        obj[k] = parseInt(proto.skus[k], 10);
        return obj;
      }, {});
    }
    if (proto.items) {
      m.items = proto.items.map(CanCreateSubscriptionsRequestSubscriptionItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.skus !== 'undefined' && this.skus !== null) {
      toReturn['skus'] = 'toApiJson' in this.skus ? this.skus.toApiJson() : this.skus;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    return toReturn;
  }
}
class CanCreateSubscriptionsResponse {
  static fromProto(proto) {
    let m = new CanCreateSubscriptionsResponse();
    m = Object.assign(m, proto);
    if (proto.validationResponse) {
      m.validationResponse = proto.validationResponse.map(ValidateResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.validationResponse !== 'undefined' && this.validationResponse !== null) {
      toReturn['validationResponse'] = 'toApiJson' in this.validationResponse ? this.validationResponse.toApiJson() : this.validationResponse;
    }
    return toReturn;
  }
}
class ChangeCustomUnitPriceRequest {
  static fromProto(proto) {
    let m = new ChangeCustomUnitPriceRequest();
    m = Object.assign(m, proto);
    if (proto.customUnitPrice) {
      m.customUnitPrice = parseInt(proto.customUnitPrice, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.customUnitPrice !== 'undefined') {
      toReturn['customUnitPrice'] = this.customUnitPrice;
    }
    return toReturn;
  }
}
class ChangeFrequencyRequest {
  static fromProto(proto) {
    let m = new ChangeFrequencyRequest();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$C(Frequency, proto.frequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    return toReturn;
  }
}
class ChangeRenewalDateRequest {
  static fromProto(proto) {
    let m = new ChangeRenewalDateRequest();
    m = Object.assign(m, proto);
    if (proto.nextRenewalDate) {
      m.nextRenewalDate = new Date(proto.nextRenewalDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.nextRenewalDate !== 'undefined' && this.nextRenewalDate !== null) {
      toReturn['nextRenewalDate'] = 'toApiJson' in this.nextRenewalDate ? this.nextRenewalDate.toApiJson() : this.nextRenewalDate;
    }
    return toReturn;
  }
}
class CreateSubscriptionRequest {
  static fromProto(proto) {
    let m = new CreateSubscriptionRequest();
    m = Object.assign(m, proto);
    if (proto.billingStart) {
      m.billingStart = new Date(proto.billingStart);
    }
    if (proto.proratedTo) {
      m.proratedTo = new Date(proto.proratedTo);
    }
    if (proto.renewalState) {
      m.renewalState = enumStringToValue$C(RenewalState, proto.renewalState);
    }
    if (proto.customUnitPrice) {
      m.customUnitPrice = parseInt(proto.customUnitPrice, 10);
    }
    if (proto.alignWith) {
      m.alignWith = AlignmentSubscription.fromProto(proto.alignWith);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$C(Frequency, proto.frequency);
    }
    if (proto.retailAmount) {
      m.retailAmount = parseInt(proto.retailAmount, 10);
    }
    if (proto.retailFrequency) {
      m.retailFrequency = enumStringToValue$C(Frequency, proto.retailFrequency);
    }
    if (proto.consumer) {
      m.consumer = enumStringToValue$C(Consumer, proto.consumer);
    }
    if (proto.renewalStart) {
      m.renewalStart = new Date(proto.renewalStart);
    }
    if (proto.expiry) {
      m.expiry = new Date(proto.expiry);
    }
    if (proto.billingCycleAnchor) {
      m.billingCycleAnchor = new Date(proto.billingCycleAnchor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.billingStart !== 'undefined' && this.billingStart !== null) {
      toReturn['billingStart'] = 'toApiJson' in this.billingStart ? this.billingStart.toApiJson() : this.billingStart;
    }
    if (typeof this.proratedTo !== 'undefined' && this.proratedTo !== null) {
      toReturn['proratedTo'] = 'toApiJson' in this.proratedTo ? this.proratedTo.toApiJson() : this.proratedTo;
    }
    if (typeof this.renewalState !== 'undefined') {
      toReturn['renewalState'] = this.renewalState;
    }
    if (typeof this.retailBundleId !== 'undefined') {
      toReturn['retailBundleId'] = this.retailBundleId;
    }
    if (typeof this.forResale !== 'undefined') {
      toReturn['forResale'] = this.forResale;
    }
    if (typeof this.customUnitPrice !== 'undefined') {
      toReturn['customUnitPrice'] = this.customUnitPrice;
    }
    if (typeof this.alignWith !== 'undefined' && this.alignWith !== null) {
      toReturn['alignWith'] = 'toApiJson' in this.alignWith ? this.alignWith.toApiJson() : this.alignWith;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.retailAmount !== 'undefined') {
      toReturn['retailAmount'] = this.retailAmount;
    }
    if (typeof this.retailFrequency !== 'undefined') {
      toReturn['retailFrequency'] = this.retailFrequency;
    }
    if (typeof this.consumer !== 'undefined') {
      toReturn['consumer'] = this.consumer;
    }
    if (typeof this.renewalStart !== 'undefined' && this.renewalStart !== null) {
      toReturn['renewalStart'] = 'toApiJson' in this.renewalStart ? this.renewalStart.toApiJson() : this.renewalStart;
    }
    if (typeof this.expiry !== 'undefined' && this.expiry !== null) {
      toReturn['expiry'] = 'toApiJson' in this.expiry ? this.expiry.toApiJson() : this.expiry;
    }
    if (typeof this.autoBillable !== 'undefined') {
      toReturn['autoBillable'] = this.autoBillable;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.billingCycleAnchor !== 'undefined' && this.billingCycleAnchor !== null) {
      toReturn['billingCycleAnchor'] = 'toApiJson' in this.billingCycleAnchor ? this.billingCycleAnchor.toApiJson() : this.billingCycleAnchor;
    }
    return toReturn;
  }
}
class CreateSubscriptionResponse {
  static fromProto(proto) {
    let m = new CreateSubscriptionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    return toReturn;
  }
}
class CreateSubscriptionsRequest {
  static fromProto(proto) {
    let m = new CreateSubscriptionsRequest();
    m = Object.assign(m, proto);
    if (proto.subscriptions) {
      m.subscriptions = proto.subscriptions.map(Subscription.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.subscriptions !== 'undefined' && this.subscriptions !== null) {
      toReturn['subscriptions'] = 'toApiJson' in this.subscriptions ? this.subscriptions.toApiJson() : this.subscriptions;
    }
    return toReturn;
  }
}
class CreateSubscriptionsResponse {
  static fromProto(proto) {
    let m = new CreateSubscriptionsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ReverseSubscriptionRequest {
  static fromProto(proto) {
    let m = new ReverseSubscriptionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class SetAutoBillableRequest {
  static fromProto(proto) {
    let m = new SetAutoBillableRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.autoBillable !== 'undefined') {
      toReturn['autoBillable'] = this.autoBillable;
    }
    return toReturn;
  }
}
class SetRenewalStartRequest {
  static fromProto(proto) {
    let m = new SetRenewalStartRequest();
    m = Object.assign(m, proto);
    if (proto.renewalStart) {
      m.renewalStart = new Date(proto.renewalStart);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.renewalStart !== 'undefined' && this.renewalStart !== null) {
      toReturn['renewalStart'] = 'toApiJson' in this.renewalStart ? this.renewalStart.toApiJson() : this.renewalStart;
    }
    return toReturn;
  }
}
class CanCreateSubscriptionsRequestSkusEntry {
  static fromProto(proto) {
    let m = new CanCreateSubscriptionsRequestSkusEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class Subscription {
  static fromProto(proto) {
    let m = new Subscription();
    m = Object.assign(m, proto);
    if (proto.billingStart) {
      m.billingStart = new Date(proto.billingStart);
    }
    if (proto.renewalState) {
      m.renewalState = enumStringToValue$C(RenewalState, proto.renewalState);
    }
    if (proto.proratedTo) {
      m.proratedTo = new Date(proto.proratedTo);
    }
    if (proto.customUnitPrice) {
      m.customUnitPrice = parseInt(proto.customUnitPrice, 10);
    }
    if (proto.alignWith) {
      m.alignWith = AlignmentSubscription.fromProto(proto.alignWith);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$C(Frequency, proto.frequency);
    }
    if (proto.retailAmount) {
      m.retailAmount = parseInt(proto.retailAmount, 10);
    }
    if (proto.retailFrequency) {
      m.retailFrequency = enumStringToValue$C(Frequency, proto.retailFrequency);
    }
    if (proto.consumer) {
      m.consumer = enumStringToValue$C(Consumer, proto.consumer);
    }
    if (proto.renewalStart) {
      m.renewalStart = new Date(proto.renewalStart);
    }
    if (proto.expiry) {
      m.expiry = new Date(proto.expiry);
    }
    if (proto.billingCycleAnchor) {
      m.billingCycleAnchor = new Date(proto.billingCycleAnchor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.billingStart !== 'undefined' && this.billingStart !== null) {
      toReturn['billingStart'] = 'toApiJson' in this.billingStart ? this.billingStart.toApiJson() : this.billingStart;
    }
    if (typeof this.renewalState !== 'undefined') {
      toReturn['renewalState'] = this.renewalState;
    }
    if (typeof this.proratedTo !== 'undefined' && this.proratedTo !== null) {
      toReturn['proratedTo'] = 'toApiJson' in this.proratedTo ? this.proratedTo.toApiJson() : this.proratedTo;
    }
    if (typeof this.retailBundleId !== 'undefined') {
      toReturn['retailBundleId'] = this.retailBundleId;
    }
    if (typeof this.forResale !== 'undefined') {
      toReturn['forResale'] = this.forResale;
    }
    if (typeof this.customUnitPrice !== 'undefined') {
      toReturn['customUnitPrice'] = this.customUnitPrice;
    }
    if (typeof this.alignWith !== 'undefined' && this.alignWith !== null) {
      toReturn['alignWith'] = 'toApiJson' in this.alignWith ? this.alignWith.toApiJson() : this.alignWith;
    }
    if (typeof this.bundleInstanceId !== 'undefined') {
      toReturn['bundleInstanceId'] = this.bundleInstanceId;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.retailAmount !== 'undefined') {
      toReturn['retailAmount'] = this.retailAmount;
    }
    if (typeof this.retailFrequency !== 'undefined') {
      toReturn['retailFrequency'] = this.retailFrequency;
    }
    if (typeof this.consumer !== 'undefined') {
      toReturn['consumer'] = this.consumer;
    }
    if (typeof this.renewalStart !== 'undefined' && this.renewalStart !== null) {
      toReturn['renewalStart'] = 'toApiJson' in this.renewalStart ? this.renewalStart.toApiJson() : this.renewalStart;
    }
    if (typeof this.expiry !== 'undefined' && this.expiry !== null) {
      toReturn['expiry'] = 'toApiJson' in this.expiry ? this.expiry.toApiJson() : this.expiry;
    }
    if (typeof this.autoBillable !== 'undefined') {
      toReturn['autoBillable'] = this.autoBillable;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.billingCycleAnchor !== 'undefined' && this.billingCycleAnchor !== null) {
      toReturn['billingCycleAnchor'] = 'toApiJson' in this.billingCycleAnchor ? this.billingCycleAnchor.toApiJson() : this.billingCycleAnchor;
    }
    return toReturn;
  }
}
class CanCreateSubscriptionsRequestSubscriptionItem {
  static fromProto(proto) {
    let m = new CanCreateSubscriptionsRequestSubscriptionItem();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$C(Frequency, proto.frequency);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
class ValidateResponse {
  static fromProto(proto) {
    let m = new ValidateResponse();
    m = Object.assign(m, proto);
    if (proto.code) {
      m.code = SubscribeValidation.fromProto(proto.code);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.code !== 'undefined' && this.code !== null) {
      toReturn['code'] = 'toApiJson' in this.code ? this.code.toApiJson() : this.code;
    }
    return toReturn;
  }
}
function enumStringToValue$B(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BillItemRequest {
  static fromProto(proto) {
    let m = new BillItemRequest();
    m = Object.assign(m, proto);
    if (proto.billingStart) {
      m.billingStart = new Date(proto.billingStart);
    }
    if (proto.proratedTo) {
      m.proratedTo = new Date(proto.proratedTo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.billingStart !== 'undefined' && this.billingStart !== null) {
      toReturn['billingStart'] = 'toApiJson' in this.billingStart ? this.billingStart.toApiJson() : this.billingStart;
    }
    if (typeof this.proratedTo !== 'undefined' && this.proratedTo !== null) {
      toReturn['proratedTo'] = 'toApiJson' in this.proratedTo ? this.proratedTo.toApiJson() : this.proratedTo;
    }
    return toReturn;
  }
}
class BillMultipleItemsRequest {
  static fromProto(proto) {
    let m = new BillMultipleItemsRequest();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(Item.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    return toReturn;
  }
}
class BillMultipleItemsResponse {
  static fromProto(proto) {
    let m = new BillMultipleItemsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class BillableItem {
  static fromProto(proto) {
    let m = new BillableItem();
    m = Object.assign(m, proto);
    if (proto.expiry) {
      m.expiry = new Date(proto.expiry);
    }
    if (proto.billingStart) {
      m.billingStart = new Date(proto.billingStart);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$B(Frequency, proto.frequency);
    }
    if (proto.nextRenewal) {
      m.nextRenewal = new Date(proto.nextRenewal);
    }
    if (proto.customerAddress) {
      m.customerAddress = BillableItemCustomerAddress.fromProto(proto.customerAddress);
    }
    if (proto.customUnitPrice) {
      m.customUnitPrice = parseInt(proto.customUnitPrice, 10);
    }
    if (proto.retailFrequency) {
      m.retailFrequency = enumStringToValue$B(Frequency, proto.retailFrequency);
    }
    if (proto.nextRetailRenewal) {
      m.nextRetailRenewal = new Date(proto.nextRetailRenewal);
    }
    if (proto.retailUnitPrice) {
      m.retailUnitPrice = parseInt(proto.retailUnitPrice, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue$B(SubscriptionStatus, proto.status);
    }
    if (proto.price) {
      m.price = ProductPricing.fromProto(proto.price);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.source) {
      m.source = enumStringToValue$B(Source, proto.source);
    }
    if (proto.consumer) {
      m.consumer = enumStringToValue$B(Consumer, proto.consumer);
    }
    if (proto.billingCycleAnchor) {
      m.billingCycleAnchor = new Date(proto.billingCycleAnchor);
    }
    if (proto.nextServicePeriodStart) {
      m.nextServicePeriodStart = new Date(proto.nextServicePeriodStart);
    }
    if (proto.nextServicePeriodEnd) {
      m.nextServicePeriodEnd = new Date(proto.nextServicePeriodEnd);
    }
    if (proto.nextInvoiceDate) {
      m.nextInvoiceDate = new Date(proto.nextInvoiceDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.expiry !== 'undefined' && this.expiry !== null) {
      toReturn['expiry'] = 'toApiJson' in this.expiry ? this.expiry.toApiJson() : this.expiry;
    }
    if (typeof this.billingStart !== 'undefined' && this.billingStart !== null) {
      toReturn['billingStart'] = 'toApiJson' in this.billingStart ? this.billingStart.toApiJson() : this.billingStart;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.nextRenewal !== 'undefined' && this.nextRenewal !== null) {
      toReturn['nextRenewal'] = 'toApiJson' in this.nextRenewal ? this.nextRenewal.toApiJson() : this.nextRenewal;
    }
    if (typeof this.customerName !== 'undefined') {
      toReturn['customerName'] = this.customerName;
    }
    if (typeof this.productName !== 'undefined') {
      toReturn['productName'] = this.productName;
    }
    if (typeof this.customerAddress !== 'undefined' && this.customerAddress !== null) {
      toReturn['customerAddress'] = 'toApiJson' in this.customerAddress ? this.customerAddress.toApiJson() : this.customerAddress;
    }
    if (typeof this.customUnitPrice !== 'undefined') {
      toReturn['customUnitPrice'] = this.customUnitPrice;
    }
    if (typeof this.retailFrequency !== 'undefined') {
      toReturn['retailFrequency'] = this.retailFrequency;
    }
    if (typeof this.nextRetailRenewal !== 'undefined' && this.nextRetailRenewal !== null) {
      toReturn['nextRetailRenewal'] = 'toApiJson' in this.nextRetailRenewal ? this.nextRetailRenewal.toApiJson() : this.nextRetailRenewal;
    }
    if (typeof this.retailUnitPrice !== 'undefined') {
      toReturn['retailUnitPrice'] = this.retailUnitPrice;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.price !== 'undefined' && this.price !== null) {
      toReturn['price'] = 'toApiJson' in this.price ? this.price.toApiJson() : this.price;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.autoBillable !== 'undefined') {
      toReturn['autoBillable'] = this.autoBillable;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.consumer !== 'undefined') {
      toReturn['consumer'] = this.consumer;
    }
    if (typeof this.billingCycleAnchor !== 'undefined' && this.billingCycleAnchor !== null) {
      toReturn['billingCycleAnchor'] = 'toApiJson' in this.billingCycleAnchor ? this.billingCycleAnchor.toApiJson() : this.billingCycleAnchor;
    }
    if (typeof this.nextServicePeriodStart !== 'undefined' && this.nextServicePeriodStart !== null) {
      toReturn['nextServicePeriodStart'] = 'toApiJson' in this.nextServicePeriodStart ? this.nextServicePeriodStart.toApiJson() : this.nextServicePeriodStart;
    }
    if (typeof this.nextServicePeriodEnd !== 'undefined' && this.nextServicePeriodEnd !== null) {
      toReturn['nextServicePeriodEnd'] = 'toApiJson' in this.nextServicePeriodEnd ? this.nextServicePeriodEnd.toApiJson() : this.nextServicePeriodEnd;
    }
    if (typeof this.nextInvoiceDate !== 'undefined' && this.nextInvoiceDate !== null) {
      toReturn['nextInvoiceDate'] = 'toApiJson' in this.nextInvoiceDate ? this.nextInvoiceDate.toApiJson() : this.nextInvoiceDate;
    }
    return toReturn;
  }
}
class CanBillItemRequest {
  static fromProto(proto) {
    let m = new CanBillItemRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    return toReturn;
  }
}
class CreateUsageRequest {
  static fromProto(proto) {
    let m = new CreateUsageRequest();
    m = Object.assign(m, proto);
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    if (proto.usageDate) {
      m.usageDate = new Date(proto.usageDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.usageDate !== 'undefined' && this.usageDate !== null) {
      toReturn['usageDate'] = 'toApiJson' in this.usageDate ? this.usageDate.toApiJson() : this.usageDate;
    }
    return toReturn;
  }
}
class BillableItemCustomerAddress {
  static fromProto(proto) {
    let m = new BillableItemCustomerAddress();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    return toReturn;
  }
}
class DeleteBillableItemRequest {
  static fromProto(proto) {
    let m = new DeleteBillableItemRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class ExpireBillableItemRequest {
  static fromProto(proto) {
    let m = new ExpireBillableItemRequest();
    m = Object.assign(m, proto);
    if (proto.expiry) {
      m.expiry = new Date(proto.expiry);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.expiry !== 'undefined' && this.expiry !== null) {
      toReturn['expiry'] = 'toApiJson' in this.expiry ? this.expiry.toApiJson() : this.expiry;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    return toReturn;
  }
}
class ExportSubscriptionsRequest {
  static fromProto(proto) {
    let m = new ExportSubscriptionsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSubscriptionsRequestFilters.fromProto(proto.filters);
    }
    if (proto.consumer) {
      m.consumer = enumStringToValue$B(Consumer, proto.consumer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.consumer !== 'undefined') {
      toReturn['consumer'] = this.consumer;
    }
    return toReturn;
  }
}
class ListSubscriptionsRequestFilters {
  static fromProto(proto) {
    let m = new ListSubscriptionsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$B(SubscriptionStatus, proto.status);
    }
    if (proto.expiredDateGte) {
      m.expiredDateGte = new Date(proto.expiredDateGte);
    }
    if (proto.expiredDateLte) {
      m.expiredDateLte = new Date(proto.expiredDateLte);
    }
    if (proto.frequencies) {
      m.frequencies = proto.frequencies.map(v => enumStringToValue$B(Frequency, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.skus !== 'undefined') {
      toReturn['skus'] = this.skus;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.expiredDateGte !== 'undefined' && this.expiredDateGte !== null) {
      toReturn['expiredDateGte'] = 'toApiJson' in this.expiredDateGte ? this.expiredDateGte.toApiJson() : this.expiredDateGte;
    }
    if (typeof this.expiredDateLte !== 'undefined' && this.expiredDateLte !== null) {
      toReturn['expiredDateLte'] = 'toApiJson' in this.expiredDateLte ? this.expiredDateLte.toApiJson() : this.expiredDateLte;
    }
    if (typeof this.frequencies !== 'undefined') {
      toReturn['frequencies'] = this.frequencies;
    }
    return toReturn;
  }
}
class ListBillableItemsRequestFilters {
  static fromProto(proto) {
    let m = new ListBillableItemsRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.skus !== 'undefined') {
      toReturn['skus'] = this.skus;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class GetBillableItemRequest {
  static fromProto(proto) {
    let m = new GetBillableItemRequest();
    m = Object.assign(m, proto);
    if (proto.projectionFilter) {
      m.projectionFilter = SubscriptionProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class GetBillableItemResponse {
  static fromProto(proto) {
    let m = new GetBillableItemResponse();
    m = Object.assign(m, proto);
    if (proto.item) {
      m.item = BillableItem.fromProto(proto.item);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.item !== 'undefined' && this.item !== null) {
      toReturn['item'] = 'toApiJson' in this.item ? this.item.toApiJson() : this.item;
    }
    return toReturn;
  }
}
class GetMultiSubscriptionsRequest {
  static fromProto(proto) {
    let m = new GetMultiSubscriptionsRequest();
    m = Object.assign(m, proto);
    if (proto.subscriptionKeys) {
      m.subscriptionKeys = proto.subscriptionKeys.map(GetMultiSubscriptionsRequestKey.fromProto);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = SubscriptionProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionKeys !== 'undefined' && this.subscriptionKeys !== null) {
      toReturn['subscriptionKeys'] = 'toApiJson' in this.subscriptionKeys ? this.subscriptionKeys.toApiJson() : this.subscriptionKeys;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    if (typeof this.subscriptionIds !== 'undefined') {
      toReturn['subscriptionIds'] = this.subscriptionIds;
    }
    return toReturn;
  }
}
class GetMultiSubscriptionsResponse {
  static fromProto(proto) {
    let m = new GetMultiSubscriptionsResponse();
    m = Object.assign(m, proto);
    if (proto.subscriptions) {
      m.subscriptions = proto.subscriptions.map(BillableItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptions !== 'undefined' && this.subscriptions !== null) {
      toReturn['subscriptions'] = 'toApiJson' in this.subscriptions ? this.subscriptions.toApiJson() : this.subscriptions;
    }
    return toReturn;
  }
}
class Item {
  static fromProto(proto) {
    let m = new Item();
    m = Object.assign(m, proto);
    if (proto.billingStart) {
      m.billingStart = new Date(proto.billingStart);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.billingStart !== 'undefined' && this.billingStart !== null) {
      toReturn['billingStart'] = 'toApiJson' in this.billingStart ? this.billingStart.toApiJson() : this.billingStart;
    }
    return toReturn;
  }
}
class GetMultiSubscriptionsRequestKey {
  static fromProto(proto) {
    let m = new GetMultiSubscriptionsRequestKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class ListBillableItemsRequest {
  static fromProto(proto) {
    let m = new ListBillableItemsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListBillableItemsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListBillableItemsResponse {
  static fromProto(proto) {
    let m = new ListBillableItemsResponse();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(BillableItem.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListSubscriptionsRequest {
  static fromProto(proto) {
    let m = new ListSubscriptionsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSubscriptionsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.projectionFilter) {
      m.projectionFilter = SubscriptionProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class ListSubscriptionsResponse {
  static fromProto(proto) {
    let m = new ListSubscriptionsResponse();
    m = Object.assign(m, proto);
    if (proto.subscriptions) {
      m.subscriptions = proto.subscriptions.map(BillableItem.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptions !== 'undefined' && this.subscriptions !== null) {
      toReturn['subscriptions'] = 'toApiJson' in this.subscriptions ? this.subscriptions.toApiJson() : this.subscriptions;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UpdateSubscriptionRequestSubscription {
  static fromProto(proto) {
    let m = new UpdateSubscriptionRequestSubscription();
    m = Object.assign(m, proto);
    if (proto.billingCycleAnchor) {
      m.billingCycleAnchor = new Date(proto.billingCycleAnchor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.billingCycleAnchor !== 'undefined' && this.billingCycleAnchor !== null) {
      toReturn['billingCycleAnchor'] = 'toApiJson' in this.billingCycleAnchor ? this.billingCycleAnchor.toApiJson() : this.billingCycleAnchor;
    }
    return toReturn;
  }
}
class SubscriptionProjectionFilter {
  static fromProto(proto) {
    let m = new SubscriptionProjectionFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.includeDeleted !== 'undefined') {
      toReturn['includeDeleted'] = this.includeDeleted;
    }
    return toReturn;
  }
}
class UnexpireBillableItemRequest {
  static fromProto(proto) {
    let m = new UnexpireBillableItemRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    return toReturn;
  }
}
class UpdateSubscriptionRequest {
  static fromProto(proto) {
    let m = new UpdateSubscriptionRequest();
    m = Object.assign(m, proto);
    if (proto.subscription) {
      m.subscription = UpdateSubscriptionRequestSubscription.fromProto(proto.subscription);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscription !== 'undefined' && this.subscription !== null) {
      toReturn['subscription'] = 'toApiJson' in this.subscription ? this.subscription.toApiJson() : this.subscription;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateSubscriptionResponse {
  static fromProto(proto) {
    let m = new UpdateSubscriptionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
function enumStringToValue$A(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppliedDiscount {
  static fromProto(proto) {
    let m = new AppliedDiscount();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$A(DiscountType, proto.type);
    }
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    if (proto.totalAmount) {
      m.totalAmount = parseInt(proto.totalAmount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.totalAmount !== 'undefined') {
      toReturn['totalAmount'] = this.totalAmount;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.referenceId !== 'undefined') {
      toReturn['referenceId'] = this.referenceId;
    }
    return toReturn;
  }
}
function enumStringToValue$z(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Bundle {
  static fromProto(proto) {
    let m = new Bundle();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(BundleItem.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.bundleId !== 'undefined') {
      toReturn['bundleId'] = this.bundleId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.hideBundleDetails !== 'undefined') {
      toReturn['hideBundleDetails'] = this.hideBundleDetails;
    }
    return toReturn;
  }
}
class BundleItem {
  static fromProto(proto) {
    let m = new BundleItem();
    m = Object.assign(m, proto);
    if (proto.discountType) {
      m.discountType = enumStringToValue$z(DiscountType, proto.discountType);
    }
    if (proto.discountAmount) {
      m.discountAmount = parseInt(proto.discountAmount, 10);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    if (proto.price) {
      m.price = BundleItemPrice.fromProto(proto.price);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.discountType !== 'undefined') {
      toReturn['discountType'] = this.discountType;
    }
    if (typeof this.discountAmount !== 'undefined') {
      toReturn['discountAmount'] = this.discountAmount;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.defaultSku !== 'undefined') {
      toReturn['defaultSku'] = this.defaultSku;
    }
    if (typeof this.price !== 'undefined' && this.price !== null) {
      toReturn['price'] = 'toApiJson' in this.price ? this.price.toApiJson() : this.price;
    }
    return toReturn;
  }
}
class BundlePricing {
  static fromProto(proto) {
    let m = new BundlePricing();
    m = Object.assign(m, proto);
    if (proto.prices) {
      m.prices = proto.prices.map(BundlePricingPriceAndFrequency.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bundleId !== 'undefined') {
      toReturn['bundleId'] = this.bundleId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.prices !== 'undefined' && this.prices !== null) {
      toReturn['prices'] = 'toApiJson' in this.prices ? this.prices.toApiJson() : this.prices;
    }
    return toReturn;
  }
}
class GetMultiBundleResponseBundlesEntry {
  static fromProto(proto) {
    let m = new GetMultiBundleResponseBundlesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = Bundle.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class ListBundlesRequestFilters {
  static fromProto(proto) {
    let m = new ListBundlesRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetMultiBundleRequest {
  static fromProto(proto) {
    let m = new GetMultiBundleRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.bundleIds !== 'undefined') {
      toReturn['bundleIds'] = this.bundleIds;
    }
    return toReturn;
  }
}
class GetMultiBundleResponse {
  static fromProto(proto) {
    let m = new GetMultiBundleResponse();
    m = Object.assign(m, proto);
    if (proto.bundles) {
      m.bundles = Object.keys(proto.bundles).reduce((obj, k) => {
        obj[k] = Bundle.fromProto(proto.bundles[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bundles !== 'undefined' && this.bundles !== null) {
      toReturn['bundles'] = 'toApiJson' in this.bundles ? this.bundles.toApiJson() : this.bundles;
    }
    return toReturn;
  }
}
class ListBundlesRequest {
  static fromProto(proto) {
    let m = new ListBundlesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListBundlesRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListBundlesResponse {
  static fromProto(proto) {
    let m = new ListBundlesResponse();
    m = Object.assign(m, proto);
    if (proto.bundles) {
      m.bundles = proto.bundles.map(Bundle.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bundles !== 'undefined' && this.bundles !== null) {
      toReturn['bundles'] = 'toApiJson' in this.bundles ? this.bundles.toApiJson() : this.bundles;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class BundleItemPrice {
  static fromProto(proto) {
    let m = new BundleItemPrice();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    return toReturn;
  }
}
class BundlePricingPriceAndFrequency {
  static fromProto(proto) {
    let m = new BundlePricingPriceAndFrequency();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$z(Frequency, proto.frequency);
    }
    if (proto.effectivePrice) {
      m.effectivePrice = parseInt(proto.effectivePrice, 10);
    }
    if (proto.initialPrice) {
      m.initialPrice = parseInt(proto.initialPrice, 10);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.effectivePrice !== 'undefined') {
      toReturn['effectivePrice'] = this.effectivePrice;
    }
    if (typeof this.initialPrice !== 'undefined') {
      toReturn['initialPrice'] = this.initialPrice;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    return toReturn;
  }
}
class UpsertBundleRequest {
  static fromProto(proto) {
    let m = new UpsertBundleRequest();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(BundleItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.bundleId !== 'undefined') {
      toReturn['bundleId'] = this.bundleId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.hideBundleDetails !== 'undefined') {
      toReturn['hideBundleDetails'] = this.hideBundleDetails;
    }
    return toReturn;
  }
}
function enumStringToValue$y(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Contract {
  static fromProto(proto) {
    let m = new Contract();
    m = Object.assign(m, proto);
    if (proto.netD) {
      m.netD = parseInt(proto.netD, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$y(Currency, proto.currency);
    }
    if (proto.signed) {
      m.signed = new Date(proto.signed);
    }
    if (proto.activated) {
      m.activated = new Date(proto.activated);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.verified) {
      m.verified = new Date(proto.verified);
    }
    if (proto.creditLimit) {
      m.creditLimit = parseInt(proto.creditLimit, 10);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.subscriptionUpdateStatus) {
      m.subscriptionUpdateStatus = enumStringToValue$y(ContractSubscriptionStatus, proto.subscriptionUpdateStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.netD !== 'undefined') {
      toReturn['netD'] = this.netD;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.signed !== 'undefined' && this.signed !== null) {
      toReturn['signed'] = 'toApiJson' in this.signed ? this.signed.toApiJson() : this.signed;
    }
    if (typeof this.activated !== 'undefined' && this.activated !== null) {
      toReturn['activated'] = 'toApiJson' in this.activated ? this.activated.toApiJson() : this.activated;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.verified !== 'undefined' && this.verified !== null) {
      toReturn['verified'] = 'toApiJson' in this.verified ? this.verified.toApiJson() : this.verified;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.creditLimit !== 'undefined') {
      toReturn['creditLimit'] = this.creditLimit;
    }
    if (typeof this.dimension !== 'undefined') {
      toReturn['dimension'] = this.dimension;
    }
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.subscriptionUpdateStatus !== 'undefined') {
      toReturn['subscriptionUpdateStatus'] = this.subscriptionUpdateStatus;
    }
    return toReturn;
  }
}
class GetMultiContractsResponseContractsEntry {
  static fromProto(proto) {
    let m = new GetMultiContractsResponseContractsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = Contract.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class CreateContractRequest {
  static fromProto(proto) {
    let m = new CreateContractRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    return toReturn;
  }
}
class CreateContractResponse {
  static fromProto(proto) {
    let m = new CreateContractResponse();
    m = Object.assign(m, proto);
    if (proto.contract) {
      m.contract = Contract.fromProto(proto.contract);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contract !== 'undefined' && this.contract !== null) {
      toReturn['contract'] = 'toApiJson' in this.contract ? this.contract.toApiJson() : this.contract;
    }
    return toReturn;
  }
}
class GetContractRequest {
  static fromProto(proto) {
    let m = new GetContractRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetContractResponse {
  static fromProto(proto) {
    let m = new GetContractResponse();
    m = Object.assign(m, proto);
    if (proto.contract) {
      m.contract = Contract.fromProto(proto.contract);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contract !== 'undefined' && this.contract !== null) {
      toReturn['contract'] = 'toApiJson' in this.contract ? this.contract.toApiJson() : this.contract;
    }
    return toReturn;
  }
}
class GetMerchantWholesaleCurrencyRequest {
  static fromProto(proto) {
    let m = new GetMerchantWholesaleCurrencyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetMerchantWholesaleCurrencyResponse {
  static fromProto(proto) {
    let m = new GetMerchantWholesaleCurrencyResponse();
    m = Object.assign(m, proto);
    if (proto.currency) {
      m.currency = enumStringToValue$y(Currency, proto.currency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    return toReturn;
  }
}
class GetMultiContractsRequest {
  static fromProto(proto) {
    let m = new GetMultiContractsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantIds !== 'undefined') {
      toReturn['merchantIds'] = this.merchantIds;
    }
    return toReturn;
  }
}
class GetMultiContractsResponse {
  static fromProto(proto) {
    let m = new GetMultiContractsResponse();
    m = Object.assign(m, proto);
    if (proto.contracts) {
      m.contracts = Object.keys(proto.contracts).reduce((obj, k) => {
        obj[k] = Contract.fromProto(proto.contracts[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contracts !== 'undefined' && this.contracts !== null) {
      toReturn['contracts'] = 'toApiJson' in this.contracts ? this.contracts.toApiJson() : this.contracts;
    }
    return toReturn;
  }
}
class ListContractsRequest {
  static fromProto(proto) {
    let m = new ListContractsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListContractsResponse {
  static fromProto(proto) {
    let m = new ListContractsResponse();
    m = Object.assign(m, proto);
    if (proto.contracts) {
      m.contracts = proto.contracts.map(Contract.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contracts !== 'undefined' && this.contracts !== null) {
      toReturn['contracts'] = 'toApiJson' in this.contracts ? this.contracts.toApiJson() : this.contracts;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UpdateContractRequestMutation {
  static fromProto(proto) {
    let m = new UpdateContractRequestMutation();
    m = Object.assign(m, proto);
    if (proto.netD) {
      m.netD = parseInt(proto.netD, 10);
    }
    if (proto.signed) {
      m.signed = new Date(proto.signed);
    }
    if (proto.activated) {
      m.activated = new Date(proto.activated);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.creditLimit) {
      m.creditLimit = parseInt(proto.creditLimit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.netD !== 'undefined') {
      toReturn['netD'] = this.netD;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dimension !== 'undefined') {
      toReturn['dimension'] = this.dimension;
    }
    if (typeof this.signed !== 'undefined' && this.signed !== null) {
      toReturn['signed'] = 'toApiJson' in this.signed ? this.signed.toApiJson() : this.signed;
    }
    if (typeof this.activated !== 'undefined' && this.activated !== null) {
      toReturn['activated'] = 'toApiJson' in this.activated ? this.activated.toApiJson() : this.activated;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.creditLimit !== 'undefined') {
      toReturn['creditLimit'] = this.creditLimit;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    return toReturn;
  }
}
class ResetContractPricingRequest {
  static fromProto(proto) {
    let m = new ResetContractPricingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class UpdateContractRequest {
  static fromProto(proto) {
    let m = new UpdateContractRequest();
    m = Object.assign(m, proto);
    if (proto.mutations) {
      m.mutations = proto.mutations.map(UpdateContractRequestMutation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.mutations !== 'undefined' && this.mutations !== null) {
      toReturn['mutations'] = 'toApiJson' in this.mutations ? this.mutations.toApiJson() : this.mutations;
    }
    if (typeof this.performedBy !== 'undefined') {
      toReturn['performedBy'] = this.performedBy;
    }
    return toReturn;
  }
}
class UpdateContractResponse {
  static fromProto(proto) {
    let m = new UpdateContractResponse();
    m = Object.assign(m, proto);
    if (proto.contract) {
      m.contract = Contract.fromProto(proto.contract);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contract !== 'undefined' && this.contract !== null) {
      toReturn['contract'] = 'toApiJson' in this.contract ? this.contract.toApiJson() : this.contract;
    }
    return toReturn;
  }
}
class UpdateContractSubscriptionRequest {
  static fromProto(proto) {
    let m = new UpdateContractSubscriptionRequest();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$y(Frequency, proto.frequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    return toReturn;
  }
}
function enumStringToValue$x(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CustomerSummary {
  static fromProto(proto) {
    let m = new CustomerSummary();
    m = Object.assign(m, proto);
    if (proto.purchaseItemQuantity) {
      m.purchaseItemQuantity = parseInt(proto.purchaseItemQuantity, 10);
    }
    if (proto.purchaseItemTotal) {
      m.purchaseItemTotal = parseInt(proto.purchaseItemTotal, 10);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$x(Currency, proto.currency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.purchaseItemQuantity !== 'undefined') {
      toReturn['purchaseItemQuantity'] = this.purchaseItemQuantity;
    }
    if (typeof this.purchaseItemTotal !== 'undefined') {
      toReturn['purchaseItemTotal'] = this.purchaseItemTotal;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    return toReturn;
  }
}
class GetMultiCustomerSummariesRequest {
  static fromProto(proto) {
    let m = new GetMultiCustomerSummariesRequest();
    m = Object.assign(m, proto);
    if (proto.periodStart) {
      m.periodStart = new Date(proto.periodStart);
    }
    if (proto.periodEnd) {
      m.periodEnd = new Date(proto.periodEnd);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerIds !== 'undefined') {
      toReturn['customerIds'] = this.customerIds;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.periodStart !== 'undefined' && this.periodStart !== null) {
      toReturn['periodStart'] = 'toApiJson' in this.periodStart ? this.periodStart.toApiJson() : this.periodStart;
    }
    if (typeof this.periodEnd !== 'undefined' && this.periodEnd !== null) {
      toReturn['periodEnd'] = 'toApiJson' in this.periodEnd ? this.periodEnd.toApiJson() : this.periodEnd;
    }
    return toReturn;
  }
}
class GetMultiCustomerSummariesResponse {
  static fromProto(proto) {
    let m = new GetMultiCustomerSummariesResponse();
    m = Object.assign(m, proto);
    if (proto.customerSummaries) {
      m.customerSummaries = proto.customerSummaries.map(CustomerSummary.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerSummaries !== 'undefined' && this.customerSummaries !== null) {
      toReturn['customerSummaries'] = 'toApiJson' in this.customerSummaries ? this.customerSummaries.toApiJson() : this.customerSummaries;
    }
    return toReturn;
  }
}
function enumStringToValue$w(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BankAccount {
  static fromProto(proto) {
    let m = new BankAccount();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.accountHolderName !== 'undefined') {
      toReturn['accountHolderName'] = this.accountHolderName;
    }
    if (typeof this.bankName !== 'undefined') {
      toReturn['bankName'] = this.bankName;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.routingNumber !== 'undefined') {
      toReturn['routingNumber'] = this.routingNumber;
    }
    if (typeof this.last4 !== 'undefined') {
      toReturn['last4'] = this.last4;
    }
    if (typeof this.defaultForCurrency !== 'undefined') {
      toReturn['defaultForCurrency'] = this.defaultForCurrency;
    }
    return toReturn;
  }
}
class CreateStripeExternalAccountRequest {
  static fromProto(proto) {
    let m = new CreateStripeExternalAccountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.stripeToken !== 'undefined') {
      toReturn['stripeToken'] = this.stripeToken;
    }
    return toReturn;
  }
}
class DeleteBankAccountRequest {
  static fromProto(proto) {
    let m = new DeleteBankAccountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.bankAccountId !== 'undefined') {
      toReturn['bankAccountId'] = this.bankAccountId;
    }
    return toReturn;
  }
}
class ListBankAccountsRequest {
  static fromProto(proto) {
    let m = new ListBankAccountsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class ListBankAccountsResponse {
  static fromProto(proto) {
    let m = new ListBankAccountsResponse();
    m = Object.assign(m, proto);
    if (proto.bankAccount) {
      m.bankAccount = proto.bankAccount.map(BankAccount.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bankAccount !== 'undefined' && this.bankAccount !== null) {
      toReturn['bankAccount'] = 'toApiJson' in this.bankAccount ? this.bankAccount.toApiJson() : this.bankAccount;
    }
    return toReturn;
  }
}
class SetDefaultBankAccountRequest {
  static fromProto(proto) {
    let m = new SetDefaultBankAccountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.bankAccountId !== 'undefined') {
      toReturn['bankAccountId'] = this.bankAccountId;
    }
    return toReturn;
  }
}
function enumStringToValue$v(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ProductSummaryDiscount {
  static fromProto(proto) {
    let m = new ProductSummaryDiscount();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$v(ProductSummaryDiscountDiscountType, proto.type);
    }
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    if (proto.totalAmount) {
      m.totalAmount = parseInt(proto.totalAmount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.totalAmount !== 'undefined') {
      toReturn['totalAmount'] = this.totalAmount;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.resetEachPeriod !== 'undefined') {
      toReturn['resetEachPeriod'] = this.resetEachPeriod;
    }
    return toReturn;
  }
}
class ListSubscriptionRetentionRequestFilters {
  static fromProto(proto) {
    let m = new ListSubscriptionRetentionRequestFilters();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    return toReturn;
  }
}
class GetProductSummariesTotalRequest {
  static fromProto(proto) {
    let m = new GetProductSummariesTotalRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class GetProductSummariesTotalResponse {
  static fromProto(proto) {
    let m = new GetProductSummariesTotalResponse();
    m = Object.assign(m, proto);
    if (proto.totalAmount) {
      m.totalAmount = parseInt(proto.totalAmount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.totalAmount !== 'undefined') {
      toReturn['totalAmount'] = this.totalAmount;
    }
    return toReturn;
  }
}
class ListProductSummariesRequest {
  static fromProto(proto) {
    let m = new ListProductSummariesRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.skus !== 'undefined') {
      toReturn['skus'] = this.skus;
    }
    return toReturn;
  }
}
class ListProductSummariesResponse {
  static fromProto(proto) {
    let m = new ListProductSummariesResponse();
    m = Object.assign(m, proto);
    if (proto.results) {
      m.results = proto.results.map(ProductSummary.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ListSubscriptionRetentionByGroupResponse {
  static fromProto(proto) {
    let m = new ListSubscriptionRetentionByGroupResponse();
    m = Object.assign(m, proto);
    if (proto.metricsByGroup) {
      m.metricsByGroup = proto.metricsByGroup.map(ListSubscriptionRetentionByGroupResponseSubscriptionRetentionByGroup.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metricsByGroup !== 'undefined' && this.metricsByGroup !== null) {
      toReturn['metricsByGroup'] = 'toApiJson' in this.metricsByGroup ? this.metricsByGroup.toApiJson() : this.metricsByGroup;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListSubscriptionRetentionBySKUResponse {
  static fromProto(proto) {
    let m = new ListSubscriptionRetentionBySKUResponse();
    m = Object.assign(m, proto);
    if (proto.subscriptionMetrics) {
      m.subscriptionMetrics = proto.subscriptionMetrics.map(RetentionMetrics.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionMetrics !== 'undefined' && this.subscriptionMetrics !== null) {
      toReturn['subscriptionMetrics'] = 'toApiJson' in this.subscriptionMetrics ? this.subscriptionMetrics.toApiJson() : this.subscriptionMetrics;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListSubscriptionRetentionRequest {
  static fromProto(proto) {
    let m = new ListSubscriptionRetentionRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSubscriptionRetentionRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class Pricing {
  static fromProto(proto) {
    let m = new Pricing();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$v(PricingRuleType, proto.type);
    }
    if (proto.rules) {
      m.rules = proto.rules.map(PricingRule.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.rules !== 'undefined' && this.rules !== null) {
      toReturn['rules'] = 'toApiJson' in this.rules ? this.rules.toApiJson() : this.rules;
    }
    return toReturn;
  }
}
class ProductSummary {
  static fromProto(proto) {
    let m = new ProductSummary();
    m = Object.assign(m, proto);
    if (proto.totalQuantity) {
      m.totalQuantity = parseInt(proto.totalQuantity, 10);
    }
    if (proto.totalAmount) {
      m.totalAmount = parseInt(proto.totalAmount, 10);
    }
    if (proto.totalDiscount) {
      m.totalDiscount = parseInt(proto.totalDiscount, 10);
    }
    if (proto.pricing) {
      m.pricing = Pricing.fromProto(proto.pricing);
    }
    if (proto.discounts) {
      m.discounts = proto.discounts.map(ProductSummaryDiscount.fromProto);
    }
    if (proto.billingStrategy) {
      m.billingStrategy = enumStringToValue$v(ProductSummaryBillingStrategy, proto.billingStrategy);
    }
    if (proto.productType) {
      m.productType = enumStringToValue$v(ProductSummaryProductType, proto.productType);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$v(Frequency, proto.frequency);
    }
    if (proto.volumeCommitment) {
      m.volumeCommitment = parseInt(proto.volumeCommitment, 10);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.productName !== 'undefined') {
      toReturn['productName'] = this.productName;
    }
    if (typeof this.totalQuantity !== 'undefined') {
      toReturn['totalQuantity'] = this.totalQuantity;
    }
    if (typeof this.totalAmount !== 'undefined') {
      toReturn['totalAmount'] = this.totalAmount;
    }
    if (typeof this.totalDiscount !== 'undefined') {
      toReturn['totalDiscount'] = this.totalDiscount;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.discounts !== 'undefined' && this.discounts !== null) {
      toReturn['discounts'] = 'toApiJson' in this.discounts ? this.discounts.toApiJson() : this.discounts;
    }
    if (typeof this.billingStrategy !== 'undefined') {
      toReturn['billingStrategy'] = this.billingStrategy;
    }
    if (typeof this.productType !== 'undefined') {
      toReturn['productType'] = this.productType;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.proratedPercent !== 'undefined') {
      toReturn['proratedPercent'] = this.proratedPercent;
    }
    if (typeof this.volumeCommitment !== 'undefined') {
      toReturn['volumeCommitment'] = this.volumeCommitment;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    return toReturn;
  }
}
class RetentionMetrics {
  static fromProto(proto) {
    let m = new RetentionMetrics();
    m = Object.assign(m, proto);
    if (proto.startingCount) {
      m.startingCount = parseInt(proto.startingCount, 10);
    }
    if (proto.activations) {
      m.activations = parseInt(proto.activations, 10);
    }
    if (proto.deactivations) {
      m.deactivations = parseInt(proto.deactivations, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.productName !== 'undefined') {
      toReturn['productName'] = this.productName;
    }
    if (typeof this.startingCount !== 'undefined') {
      toReturn['startingCount'] = this.startingCount;
    }
    if (typeof this.activations !== 'undefined') {
      toReturn['activations'] = this.activations;
    }
    if (typeof this.deactivations !== 'undefined') {
      toReturn['deactivations'] = this.deactivations;
    }
    if (typeof this.churn !== 'undefined') {
      toReturn['churn'] = this.churn;
    }
    if (typeof this.retention !== 'undefined') {
      toReturn['retention'] = this.retention;
    }
    return toReturn;
  }
}
class PricingRule {
  static fromProto(proto) {
    let m = new PricingRule();
    m = Object.assign(m, proto);
    if (proto.min) {
      m.min = parseInt(proto.min, 10);
    }
    if (proto.max) {
      m.max = parseInt(proto.max, 10);
    }
    if (proto.units) {
      m.units = parseInt(proto.units, 10);
    }
    if (proto.unitPrice) {
      m.unitPrice = parseInt(proto.unitPrice, 10);
    }
    if (proto.totalAmount) {
      m.totalAmount = parseInt(proto.totalAmount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.min !== 'undefined') {
      toReturn['min'] = this.min;
    }
    if (typeof this.max !== 'undefined') {
      toReturn['max'] = this.max;
    }
    if (typeof this.units !== 'undefined') {
      toReturn['units'] = this.units;
    }
    if (typeof this.unitPrice !== 'undefined') {
      toReturn['unitPrice'] = this.unitPrice;
    }
    if (typeof this.totalAmount !== 'undefined') {
      toReturn['totalAmount'] = this.totalAmount;
    }
    return toReturn;
  }
}
class ListSubscriptionRetentionByGroupResponseSubscriptionRetentionByGroup {
  static fromProto(proto) {
    let m = new ListSubscriptionRetentionByGroupResponseSubscriptionRetentionByGroup();
    m = Object.assign(m, proto);
    if (proto.subscriptionMetrics) {
      m.subscriptionMetrics = proto.subscriptionMetrics.map(RetentionMetrics.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.subscriptionMetrics !== 'undefined' && this.subscriptionMetrics !== null) {
      toReturn['subscriptionMetrics'] = 'toApiJson' in this.subscriptionMetrics ? this.subscriptionMetrics.toApiJson() : this.subscriptionMetrics;
    }
    return toReturn;
  }
}
function enumStringToValue$u(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateDiscountRequest {
  static fromProto(proto) {
    let m = new CreateDiscountRequest();
    m = Object.assign(m, proto);
    if (proto.discountType) {
      m.discountType = enumStringToValue$u(DiscountType, proto.discountType);
    }
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.consumer) {
      m.consumer = enumStringToValue$u(Consumer, proto.consumer);
    }
    if (proto.numberOfBillingPeriods) {
      m.numberOfBillingPeriods = parseInt(proto.numberOfBillingPeriods, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.discountType !== 'undefined') {
      toReturn['discountType'] = this.discountType;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.resetEachPeriod !== 'undefined') {
      toReturn['resetEachPeriod'] = this.resetEachPeriod;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.consumer !== 'undefined') {
      toReturn['consumer'] = this.consumer;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.numberOfBillingPeriods !== 'undefined') {
      toReturn['numberOfBillingPeriods'] = this.numberOfBillingPeriods;
    }
    return toReturn;
  }
}
class CreateDiscountResponse {
  static fromProto(proto) {
    let m = new CreateDiscountResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class Discount {
  static fromProto(proto) {
    let m = new Discount();
    m = Object.assign(m, proto);
    if (proto.discountId) {
      m.discountId = parseInt(proto.discountId, 10);
    }
    if (proto.discountType) {
      m.discountType = enumStringToValue$u(DiscountType, proto.discountType);
    }
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.consumer) {
      m.consumer = enumStringToValue$u(Consumer, proto.consumer);
    }
    if (proto.numberOfBillingPeriods) {
      m.numberOfBillingPeriods = parseInt(proto.numberOfBillingPeriods, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.discountId !== 'undefined') {
      toReturn['discountId'] = this.discountId;
    }
    if (typeof this.discountType !== 'undefined') {
      toReturn['discountType'] = this.discountType;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.resetEachPeriod !== 'undefined') {
      toReturn['resetEachPeriod'] = this.resetEachPeriod;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.consumer !== 'undefined') {
      toReturn['consumer'] = this.consumer;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.numberOfBillingPeriods !== 'undefined') {
      toReturn['numberOfBillingPeriods'] = this.numberOfBillingPeriods;
    }
    return toReturn;
  }
}
class ExpireDiscountRequest {
  static fromProto(proto) {
    let m = new ExpireDiscountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ListDiscountsRequestFilters {
  static fromProto(proto) {
    let m = new ListDiscountsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.expiry) {
      m.expiry = new Date(proto.expiry);
    }
    if (proto.consumers) {
      m.consumers = proto.consumers.map(v => enumStringToValue$u(Consumer, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.expiry !== 'undefined' && this.expiry !== null) {
      toReturn['expiry'] = 'toApiJson' in this.expiry ? this.expiry.toApiJson() : this.expiry;
    }
    if (typeof this.skus !== 'undefined') {
      toReturn['skus'] = this.skus;
    }
    if (typeof this.customerIds !== 'undefined') {
      toReturn['customerIds'] = this.customerIds;
    }
    if (typeof this.includeCustomerDiscounts !== 'undefined') {
      toReturn['includeCustomerDiscounts'] = this.includeCustomerDiscounts;
    }
    if (typeof this.consumers !== 'undefined') {
      toReturn['consumers'] = this.consumers;
    }
    if (typeof this.subscriptionIds !== 'undefined') {
      toReturn['subscriptionIds'] = this.subscriptionIds;
    }
    return toReturn;
  }
}
class ListDiscountsRequest {
  static fromProto(proto) {
    let m = new ListDiscountsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListDiscountsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListDiscountsResponse {
  static fromProto(proto) {
    let m = new ListDiscountsResponse();
    m = Object.assign(m, proto);
    if (proto.discounts) {
      m.discounts = proto.discounts.map(Discount.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.discounts !== 'undefined' && this.discounts !== null) {
      toReturn['discounts'] = 'toApiJson' in this.discounts ? this.discounts.toApiJson() : this.discounts;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UpdateDiscountRequest {
  static fromProto(proto) {
    let m = new UpdateDiscountRequest();
    m = Object.assign(m, proto);
    if (proto.discountType) {
      m.discountType = enumStringToValue$u(DiscountType, proto.discountType);
    }
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.numberOfBillingPeriods) {
      m.numberOfBillingPeriods = parseInt(proto.numberOfBillingPeriods, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.discountType !== 'undefined') {
      toReturn['discountType'] = this.discountType;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.resetEachPeriod !== 'undefined') {
      toReturn['resetEachPeriod'] = this.resetEachPeriod;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.numberOfBillingPeriods !== 'undefined') {
      toReturn['numberOfBillingPeriods'] = this.numberOfBillingPeriods;
    }
    return toReturn;
  }
}
function enumStringToValue$t(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppliedTaxRate {
  static fromProto(proto) {
    let m = new AppliedTaxRate();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.taxRateId !== 'undefined') {
      toReturn['taxRateId'] = this.taxRateId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.percentage !== 'undefined') {
      toReturn['percentage'] = this.percentage;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
function enumStringToValue$s(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ArchiveTaxRequest {
  static fromProto(proto) {
    let m = new ArchiveTaxRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CalculateLineItemTaxesRequest {
  static fromProto(proto) {
    let m = new CalculateLineItemTaxesRequest();
    m = Object.assign(m, proto);
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(CalculateLineItemTaxesRequestLineItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    return toReturn;
  }
}
class CalculateLineItemTaxesResponse {
  static fromProto(proto) {
    let m = new CalculateLineItemTaxesResponse();
    m = Object.assign(m, proto);
    if (proto.lineItemTaxes) {
      m.lineItemTaxes = proto.lineItemTaxes.map(CalculateLineItemTaxesResponseLineItemTaxes.fromProto);
    }
    if (proto.totalTaxableAmount) {
      m.totalTaxableAmount = parseInt(proto.totalTaxableAmount, 10);
    }
    if (proto.taxRates) {
      m.taxRates = proto.taxRates.map(TaxRate.fromProto);
    }
    if (proto.appliedTaxes) {
      m.appliedTaxes = proto.appliedTaxes.map(AppliedTaxRate.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lineItemTaxes !== 'undefined' && this.lineItemTaxes !== null) {
      toReturn['lineItemTaxes'] = 'toApiJson' in this.lineItemTaxes ? this.lineItemTaxes.toApiJson() : this.lineItemTaxes;
    }
    if (typeof this.totalTaxableAmount !== 'undefined') {
      toReturn['totalTaxableAmount'] = this.totalTaxableAmount;
    }
    if (typeof this.taxRates !== 'undefined' && this.taxRates !== null) {
      toReturn['taxRates'] = 'toApiJson' in this.taxRates ? this.taxRates.toApiJson() : this.taxRates;
    }
    if (typeof this.appliedTaxes !== 'undefined' && this.appliedTaxes !== null) {
      toReturn['appliedTaxes'] = 'toApiJson' in this.appliedTaxes ? this.appliedTaxes.toApiJson() : this.appliedTaxes;
    }
    return toReturn;
  }
}
class CalculateTaxRequest {
  static fromProto(proto) {
    let m = new CalculateTaxRequest();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    return toReturn;
  }
}
class CalculateTaxResponse {
  static fromProto(proto) {
    let m = new CalculateTaxResponse();
    m = Object.assign(m, proto);
    if (proto.taxableAmount) {
      m.taxableAmount = parseInt(proto.taxableAmount, 10);
    }
    if (proto.taxRates) {
      m.taxRates = proto.taxRates.map(TaxRate.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taxableAmount !== 'undefined') {
      toReturn['taxableAmount'] = this.taxableAmount;
    }
    if (typeof this.taxRates !== 'undefined' && this.taxRates !== null) {
      toReturn['taxRates'] = 'toApiJson' in this.taxRates ? this.taxRates.toApiJson() : this.taxRates;
    }
    return toReturn;
  }
}
class CreateTaxRequest {
  static fromProto(proto) {
    let m = new CreateTaxRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.stateCode !== 'undefined') {
      toReturn['stateCode'] = this.stateCode;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.percentage !== 'undefined') {
      toReturn['percentage'] = this.percentage;
    }
    if (typeof this.accountingSystemId !== 'undefined') {
      toReturn['accountingSystemId'] = this.accountingSystemId;
    }
    return toReturn;
  }
}
class CreateTaxResponse {
  static fromProto(proto) {
    let m = new CreateTaxResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ListTaxRequestFilters {
  static fromProto(proto) {
    let m = new ListTaxRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.includeArchived !== 'undefined') {
      toReturn['includeArchived'] = this.includeArchived;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.stateCode !== 'undefined') {
      toReturn['stateCode'] = this.stateCode;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class GetMultiTaxRequest {
  static fromProto(proto) {
    let m = new GetMultiTaxRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.ids !== 'undefined') {
      toReturn['ids'] = this.ids;
    }
    return toReturn;
  }
}
class GetMultiTaxResponse {
  static fromProto(proto) {
    let m = new GetMultiTaxResponse();
    m = Object.assign(m, proto);
    if (proto.taxRates) {
      m.taxRates = proto.taxRates.map(TaxRate.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taxRates !== 'undefined' && this.taxRates !== null) {
      toReturn['taxRates'] = 'toApiJson' in this.taxRates ? this.taxRates.toApiJson() : this.taxRates;
    }
    return toReturn;
  }
}
class CalculateLineItemTaxesRequestLineItem {
  static fromProto(proto) {
    let m = new CalculateLineItemTaxesRequestLineItem();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    return toReturn;
  }
}
class CalculateLineItemTaxesResponseLineItemTaxes {
  static fromProto(proto) {
    let m = new CalculateLineItemTaxesResponseLineItemTaxes();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.taxableAmount !== 'undefined') {
      toReturn['taxableAmount'] = this.taxableAmount;
    }
    if (typeof this.taxRateIds !== 'undefined') {
      toReturn['taxRateIds'] = this.taxRateIds;
    }
    return toReturn;
  }
}
class ListTaxRequest {
  static fromProto(proto) {
    let m = new ListTaxRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListTaxRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListTaxResponse {
  static fromProto(proto) {
    let m = new ListTaxResponse();
    m = Object.assign(m, proto);
    if (proto.taxRates) {
      m.taxRates = proto.taxRates.map(TaxRate.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taxRates !== 'undefined' && this.taxRates !== null) {
      toReturn['taxRates'] = 'toApiJson' in this.taxRates ? this.taxRates.toApiJson() : this.taxRates;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class TaxRate {
  static fromProto(proto) {
    let m = new TaxRate();
    m = Object.assign(m, proto);
    if (proto.archived) {
      m.archived = new Date(proto.archived);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.stateCode !== 'undefined') {
      toReturn['stateCode'] = this.stateCode;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.percentage !== 'undefined') {
      toReturn['percentage'] = this.percentage;
    }
    if (typeof this.accountingSystemId !== 'undefined') {
      toReturn['accountingSystemId'] = this.accountingSystemId;
    }
    if (typeof this.archived !== 'undefined' && this.archived !== null) {
      toReturn['archived'] = 'toApiJson' in this.archived ? this.archived.toApiJson() : this.archived;
    }
    return toReturn;
  }
}
class UpdateTaxRequest {
  static fromProto(proto) {
    let m = new UpdateTaxRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.stateCode !== 'undefined') {
      toReturn['stateCode'] = this.stateCode;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.percentage !== 'undefined') {
      toReturn['percentage'] = this.percentage;
    }
    if (typeof this.accountingSystemId !== 'undefined') {
      toReturn['accountingSystemId'] = this.accountingSystemId;
    }
    return toReturn;
  }
}
function enumStringToValue$r(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppliedBundle {
  static fromProto(proto) {
    let m = new AppliedBundle();
    m = Object.assign(m, proto);
    if (proto.bundleItems) {
      m.bundleItems = proto.bundleItems.map(AppliedBundleItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bundleId !== 'undefined') {
      toReturn['bundleId'] = this.bundleId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.bundleItems !== 'undefined' && this.bundleItems !== null) {
      toReturn['bundleItems'] = 'toApiJson' in this.bundleItems ? this.bundleItems.toApiJson() : this.bundleItems;
    }
    if (typeof this.hideBundleItems !== 'undefined') {
      toReturn['hideBundleItems'] = this.hideBundleItems;
    }
    if (typeof this.bundleInstanceId !== 'undefined') {
      toReturn['bundleInstanceId'] = this.bundleInstanceId;
    }
    return toReturn;
  }
}
class AppliedBundleItem {
  static fromProto(proto) {
    let m = new AppliedBundleItem();
    m = Object.assign(m, proto);
    if (proto.discountAmount) {
      m.discountAmount = parseInt(proto.discountAmount, 10);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.discountType !== 'undefined') {
      toReturn['discountType'] = this.discountType;
    }
    if (typeof this.discountAmount !== 'undefined') {
      toReturn['discountAmount'] = this.discountAmount;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
function enumStringToValue$q(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreatePaymentCardRequest {
  static fromProto(proto) {
    let m = new CreatePaymentCardRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.stripeToken !== 'undefined') {
      toReturn['stripeToken'] = this.stripeToken;
    }
    if (typeof this.recaptchaToken !== 'undefined') {
      toReturn['recaptchaToken'] = this.recaptchaToken;
    }
    return toReturn;
  }
}
class DeletePaymentCardRequest {
  static fromProto(proto) {
    let m = new DeletePaymentCardRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.cardId !== 'undefined') {
      toReturn['cardId'] = this.cardId;
    }
    return toReturn;
  }
}
class ListPaymentCardsRequest {
  static fromProto(proto) {
    let m = new ListPaymentCardsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class ListPaymentCardsResponse {
  static fromProto(proto) {
    let m = new ListPaymentCardsResponse();
    m = Object.assign(m, proto);
    if (proto.paymentCard) {
      m.paymentCard = proto.paymentCard.map(PaymentCard.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paymentCard !== 'undefined' && this.paymentCard !== null) {
      toReturn['paymentCard'] = 'toApiJson' in this.paymentCard ? this.paymentCard.toApiJson() : this.paymentCard;
    }
    return toReturn;
  }
}
class PaymentCard {
  static fromProto(proto) {
    let m = new PaymentCard();
    m = Object.assign(m, proto);
    if (proto.cardType) {
      m.cardType = enumStringToValue$q(PaymentCardCARD_TYPE, proto.cardType);
    }
    if (proto.fundingType) {
      m.fundingType = enumStringToValue$q(PaymentCardFUNDING_TYPE, proto.fundingType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lastFourDigits !== 'undefined') {
      toReturn['lastFourDigits'] = this.lastFourDigits;
    }
    if (typeof this.cardType !== 'undefined') {
      toReturn['cardType'] = this.cardType;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.zipCode !== 'undefined') {
      toReturn['zipCode'] = this.zipCode;
    }
    if (typeof this.cardId !== 'undefined') {
      toReturn['cardId'] = this.cardId;
    }
    if (typeof this.cardholderName !== 'undefined') {
      toReturn['cardholderName'] = this.cardholderName;
    }
    if (typeof this.expiryMonth !== 'undefined') {
      toReturn['expiryMonth'] = this.expiryMonth;
    }
    if (typeof this.expiryYear !== 'undefined') {
      toReturn['expiryYear'] = this.expiryYear;
    }
    if (typeof this.fundingType !== 'undefined') {
      toReturn['fundingType'] = this.fundingType;
    }
    if (typeof this.default !== 'undefined') {
      toReturn['default'] = this.default;
    }
    return toReturn;
  }
}
class SetDefaultPaymentMethodRequest {
  static fromProto(proto) {
    let m = new SetDefaultPaymentMethodRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.paymentMethodId !== 'undefined') {
      toReturn['paymentMethodId'] = this.paymentMethodId;
    }
    return toReturn;
  }
}
class UpdatePaymentCardRequest {
  static fromProto(proto) {
    let m = new UpdatePaymentCardRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.stripeToken !== 'undefined') {
      toReturn['stripeToken'] = this.stripeToken;
    }
    if (typeof this.recaptchaToken !== 'undefined') {
      toReturn['recaptchaToken'] = this.recaptchaToken;
    }
    return toReturn;
  }
}
function enumStringToValue$p(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ListPaymentMethodsRequest {
  static fromProto(proto) {
    let m = new ListPaymentMethodsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class ListPaymentMethodsResponse {
  static fromProto(proto) {
    let m = new ListPaymentMethodsResponse();
    m = Object.assign(m, proto);
    if (proto.paymentMethods) {
      m.paymentMethods = proto.paymentMethods.map(PaymentMethod.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paymentMethods !== 'undefined' && this.paymentMethods !== null) {
      toReturn['paymentMethods'] = 'toApiJson' in this.paymentMethods ? this.paymentMethods.toApiJson() : this.paymentMethods;
    }
    return toReturn;
  }
}
class PaymentACHDebit {
  static fromProto(proto) {
    let m = new PaymentACHDebit();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lastFourDigits !== 'undefined') {
      toReturn['lastFourDigits'] = this.lastFourDigits;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class PaymentACSSDebit {
  static fromProto(proto) {
    let m = new PaymentACSSDebit();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lastFourDigits !== 'undefined') {
      toReturn['lastFourDigits'] = this.lastFourDigits;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class PaymentMethod {
  static fromProto(proto) {
    let m = new PaymentMethod();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$p(PaymentMethodType, proto.type);
    }
    if (proto.card) {
      m.card = PaymentCard.fromProto(proto.card);
    }
    if (proto.achDebit) {
      m.achDebit = PaymentACHDebit.fromProto(proto.achDebit);
    }
    if (proto.acssDebit) {
      m.acssDebit = PaymentACSSDebit.fromProto(proto.acssDebit);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.card !== 'undefined' && this.card !== null) {
      toReturn['card'] = 'toApiJson' in this.card ? this.card.toApiJson() : this.card;
    }
    if (typeof this.achDebit !== 'undefined' && this.achDebit !== null) {
      toReturn['achDebit'] = 'toApiJson' in this.achDebit ? this.achDebit.toApiJson() : this.achDebit;
    }
    if (typeof this.acssDebit !== 'undefined' && this.acssDebit !== null) {
      toReturn['acssDebit'] = 'toApiJson' in this.acssDebit ? this.acssDebit.toApiJson() : this.acssDebit;
    }
    if (typeof this.default !== 'undefined') {
      toReturn['default'] = this.default;
    }
    return toReturn;
  }
}
function enumStringToValue$o(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddBundleRequest {
  static fromProto(proto) {
    let m = new AddBundleRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.bundleId !== 'undefined') {
      toReturn['bundleId'] = this.bundleId;
    }
    return toReturn;
  }
}
class AddBundleResponse {
  static fromProto(proto) {
    let m = new AddBundleResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = Invoice.fromProto(proto.invoice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    return toReturn;
  }
}
class AddLineItemRequest {
  static fromProto(proto) {
    let m = new AddLineItemRequest();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.discounts) {
      m.discounts = proto.discounts.map(AppliedDiscount.fromProto);
    }
    if (proto.servicePeriodStart) {
      m.servicePeriodStart = new Date(proto.servicePeriodStart);
    }
    if (proto.servicePeriodEnd) {
      m.servicePeriodEnd = new Date(proto.servicePeriodEnd);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.taxRates !== 'undefined') {
      toReturn['taxRates'] = this.taxRates;
    }
    if (typeof this.discounts !== 'undefined' && this.discounts !== null) {
      toReturn['discounts'] = 'toApiJson' in this.discounts ? this.discounts.toApiJson() : this.discounts;
    }
    if (typeof this.servicePeriodStart !== 'undefined' && this.servicePeriodStart !== null) {
      toReturn['servicePeriodStart'] = 'toApiJson' in this.servicePeriodStart ? this.servicePeriodStart.toApiJson() : this.servicePeriodStart;
    }
    if (typeof this.servicePeriodEnd !== 'undefined' && this.servicePeriodEnd !== null) {
      toReturn['servicePeriodEnd'] = 'toApiJson' in this.servicePeriodEnd ? this.servicePeriodEnd.toApiJson() : this.servicePeriodEnd;
    }
    return toReturn;
  }
}
class AddLineItemResponse {
  static fromProto(proto) {
    let m = new AddLineItemResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = Invoice.fromProto(proto.invoice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    return toReturn;
  }
}
class AppliedCreditNote {
  static fromProto(proto) {
    let m = new AppliedCreditNote();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.creditNoteType) {
      m.creditNoteType = enumStringToValue$o(CreditNoteType, proto.creditNoteType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.creditNoteId !== 'undefined') {
      toReturn['creditNoteId'] = this.creditNoteId;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.creditNoteType !== 'undefined') {
      toReturn['creditNoteType'] = this.creditNoteType;
    }
    if (typeof this.creditNoteNumber !== 'undefined') {
      toReturn['creditNoteNumber'] = this.creditNoteNumber;
    }
    return toReturn;
  }
}
class ChargeInvoiceRequest {
  static fromProto(proto) {
    let m = new ChargeInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.paymentMethodId !== 'undefined') {
      toReturn['paymentMethodId'] = this.paymentMethodId;
    }
    return toReturn;
  }
}
class CreateInvoiceRequest {
  static fromProto(proto) {
    let m = new CreateInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class CreateInvoiceResponse {
  static fromProto(proto) {
    let m = new CreateInvoiceResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
class CreatePaymentLinkRequest {
  static fromProto(proto) {
    let m = new CreatePaymentLinkRequest();
    m = Object.assign(m, proto);
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(PaymentLinkItem.fromProto);
    }
    if (proto.due) {
      m.due = new Date(proto.due);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    if (typeof this.due !== 'undefined' && this.due !== null) {
      toReturn['due'] = 'toApiJson' in this.due ? this.due.toApiJson() : this.due;
    }
    return toReturn;
  }
}
class CreatePaymentLinkResponse {
  static fromProto(proto) {
    let m = new CreatePaymentLinkResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
class InvoiceCustomerAddress {
  static fromProto(proto) {
    let m = new InvoiceCustomerAddress();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    return toReturn;
  }
}
class ListInvoicesRequestFiltersDateFilter {
  static fromProto(proto) {
    let m = new ListInvoicesRequestFiltersDateFilter();
    m = Object.assign(m, proto);
    if (proto.dateField) {
      m.dateField = enumStringToValue$o(ListInvoicesRequestFiltersDateFilterDateField, proto.dateField);
    }
    if (proto.dateLte) {
      m.dateLte = new Date(proto.dateLte);
    }
    if (proto.dateGte) {
      m.dateGte = new Date(proto.dateGte);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dateField !== 'undefined') {
      toReturn['dateField'] = this.dateField;
    }
    if (typeof this.dateLte !== 'undefined' && this.dateLte !== null) {
      toReturn['dateLte'] = 'toApiJson' in this.dateLte ? this.dateLte.toApiJson() : this.dateLte;
    }
    if (typeof this.dateGte !== 'undefined' && this.dateGte !== null) {
      toReturn['dateGte'] = 'toApiJson' in this.dateGte ? this.dateGte.toApiJson() : this.dateGte;
    }
    return toReturn;
  }
}
class DeleteInvoiceRequest {
  static fromProto(proto) {
    let m = new DeleteInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
class DeleteLineItemRequest {
  static fromProto(proto) {
    let m = new DeleteLineItemRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class DeleteLineItemResponse {
  static fromProto(proto) {
    let m = new DeleteLineItemResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = Invoice.fromProto(proto.invoice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    return toReturn;
  }
}
class DuplicateInvoiceRequest {
  static fromProto(proto) {
    let m = new DuplicateInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
class DuplicateInvoiceResponse {
  static fromProto(proto) {
    let m = new DuplicateInvoiceResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
class ListInvoicesRequestFilters {
  static fromProto(proto) {
    let m = new ListInvoicesRequestFilters();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$o(InvoiceStatus, v));
    }
    if (proto.dateFilter) {
      m.dateFilter = ListInvoicesRequestFiltersDateFilter.fromProto(proto.dateFilter);
    }
    if (proto.lastPaymentStatuses) {
      m.lastPaymentStatuses = proto.lastPaymentStatuses.map(v => enumStringToValue$o(LastPaymentStatus, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.pastDue !== 'undefined') {
      toReturn['pastDue'] = this.pastDue;
    }
    if (typeof this.number !== 'undefined') {
      toReturn['number'] = this.number;
    }
    if (typeof this.dateFilter !== 'undefined' && this.dateFilter !== null) {
      toReturn['dateFilter'] = 'toApiJson' in this.dateFilter ? this.dateFilter.toApiJson() : this.dateFilter;
    }
    if (typeof this.origins !== 'undefined') {
      toReturn['origins'] = this.origins;
    }
    if (typeof this.collectionMethods !== 'undefined') {
      toReturn['collectionMethods'] = this.collectionMethods;
    }
    if (typeof this.lastPaymentStatuses !== 'undefined') {
      toReturn['lastPaymentStatuses'] = this.lastPaymentStatuses;
    }
    return toReturn;
  }
}
class GetInvoiceRequest {
  static fromProto(proto) {
    let m = new GetInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
class GetInvoiceResponse {
  static fromProto(proto) {
    let m = new GetInvoiceResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = Invoice.fromProto(proto.invoice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    return toReturn;
  }
}
class GetUpcomingInvoicePreviewRequest {
  static fromProto(proto) {
    let m = new GetUpcomingInvoicePreviewRequest();
    m = Object.assign(m, proto);
    if (proto.invoiceDate) {
      m.invoiceDate = new Date(proto.invoiceDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.invoiceDate !== 'undefined' && this.invoiceDate !== null) {
      toReturn['invoiceDate'] = 'toApiJson' in this.invoiceDate ? this.invoiceDate.toApiJson() : this.invoiceDate;
    }
    return toReturn;
  }
}
class GetUpcomingInvoicePreviewResponse {
  static fromProto(proto) {
    let m = new GetUpcomingInvoicePreviewResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = Invoice.fromProto(proto.invoice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    return toReturn;
  }
}
class Invoice {
  static fromProto(proto) {
    let m = new Invoice();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$o(InvoiceStatus, proto.status);
    }
    if (proto.subtotal) {
      m.subtotal = parseInt(proto.subtotal, 10);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.amountPaid) {
      m.amountPaid = parseInt(proto.amountPaid, 10);
    }
    if (proto.issued) {
      m.issued = new Date(proto.issued);
    }
    if (proto.due) {
      m.due = new Date(proto.due);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.items) {
      m.items = proto.items.map(InvoiceItem.fromProto);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$o(Currency, proto.currency);
    }
    if (proto.paid) {
      m.paid = new Date(proto.paid);
    }
    if (proto.amountTax) {
      m.amountTax = parseInt(proto.amountTax, 10);
    }
    if (proto.appliedTaxes) {
      m.appliedTaxes = proto.appliedTaxes.map(AppliedTaxRate.fromProto);
    }
    if (proto.defaultTaxRates) {
      m.defaultTaxRates = proto.defaultTaxRates.map(TaxRate.fromProto);
    }
    if (proto.appliedBundles) {
      m.appliedBundles = proto.appliedBundles.map(AppliedBundle.fromProto);
    }
    if (proto.amountDiscount) {
      m.amountDiscount = parseInt(proto.amountDiscount, 10);
    }
    if (proto.voided) {
      m.voided = new Date(proto.voided);
    }
    if (proto.customerAddress) {
      m.customerAddress = InvoiceCustomerAddress.fromProto(proto.customerAddress);
    }
    if (proto.notes) {
      m.notes = proto.notes.map(Note.fromProto);
    }
    if (proto.autoAdvance) {
      m.autoAdvance = new Date(proto.autoAdvance);
    }
    if (proto.paymentMethodTypes) {
      m.paymentMethodTypes = proto.paymentMethodTypes.map(v => enumStringToValue$o(PaymentMethodType, v));
    }
    if (proto.lastPaymentStatus) {
      m.lastPaymentStatus = enumStringToValue$o(LastPaymentStatus, proto.lastPaymentStatus);
    }
    if (proto.amountOwing) {
      m.amountOwing = parseInt(proto.amountOwing, 10);
    }
    if (proto.appliedCreditNotes) {
      m.appliedCreditNotes = proto.appliedCreditNotes.map(AppliedCreditNote.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.number !== 'undefined') {
      toReturn['number'] = this.number;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.subtotal !== 'undefined') {
      toReturn['subtotal'] = this.subtotal;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.amountPaid !== 'undefined') {
      toReturn['amountPaid'] = this.amountPaid;
    }
    if (typeof this.issued !== 'undefined' && this.issued !== null) {
      toReturn['issued'] = 'toApiJson' in this.issued ? this.issued.toApiJson() : this.issued;
    }
    if (typeof this.due !== 'undefined' && this.due !== null) {
      toReturn['due'] = 'toApiJson' in this.due ? this.due.toApiJson() : this.due;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.paid !== 'undefined' && this.paid !== null) {
      toReturn['paid'] = 'toApiJson' in this.paid ? this.paid.toApiJson() : this.paid;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.amountTax !== 'undefined') {
      toReturn['amountTax'] = this.amountTax;
    }
    if (typeof this.appliedTaxes !== 'undefined' && this.appliedTaxes !== null) {
      toReturn['appliedTaxes'] = 'toApiJson' in this.appliedTaxes ? this.appliedTaxes.toApiJson() : this.appliedTaxes;
    }
    if (typeof this.defaultTaxRates !== 'undefined' && this.defaultTaxRates !== null) {
      toReturn['defaultTaxRates'] = 'toApiJson' in this.defaultTaxRates ? this.defaultTaxRates.toApiJson() : this.defaultTaxRates;
    }
    if (typeof this.appliedBundles !== 'undefined' && this.appliedBundles !== null) {
      toReturn['appliedBundles'] = 'toApiJson' in this.appliedBundles ? this.appliedBundles.toApiJson() : this.appliedBundles;
    }
    if (typeof this.amountDiscount !== 'undefined') {
      toReturn['amountDiscount'] = this.amountDiscount;
    }
    if (typeof this.customerName !== 'undefined') {
      toReturn['customerName'] = this.customerName;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.collectionMethod !== 'undefined') {
      toReturn['collectionMethod'] = this.collectionMethod;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.memo !== 'undefined') {
      toReturn['memo'] = this.memo;
    }
    if (typeof this.voided !== 'undefined' && this.voided !== null) {
      toReturn['voided'] = 'toApiJson' in this.voided ? this.voided.toApiJson() : this.voided;
    }
    if (typeof this.defaultPaymentMethod !== 'undefined') {
      toReturn['defaultPaymentMethod'] = this.defaultPaymentMethod;
    }
    if (typeof this.customerAddress !== 'undefined' && this.customerAddress !== null) {
      toReturn['customerAddress'] = 'toApiJson' in this.customerAddress ? this.customerAddress.toApiJson() : this.customerAddress;
    }
    if (typeof this.externalCustomerIdentifier !== 'undefined') {
      toReturn['externalCustomerIdentifier'] = this.externalCustomerIdentifier;
    }
    if (typeof this.notes !== 'undefined' && this.notes !== null) {
      toReturn['notes'] = 'toApiJson' in this.notes ? this.notes.toApiJson() : this.notes;
    }
    if (typeof this.additionalContactIds !== 'undefined') {
      toReturn['additionalContactIds'] = this.additionalContactIds;
    }
    if (typeof this.autoAdvance !== 'undefined' && this.autoAdvance !== null) {
      toReturn['autoAdvance'] = 'toApiJson' in this.autoAdvance ? this.autoAdvance.toApiJson() : this.autoAdvance;
    }
    if (typeof this.paymentMethodTypes !== 'undefined') {
      toReturn['paymentMethodTypes'] = this.paymentMethodTypes;
    }
    if (typeof this.lastPaymentStatus !== 'undefined') {
      toReturn['lastPaymentStatus'] = this.lastPaymentStatus;
    }
    if (typeof this.amountOwing !== 'undefined') {
      toReturn['amountOwing'] = this.amountOwing;
    }
    if (typeof this.appliedCreditNotes !== 'undefined' && this.appliedCreditNotes !== null) {
      toReturn['appliedCreditNotes'] = 'toApiJson' in this.appliedCreditNotes ? this.appliedCreditNotes.toApiJson() : this.appliedCreditNotes;
    }
    return toReturn;
  }
}
class InvoiceItem {
  static fromProto(proto) {
    let m = new InvoiceItem();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.appliedTaxes) {
      m.appliedTaxes = proto.appliedTaxes.map(AppliedTaxRate.fromProto);
    }
    if (proto.taxRates) {
      m.taxRates = proto.taxRates.map(TaxRate.fromProto);
    }
    if (proto.discounts) {
      m.discounts = proto.discounts.map(AppliedDiscount.fromProto);
    }
    if (proto.subtotal) {
      m.subtotal = parseInt(proto.subtotal, 10);
    }
    if (proto.servicePeriodStart) {
      m.servicePeriodStart = new Date(proto.servicePeriodStart);
    }
    if (proto.servicePeriodEnd) {
      m.servicePeriodEnd = new Date(proto.servicePeriodEnd);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.appliedTaxes !== 'undefined' && this.appliedTaxes !== null) {
      toReturn['appliedTaxes'] = 'toApiJson' in this.appliedTaxes ? this.appliedTaxes.toApiJson() : this.appliedTaxes;
    }
    if (typeof this.taxRates !== 'undefined' && this.taxRates !== null) {
      toReturn['taxRates'] = 'toApiJson' in this.taxRates ? this.taxRates.toApiJson() : this.taxRates;
    }
    if (typeof this.bundleId !== 'undefined') {
      toReturn['bundleId'] = this.bundleId;
    }
    if (typeof this.discounts !== 'undefined' && this.discounts !== null) {
      toReturn['discounts'] = 'toApiJson' in this.discounts ? this.discounts.toApiJson() : this.discounts;
    }
    if (typeof this.subtotal !== 'undefined') {
      toReturn['subtotal'] = this.subtotal;
    }
    if (typeof this.bundleInstanceId !== 'undefined') {
      toReturn['bundleInstanceId'] = this.bundleInstanceId;
    }
    if (typeof this.servicePeriodStart !== 'undefined' && this.servicePeriodStart !== null) {
      toReturn['servicePeriodStart'] = 'toApiJson' in this.servicePeriodStart ? this.servicePeriodStart.toApiJson() : this.servicePeriodStart;
    }
    if (typeof this.servicePeriodEnd !== 'undefined' && this.servicePeriodEnd !== null) {
      toReturn['servicePeriodEnd'] = 'toApiJson' in this.servicePeriodEnd ? this.servicePeriodEnd.toApiJson() : this.servicePeriodEnd;
    }
    return toReturn;
  }
}
class ListInvoicesRequest {
  static fromProto(proto) {
    let m = new ListInvoicesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListInvoicesRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListInvoicesResponse {
  static fromProto(proto) {
    let m = new ListInvoicesResponse();
    m = Object.assign(m, proto);
    if (proto.invoices) {
      m.invoices = proto.invoices.map(Invoice.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoices !== 'undefined' && this.invoices !== null) {
      toReturn['invoices'] = 'toApiJson' in this.invoices ? this.invoices.toApiJson() : this.invoices;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class PayInvoiceRequest {
  static fromProto(proto) {
    let m = new PayInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    return toReturn;
  }
}
class PaymentLinkItem {
  static fromProto(proto) {
    let m = new PaymentLinkItem();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class RemoveBundleRequest {
  static fromProto(proto) {
    let m = new RemoveBundleRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.bundleId !== 'undefined') {
      toReturn['bundleId'] = this.bundleId;
    }
    if (typeof this.bundleInstanceId !== 'undefined') {
      toReturn['bundleInstanceId'] = this.bundleInstanceId;
    }
    return toReturn;
  }
}
class RemoveBundleResponse {
  static fromProto(proto) {
    let m = new RemoveBundleResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = Invoice.fromProto(proto.invoice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    return toReturn;
  }
}
class SendInvoiceRequest {
  static fromProto(proto) {
    let m = new SendInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.emailAddresses !== 'undefined') {
      toReturn['emailAddresses'] = this.emailAddresses;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class UpdateBundleRequest {
  static fromProto(proto) {
    let m = new UpdateBundleRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.bundleId !== 'undefined') {
      toReturn['bundleId'] = this.bundleId;
    }
    if (typeof this.hideBundleItems !== 'undefined') {
      toReturn['hideBundleItems'] = this.hideBundleItems;
    }
    if (typeof this.bundleInstanceId !== 'undefined') {
      toReturn['bundleInstanceId'] = this.bundleInstanceId;
    }
    return toReturn;
  }
}
class UpdateBundleResponse {
  static fromProto(proto) {
    let m = new UpdateBundleResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = Invoice.fromProto(proto.invoice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    return toReturn;
  }
}
class UpdateDefaultTaxRatesRequest {
  static fromProto(proto) {
    let m = new UpdateDefaultTaxRatesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.taxRateIds !== 'undefined') {
      toReturn['taxRateIds'] = this.taxRateIds;
    }
    return toReturn;
  }
}
class UpdateDefaultTaxRatesResponse {
  static fromProto(proto) {
    let m = new UpdateDefaultTaxRatesResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = Invoice.fromProto(proto.invoice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    return toReturn;
  }
}
class UpdateInvoiceRequest {
  static fromProto(proto) {
    let m = new UpdateInvoiceRequest();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = Invoice.fromProto(proto.invoice);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateInvoiceResponse {
  static fromProto(proto) {
    let m = new UpdateInvoiceResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = Invoice.fromProto(proto.invoice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    return toReturn;
  }
}
class UpdateLineItemRequest {
  static fromProto(proto) {
    let m = new UpdateLineItemRequest();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.discounts) {
      m.discounts = proto.discounts.map(AppliedDiscount.fromProto);
    }
    if (proto.servicePeriodStart) {
      m.servicePeriodStart = new Date(proto.servicePeriodStart);
    }
    if (proto.servicePeriodEnd) {
      m.servicePeriodEnd = new Date(proto.servicePeriodEnd);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.taxRates !== 'undefined') {
      toReturn['taxRates'] = this.taxRates;
    }
    if (typeof this.discounts !== 'undefined' && this.discounts !== null) {
      toReturn['discounts'] = 'toApiJson' in this.discounts ? this.discounts.toApiJson() : this.discounts;
    }
    if (typeof this.servicePeriodStart !== 'undefined' && this.servicePeriodStart !== null) {
      toReturn['servicePeriodStart'] = 'toApiJson' in this.servicePeriodStart ? this.servicePeriodStart.toApiJson() : this.servicePeriodStart;
    }
    if (typeof this.servicePeriodEnd !== 'undefined' && this.servicePeriodEnd !== null) {
      toReturn['servicePeriodEnd'] = 'toApiJson' in this.servicePeriodEnd ? this.servicePeriodEnd.toApiJson() : this.servicePeriodEnd;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateLineItemResponse {
  static fromProto(proto) {
    let m = new UpdateLineItemResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = Invoice.fromProto(proto.invoice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    return toReturn;
  }
}
class VoidInvoiceRequest {
  static fromProto(proto) {
    let m = new VoidInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    return toReturn;
  }
}
function enumStringToValue$n(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccountBalance {
  static fromProto(proto) {
    let m = new AccountBalance();
    m = Object.assign(m, proto);
    if (proto.available) {
      m.available = proto.available.map(BalanceAmount.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.available !== 'undefined' && this.available !== null) {
      toReturn['available'] = 'toApiJson' in this.available ? this.available.toApiJson() : this.available;
    }
    return toReturn;
  }
}
class Balance {
  static fromProto(proto) {
    let m = new Balance();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.futurePayouts) {
      m.futurePayouts = parseInt(proto.futurePayouts, 10);
    }
    if (proto.inTransit) {
      m.inTransit = parseInt(proto.inTransit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.futurePayouts !== 'undefined') {
      toReturn['futurePayouts'] = this.futurePayouts;
    }
    if (typeof this.inTransit !== 'undefined') {
      toReturn['inTransit'] = this.inTransit;
    }
    return toReturn;
  }
}
class BalanceAmount {
  static fromProto(proto) {
    let m = new BalanceAmount();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    return toReturn;
  }
}
function enumStringToValue$m(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DateRange {
  static fromProto(proto) {
    let m = new DateRange();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    return toReturn;
  }
}
function enumStringToValue$l(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ListPayoutsRequestFilters {
  static fromProto(proto) {
    let m = new ListPayoutsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.arrivalDateRange) {
      m.arrivalDateRange = DateRange.fromProto(proto.arrivalDateRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.arrivalDateRange !== 'undefined' && this.arrivalDateRange !== null) {
      toReturn['arrivalDateRange'] = 'toApiJson' in this.arrivalDateRange ? this.arrivalDateRange.toApiJson() : this.arrivalDateRange;
    }
    return toReturn;
  }
}
class ListPayoutsRequest {
  static fromProto(proto) {
    let m = new ListPayoutsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListPayoutsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.subsidiary !== 'undefined') {
      toReturn['subsidiary'] = this.subsidiary;
    }
    return toReturn;
  }
}
class ListPayoutsResponse {
  static fromProto(proto) {
    let m = new ListPayoutsResponse();
    m = Object.assign(m, proto);
    if (proto.payouts) {
      m.payouts = proto.payouts.map(Payout.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.payouts !== 'undefined' && this.payouts !== null) {
      toReturn['payouts'] = 'toApiJson' in this.payouts ? this.payouts.toApiJson() : this.payouts;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class Payout {
  static fromProto(proto) {
    let m = new Payout();
    m = Object.assign(m, proto);
    if (proto.arrivalDate) {
      m.arrivalDate = new Date(proto.arrivalDate);
    }
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$l(Currency, proto.currency);
    }
    if (proto.status) {
      m.status = enumStringToValue$l(PayoutStatus, proto.status);
    }
    if (proto.type) {
      m.type = enumStringToValue$l(PayoutType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.arrivalDate !== 'undefined' && this.arrivalDate !== null) {
      toReturn['arrivalDate'] = 'toApiJson' in this.arrivalDate ? this.arrivalDate.toApiJson() : this.arrivalDate;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.lastFourDigits !== 'undefined') {
      toReturn['lastFourDigits'] = this.lastFourDigits;
    }
    if (typeof this.bankName !== 'undefined') {
      toReturn['bankName'] = this.bankName;
    }
    if (typeof this.bankId !== 'undefined') {
      toReturn['bankId'] = this.bankId;
    }
    return toReturn;
  }
}
class ReconcilePayoutRequest {
  static fromProto(proto) {
    let m = new ReconcilePayoutRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bankReconciliationId !== 'undefined') {
      toReturn['bankReconciliationId'] = this.bankReconciliationId;
    }
    if (typeof this.payoutId !== 'undefined') {
      toReturn['payoutId'] = this.payoutId;
    }
    if (typeof this.allowRetries !== 'undefined') {
      toReturn['allowRetries'] = this.allowRetries;
    }
    if (typeof this.subsidiary !== 'undefined') {
      toReturn['subsidiary'] = this.subsidiary;
    }
    return toReturn;
  }
}
class ReconcilePayoutResponse {
  static fromProto(proto) {
    let m = new ReconcilePayoutResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pipelineId !== 'undefined') {
      toReturn['pipelineId'] = this.pipelineId;
    }
    return toReturn;
  }
}
class RetailPayout {
  static fromProto(proto) {
    let m = new RetailPayout();
    m = Object.assign(m, proto);
    if (proto.arrivalDate) {
      m.arrivalDate = new Date(proto.arrivalDate);
    }
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue$l(PayoutStatus, proto.status);
    }
    if (proto.type) {
      m.type = enumStringToValue$l(PayoutType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.arrivalDate !== 'undefined' && this.arrivalDate !== null) {
      toReturn['arrivalDate'] = 'toApiJson' in this.arrivalDate ? this.arrivalDate.toApiJson() : this.arrivalDate;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.lastFourDigits !== 'undefined') {
      toReturn['lastFourDigits'] = this.lastFourDigits;
    }
    if (typeof this.bankName !== 'undefined') {
      toReturn['bankName'] = this.bankName;
    }
    if (typeof this.bankId !== 'undefined') {
      toReturn['bankId'] = this.bankId;
    }
    if (typeof this.failureCode !== 'undefined') {
      toReturn['failureCode'] = this.failureCode;
    }
    if (typeof this.failureMessage !== 'undefined') {
      toReturn['failureMessage'] = this.failureMessage;
    }
    return toReturn;
  }
}
function enumStringToValue$k(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CancelRetailBillingRequest {
  static fromProto(proto) {
    let m = new CancelRetailBillingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class ChargeSalesInvoiceRequest {
  static fromProto(proto) {
    let m = new ChargeSalesInvoiceRequest();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    return toReturn;
  }
}
class ConnectStripeAccountRequest {
  static fromProto(proto) {
    let m = new ConnectStripeAccountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.failureUrl !== 'undefined') {
      toReturn['failureUrl'] = this.failureUrl;
    }
    if (typeof this.successUrl !== 'undefined') {
      toReturn['successUrl'] = this.successUrl;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class ConnectStripeAccountResponse {
  static fromProto(proto) {
    let m = new ConnectStripeAccountResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stripeUrl !== 'undefined') {
      toReturn['stripeUrl'] = this.stripeUrl;
    }
    if (typeof this.error !== 'undefined') {
      toReturn['error'] = this.error;
    }
    return toReturn;
  }
}
class CreateMerchantRequest {
  static fromProto(proto) {
    let m = new CreateMerchantRequest();
    m = Object.assign(m, proto);
    if (proto.includeInFinancialRecords) {
      m.includeInFinancialRecords = CreateMerchantRequestIncludeInFinancialRecords.fromProto(proto.includeInFinancialRecords);
    }
    if (proto.merchantType) {
      m.merchantType = enumStringToValue$k(MerchantType, proto.merchantType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.zipCode !== 'undefined') {
      toReturn['zipCode'] = this.zipCode;
    }
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.contactName !== 'undefined') {
      toReturn['contactName'] = this.contactName;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.additionalEmailAddresses !== 'undefined') {
      toReturn['additionalEmailAddresses'] = this.additionalEmailAddresses;
    }
    if (typeof this.includeInFinancialRecords !== 'undefined' && this.includeInFinancialRecords !== null) {
      toReturn['includeInFinancialRecords'] = 'toApiJson' in this.includeInFinancialRecords ? this.includeInFinancialRecords.toApiJson() : this.includeInFinancialRecords;
    }
    if (typeof this.hasAlternativePaymentMethod !== 'undefined') {
      toReturn['hasAlternativePaymentMethod'] = this.hasAlternativePaymentMethod;
    }
    if (typeof this.merchantType !== 'undefined') {
      toReturn['merchantType'] = this.merchantType;
    }
    return toReturn;
  }
}
class DefaultCustomerConfiguration {
  static fromProto(proto) {
    let m = new DefaultCustomerConfiguration();
    m = Object.assign(m, proto);
    if (proto.invoiceDay) {
      m.invoiceDay = parseInt(proto.invoiceDay, 10);
    }
    if (proto.netD) {
      m.netD = parseInt(proto.netD, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.generateMethod !== 'undefined') {
      toReturn['generateMethod'] = this.generateMethod;
    }
    if (typeof this.collectionMethod !== 'undefined') {
      toReturn['collectionMethod'] = this.collectionMethod;
    }
    if (typeof this.invoiceDay !== 'undefined') {
      toReturn['invoiceDay'] = this.invoiceDay;
    }
    if (typeof this.memo !== 'undefined') {
      toReturn['memo'] = this.memo;
    }
    if (typeof this.netD !== 'undefined') {
      toReturn['netD'] = this.netD;
    }
    if (typeof this.autoGenerateRetailSubscriptions !== 'undefined') {
      toReturn['autoGenerateRetailSubscriptions'] = this.autoGenerateRetailSubscriptions;
    }
    return toReturn;
  }
}
class GetMerchantRequest {
  static fromProto(proto) {
    let m = new GetMerchantRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetMerchantResponse {
  static fromProto(proto) {
    let m = new GetMerchantResponse();
    m = Object.assign(m, proto);
    if (proto.merchant) {
      m.merchant = Merchant.fromProto(proto.merchant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchant !== 'undefined' && this.merchant !== null) {
      toReturn['merchant'] = 'toApiJson' in this.merchant ? this.merchant.toApiJson() : this.merchant;
    }
    return toReturn;
  }
}
class GetMultiRetailConfigurationsRequest {
  static fromProto(proto) {
    let m = new GetMultiRetailConfigurationsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.retailGroupIds !== 'undefined') {
      toReturn['retailGroupIds'] = this.retailGroupIds;
    }
    return toReturn;
  }
}
class GetMultiRetailConfigurationsResponse {
  static fromProto(proto) {
    let m = new GetMultiRetailConfigurationsResponse();
    m = Object.assign(m, proto);
    if (proto.retailConfigurations) {
      m.retailConfigurations = Object.keys(proto.retailConfigurations).reduce((obj, k) => {
        obj[k] = RetailConfiguration.fromProto(proto.retailConfigurations[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.retailConfigurations !== 'undefined' && this.retailConfigurations !== null) {
      toReturn['retailConfigurations'] = 'toApiJson' in this.retailConfigurations ? this.retailConfigurations.toApiJson() : this.retailConfigurations;
    }
    return toReturn;
  }
}
class GetNextRetailInvoiceSequenceRequest {
  static fromProto(proto) {
    let m = new GetNextRetailInvoiceSequenceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetNextRetailInvoiceSequenceResponse {
  static fromProto(proto) {
    let m = new GetNextRetailInvoiceSequenceResponse();
    m = Object.assign(m, proto);
    if (proto.nextRetailInvoiceSequence) {
      m.nextRetailInvoiceSequence = parseInt(proto.nextRetailInvoiceSequence, 10);
    }
    if (proto.nextInvoiceNumber) {
      m.nextInvoiceNumber = parseInt(proto.nextInvoiceNumber, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextRetailInvoiceSequence !== 'undefined') {
      toReturn['nextRetailInvoiceSequence'] = this.nextRetailInvoiceSequence;
    }
    if (typeof this.nextInvoiceNumber !== 'undefined') {
      toReturn['nextInvoiceNumber'] = this.nextInvoiceNumber;
    }
    return toReturn;
  }
}
class GetOutstandingBalanceRequest {
  static fromProto(proto) {
    let m = new GetOutstandingBalanceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetOutstandingBalanceResponse {
  static fromProto(proto) {
    let m = new GetOutstandingBalanceResponse();
    m = Object.assign(m, proto);
    if (proto.outstandingBalance) {
      m.outstandingBalance = parseInt(proto.outstandingBalance, 10);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$k(Currency, proto.currency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.outstandingBalance !== 'undefined') {
      toReturn['outstandingBalance'] = this.outstandingBalance;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    return toReturn;
  }
}
class GetPayoutSummaryRequest {
  static fromProto(proto) {
    let m = new GetPayoutSummaryRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetPayoutSummaryResponse {
  static fromProto(proto) {
    let m = new GetPayoutSummaryResponse();
    m = Object.assign(m, proto);
    if (proto.balances) {
      m.balances = proto.balances.map(Balance.fromProto);
    }
    if (proto.nextInTransitPayoutExpectedDate) {
      m.nextInTransitPayoutExpectedDate = new Date(proto.nextInTransitPayoutExpectedDate);
    }
    if (proto.payoutDelayDays) {
      m.payoutDelayDays = parseInt(proto.payoutDelayDays, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.balances !== 'undefined' && this.balances !== null) {
      toReturn['balances'] = 'toApiJson' in this.balances ? this.balances.toApiJson() : this.balances;
    }
    if (typeof this.nextInTransitPayoutExpectedDate !== 'undefined' && this.nextInTransitPayoutExpectedDate !== null) {
      toReturn['nextInTransitPayoutExpectedDate'] = 'toApiJson' in this.nextInTransitPayoutExpectedDate ? this.nextInTransitPayoutExpectedDate.toApiJson() : this.nextInTransitPayoutExpectedDate;
    }
    if (typeof this.payoutInterval !== 'undefined') {
      toReturn['payoutInterval'] = this.payoutInterval;
    }
    if (typeof this.payoutDelayDays !== 'undefined') {
      toReturn['payoutDelayDays'] = this.payoutDelayDays;
    }
    return toReturn;
  }
}
class GetRetailAccountBalanceRequest {
  static fromProto(proto) {
    let m = new GetRetailAccountBalanceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetRetailAccountBalanceResponse {
  static fromProto(proto) {
    let m = new GetRetailAccountBalanceResponse();
    m = Object.assign(m, proto);
    if (proto.balance) {
      m.balance = AccountBalance.fromProto(proto.balance);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.balance !== 'undefined' && this.balance !== null) {
      toReturn['balance'] = 'toApiJson' in this.balance ? this.balance.toApiJson() : this.balance;
    }
    return toReturn;
  }
}
class GetRetailBalanceRequest {
  static fromProto(proto) {
    let m = new GetRetailBalanceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetRetailBalanceResponse {
  static fromProto(proto) {
    let m = new GetRetailBalanceResponse();
    m = Object.assign(m, proto);
    if (proto.balances) {
      m.balances = proto.balances.map(Balance.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.balances !== 'undefined' && this.balances !== null) {
      toReturn['balances'] = 'toApiJson' in this.balances ? this.balances.toApiJson() : this.balances;
    }
    return toReturn;
  }
}
class GetRetailPayoutRequest {
  static fromProto(proto) {
    let m = new GetRetailPayoutRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.payoutId !== 'undefined') {
      toReturn['payoutId'] = this.payoutId;
    }
    return toReturn;
  }
}
class GetRetailPayoutResponse {
  static fromProto(proto) {
    let m = new GetRetailPayoutResponse();
    m = Object.assign(m, proto);
    if (proto.payout) {
      m.payout = RetailPayout.fromProto(proto.payout);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.payout !== 'undefined' && this.payout !== null) {
      toReturn['payout'] = 'toApiJson' in this.payout ? this.payout.toApiJson() : this.payout;
    }
    return toReturn;
  }
}
class CreateMerchantRequestIncludeInFinancialRecords {
  static fromProto(proto) {
    let m = new CreateMerchantRequestIncludeInFinancialRecords();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeInFinancialRecords !== 'undefined') {
      toReturn['includeInFinancialRecords'] = this.includeInFinancialRecords;
    }
    return toReturn;
  }
}
class UpdateMerchantRequestIncludeInFinancialRecords {
  static fromProto(proto) {
    let m = new UpdateMerchantRequestIncludeInFinancialRecords();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeInFinancialRecords !== 'undefined') {
      toReturn['includeInFinancialRecords'] = this.includeInFinancialRecords;
    }
    return toReturn;
  }
}
class ListRetailPayoutsRequest {
  static fromProto(proto) {
    let m = new ListRetailPayoutsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListRetailPayoutsResponse {
  static fromProto(proto) {
    let m = new ListRetailPayoutsResponse();
    m = Object.assign(m, proto);
    if (proto.payouts) {
      m.payouts = proto.payouts.map(RetailPayout.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.payouts !== 'undefined' && this.payouts !== null) {
      toReturn['payouts'] = 'toApiJson' in this.payouts ? this.payouts.toApiJson() : this.payouts;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class Merchant {
  static fromProto(proto) {
    let m = new Merchant();
    m = Object.assign(m, proto);
    if (proto.merchantType) {
      m.merchantType = enumStringToValue$k(MerchantType, proto.merchantType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.zipCode !== 'undefined') {
      toReturn['zipCode'] = this.zipCode;
    }
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.contactName !== 'undefined') {
      toReturn['contactName'] = this.contactName;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.autoPostInvoices !== 'undefined') {
      toReturn['autoPostInvoices'] = this.autoPostInvoices;
    }
    if (typeof this.autoChargeInvoices !== 'undefined') {
      toReturn['autoChargeInvoices'] = this.autoChargeInvoices;
    }
    if (typeof this.includeInFinancialRecords !== 'undefined') {
      toReturn['includeInFinancialRecords'] = this.includeInFinancialRecords;
    }
    if (typeof this.additionalEmailAddresses !== 'undefined') {
      toReturn['additionalEmailAddresses'] = this.additionalEmailAddresses;
    }
    if (typeof this.hasAlternativePaymentMethod !== 'undefined') {
      toReturn['hasAlternativePaymentMethod'] = this.hasAlternativePaymentMethod;
    }
    if (typeof this.stripeAccountId !== 'undefined') {
      toReturn['stripeAccountId'] = this.stripeAccountId;
    }
    if (typeof this.merchantType !== 'undefined') {
      toReturn['merchantType'] = this.merchantType;
    }
    return toReturn;
  }
}
class ResetPaymentFacilitatorRequest {
  static fromProto(proto) {
    let m = new ResetPaymentFacilitatorRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class RetailConfiguration {
  static fromProto(proto) {
    let m = new RetailConfiguration();
    m = Object.assign(m, proto);
    if (proto.defaultCustomerConfiguration) {
      m.defaultCustomerConfiguration = DefaultCustomerConfiguration.fromProto(proto.defaultCustomerConfiguration);
    }
    if (proto.currencyConversionRate) {
      m.currencyConversionRate = parseInt(proto.currencyConversionRate, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.retailGroupId !== 'undefined') {
      toReturn['retailGroupId'] = this.retailGroupId;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.defaultCustomerConfiguration !== 'undefined' && this.defaultCustomerConfiguration !== null) {
      toReturn['defaultCustomerConfiguration'] = 'toApiJson' in this.defaultCustomerConfiguration ? this.defaultCustomerConfiguration.toApiJson() : this.defaultCustomerConfiguration;
    }
    if (typeof this.currencyConversionRate !== 'undefined') {
      toReturn['currencyConversionRate'] = this.currencyConversionRate;
    }
    return toReturn;
  }
}
class GetMultiRetailConfigurationsResponseRetailConfigurationsEntry {
  static fromProto(proto) {
    let m = new GetMultiRetailConfigurationsResponseRetailConfigurationsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = RetailConfiguration.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class SearchMerchantsRequest {
  static fromProto(proto) {
    let m = new SearchMerchantsRequest();
    m = Object.assign(m, proto);
    if (proto.sortBy) {
      m.sortBy = enumStringToValue$k(SearchMerchantsRequestSortBy, proto.sortBy);
    }
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue$k(SortDirection, proto.sortDirection);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.sortBy !== 'undefined') {
      toReturn['sortBy'] = this.sortBy;
    }
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class SearchMerchantsResponse {
  static fromProto(proto) {
    let m = new SearchMerchantsResponse();
    m = Object.assign(m, proto);
    if (proto.merchants) {
      m.merchants = proto.merchants.map(Merchant.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchants !== 'undefined' && this.merchants !== null) {
      toReturn['merchants'] = 'toApiJson' in this.merchants ? this.merchants.toApiJson() : this.merchants;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class SetAutoChargeInvoicesRequest {
  static fromProto(proto) {
    let m = new SetAutoChargeInvoicesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.autoChargeInvoices !== 'undefined') {
      toReturn['autoChargeInvoices'] = this.autoChargeInvoices;
    }
    return toReturn;
  }
}
class SetAutoPostInvoicesRequest {
  static fromProto(proto) {
    let m = new SetAutoPostInvoicesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.shouldAutoPostInvoices !== 'undefined') {
      toReturn['shouldAutoPostInvoices'] = this.shouldAutoPostInvoices;
    }
    return toReturn;
  }
}
class SetDefaultPaymentCardRequest {
  static fromProto(proto) {
    let m = new SetDefaultPaymentCardRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.cardId !== 'undefined') {
      toReturn['cardId'] = this.cardId;
    }
    return toReturn;
  }
}
class SetHasAlternativePaymentMethodRequest {
  static fromProto(proto) {
    let m = new SetHasAlternativePaymentMethodRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.hasAlternativePaymentMethod !== 'undefined') {
      toReturn['hasAlternativePaymentMethod'] = this.hasAlternativePaymentMethod;
    }
    return toReturn;
  }
}
class SetIncludeInFinancialRecordsRequest {
  static fromProto(proto) {
    let m = new SetIncludeInFinancialRecordsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.includeInFinancialRecords !== 'undefined') {
      toReturn['includeInFinancialRecords'] = this.includeInFinancialRecords;
    }
    return toReturn;
  }
}
class SetNextRetailInvoiceSequenceRequest {
  static fromProto(proto) {
    let m = new SetNextRetailInvoiceSequenceRequest();
    m = Object.assign(m, proto);
    if (proto.nextRetailInvoiceSequence) {
      m.nextRetailInvoiceSequence = parseInt(proto.nextRetailInvoiceSequence, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.nextRetailInvoiceSequence !== 'undefined') {
      toReturn['nextRetailInvoiceSequence'] = this.nextRetailInvoiceSequence;
    }
    return toReturn;
  }
}
class UpdateMerchantRequest {
  static fromProto(proto) {
    let m = new UpdateMerchantRequest();
    m = Object.assign(m, proto);
    if (proto.includeInFinancialRecords) {
      m.includeInFinancialRecords = UpdateMerchantRequestIncludeInFinancialRecords.fromProto(proto.includeInFinancialRecords);
    }
    if (proto.merchantType) {
      m.merchantType = enumStringToValue$k(MerchantType, proto.merchantType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.zipCode !== 'undefined') {
      toReturn['zipCode'] = this.zipCode;
    }
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.contactName !== 'undefined') {
      toReturn['contactName'] = this.contactName;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.additionalEmailAddresses !== 'undefined') {
      toReturn['additionalEmailAddresses'] = this.additionalEmailAddresses;
    }
    if (typeof this.includeInFinancialRecords !== 'undefined' && this.includeInFinancialRecords !== null) {
      toReturn['includeInFinancialRecords'] = 'toApiJson' in this.includeInFinancialRecords ? this.includeInFinancialRecords.toApiJson() : this.includeInFinancialRecords;
    }
    if (typeof this.hasAlternativePaymentMethod !== 'undefined') {
      toReturn['hasAlternativePaymentMethod'] = this.hasAlternativePaymentMethod;
    }
    if (typeof this.merchantType !== 'undefined') {
      toReturn['merchantType'] = this.merchantType;
    }
    return toReturn;
  }
}
class UpsertDefaultRetailCustomerConfigurationRequest {
  static fromProto(proto) {
    let m = new UpsertDefaultRetailCustomerConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.defaultCustomerConfiguration) {
      m.defaultCustomerConfiguration = DefaultCustomerConfiguration.fromProto(proto.defaultCustomerConfiguration);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.retailGroupId !== 'undefined') {
      toReturn['retailGroupId'] = this.retailGroupId;
    }
    if (typeof this.defaultCustomerConfiguration !== 'undefined' && this.defaultCustomerConfiguration !== null) {
      toReturn['defaultCustomerConfiguration'] = 'toApiJson' in this.defaultCustomerConfiguration ? this.defaultCustomerConfiguration.toApiJson() : this.defaultCustomerConfiguration;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpsertRetailConfigurationRequest {
  static fromProto(proto) {
    let m = new UpsertRetailConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.currencyConversionRate) {
      m.currencyConversionRate = parseInt(proto.currencyConversionRate, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.retailGroupId !== 'undefined') {
      toReturn['retailGroupId'] = this.retailGroupId;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.currencyConversionRate !== 'undefined') {
      toReturn['currencyConversionRate'] = this.currencyConversionRate;
    }
    return toReturn;
  }
}
function enumStringToValue$j(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ListMerchantBillingReportsRequest {
  static fromProto(proto) {
    let m = new ListMerchantBillingReportsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListMerchantBillingReportsResponse {
  static fromProto(proto) {
    let m = new ListMerchantBillingReportsResponse();
    m = Object.assign(m, proto);
    if (proto.reports) {
      m.reports = proto.reports.map(MerchantReport.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reports !== 'undefined' && this.reports !== null) {
      toReturn['reports'] = 'toApiJson' in this.reports ? this.reports.toApiJson() : this.reports;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class MerchantReport {
  static fromProto(proto) {
    let m = new MerchantReport();
    m = Object.assign(m, proto);
    if (proto.year) {
      m.year = parseInt(proto.year, 10);
    }
    if (proto.month) {
      m.month = enumStringToValue$j(Month, proto.month);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.status) {
      m.status = enumStringToValue$j(MerchantReportStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.year !== 'undefined') {
      toReturn['year'] = this.year;
    }
    if (typeof this.month !== 'undefined') {
      toReturn['month'] = this.month;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
function enumStringToValue$i(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateMeteredComponentRequest {
  static fromProto(proto) {
    let m = new CreateMeteredComponentRequest();
    m = Object.assign(m, proto);
    if (proto.component) {
      m.component = MeteredComponent.fromProto(proto.component);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.component !== 'undefined' && this.component !== null) {
      toReturn['component'] = 'toApiJson' in this.component ? this.component.toApiJson() : this.component;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    return toReturn;
  }
}
class MeteredComponent {
  static fromProto(proto) {
    let m = new MeteredComponent();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.componentId !== 'undefined') {
      toReturn['componentId'] = this.componentId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class TickComponentUsageRequest {
  static fromProto(proto) {
    let m = new TickComponentUsageRequest();
    m = Object.assign(m, proto);
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.componentId !== 'undefined') {
      toReturn['componentId'] = this.componentId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    return toReturn;
  }
}
function enumStringToValue$h(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class RetailPaymentACHDetails {
  static fromProto(proto) {
    let m = new RetailPaymentACHDetails();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lastFourDigits !== 'undefined') {
      toReturn['lastFourDigits'] = this.lastFourDigits;
    }
    return toReturn;
  }
}
class RetailPaymentACSSDetails {
  static fromProto(proto) {
    let m = new RetailPaymentACSSDetails();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lastFourDigits !== 'undefined') {
      toReturn['lastFourDigits'] = this.lastFourDigits;
    }
    return toReturn;
  }
}
class Adjustment {
  static fromProto(proto) {
    let m = new Adjustment();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.fee) {
      m.fee = parseInt(proto.fee, 10);
    }
    if (proto.net) {
      m.net = parseInt(proto.net, 10);
    }
    if (proto.refund) {
      m.refund = RetailRefund.fromProto(proto.refund);
    }
    if (proto.dispute) {
      m.dispute = Dispute.fromProto(proto.dispute);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.fee !== 'undefined') {
      toReturn['fee'] = this.fee;
    }
    if (typeof this.net !== 'undefined') {
      toReturn['net'] = this.net;
    }
    if (typeof this.refund !== 'undefined' && this.refund !== null) {
      toReturn['refund'] = 'toApiJson' in this.refund ? this.refund.toApiJson() : this.refund;
    }
    if (typeof this.dispute !== 'undefined' && this.dispute !== null) {
      toReturn['dispute'] = 'toApiJson' in this.dispute ? this.dispute.toApiJson() : this.dispute;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class RetailPaymentCardDetails {
  static fromProto(proto) {
    let m = new RetailPaymentCardDetails();
    m = Object.assign(m, proto);
    if (proto.cardType) {
      m.cardType = enumStringToValue$h(CardType, proto.cardType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cardType !== 'undefined') {
      toReturn['cardType'] = this.cardType;
    }
    if (typeof this.lastFourDigits !== 'undefined') {
      toReturn['lastFourDigits'] = this.lastFourDigits;
    }
    return toReturn;
  }
}
class CloseRetailDisputeRequest {
  static fromProto(proto) {
    let m = new CloseRetailDisputeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.disputeId !== 'undefined') {
      toReturn['disputeId'] = this.disputeId;
    }
    return toReturn;
  }
}
class ConfigureRetailPaymentProviderRequest {
  static fromProto(proto) {
    let m = new ConfigureRetailPaymentProviderRequest();
    m = Object.assign(m, proto);
    if (proto.paymentFacilitatorType) {
      m.paymentFacilitatorType = enumStringToValue$h(PaymentFacilitatorType, proto.paymentFacilitatorType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.failureUrl !== 'undefined') {
      toReturn['failureUrl'] = this.failureUrl;
    }
    if (typeof this.successUrl !== 'undefined') {
      toReturn['successUrl'] = this.successUrl;
    }
    if (typeof this.paymentFacilitatorType !== 'undefined') {
      toReturn['paymentFacilitatorType'] = this.paymentFacilitatorType;
    }
    return toReturn;
  }
}
class ConfigureRetailPaymentProviderResponse {
  static fromProto(proto) {
    let m = new ConfigureRetailPaymentProviderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stripeUrl !== 'undefined') {
      toReturn['stripeUrl'] = this.stripeUrl;
    }
    if (typeof this.error !== 'undefined') {
      toReturn['error'] = this.error;
    }
    return toReturn;
  }
}
class ConfirmRetailPaymentRequest {
  static fromProto(proto) {
    let m = new ConfirmRetailPaymentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class Dispute {
  static fromProto(proto) {
    let m = new Dispute();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$h(DisputeStatus, proto.status);
    }
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.evidence) {
      m.evidence = DisputeEvidence.fromProto(proto.evidence);
    }
    if (proto.evidenceDetails) {
      m.evidenceDetails = DisputeEvidenceDetails.fromProto(proto.evidenceDetails);
    }
    if (proto.fee) {
      m.fee = parseInt(proto.fee, 10);
    }
    if (proto.paymentReferenceType) {
      m.paymentReferenceType = enumStringToValue$h(RetailPaymentReferenceType, proto.paymentReferenceType);
    }
    if (proto.paymentReceivedAt) {
      m.paymentReceivedAt = new Date(proto.paymentReceivedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paymentId !== 'undefined') {
      toReturn['paymentId'] = this.paymentId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.evidence !== 'undefined' && this.evidence !== null) {
      toReturn['evidence'] = 'toApiJson' in this.evidence ? this.evidence.toApiJson() : this.evidence;
    }
    if (typeof this.evidenceDetails !== 'undefined' && this.evidenceDetails !== null) {
      toReturn['evidenceDetails'] = 'toApiJson' in this.evidenceDetails ? this.evidenceDetails.toApiJson() : this.evidenceDetails;
    }
    if (typeof this.isChargeRefundable !== 'undefined') {
      toReturn['isChargeRefundable'] = this.isChargeRefundable;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.fee !== 'undefined') {
      toReturn['fee'] = this.fee;
    }
    if (typeof this.feeCurrencyCode !== 'undefined') {
      toReturn['feeCurrencyCode'] = this.feeCurrencyCode;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.paymentReferenceId !== 'undefined') {
      toReturn['paymentReferenceId'] = this.paymentReferenceId;
    }
    if (typeof this.paymentReferenceType !== 'undefined') {
      toReturn['paymentReferenceType'] = this.paymentReferenceType;
    }
    if (typeof this.paymentDescription !== 'undefined') {
      toReturn['paymentDescription'] = this.paymentDescription;
    }
    if (typeof this.paymentReceivedAt !== 'undefined' && this.paymentReceivedAt !== null) {
      toReturn['paymentReceivedAt'] = 'toApiJson' in this.paymentReceivedAt ? this.paymentReceivedAt.toApiJson() : this.paymentReceivedAt;
    }
    return toReturn;
  }
}
class DisputeEvidence {
  static fromProto(proto) {
    let m = new DisputeEvidence();
    m = Object.assign(m, proto);
    if (proto.customerCommunication) {
      m.customerCommunication = File.fromProto(proto.customerCommunication);
    }
    if (proto.customerSignature) {
      m.customerSignature = File.fromProto(proto.customerSignature);
    }
    if (proto.shippingDocumentation) {
      m.shippingDocumentation = File.fromProto(proto.shippingDocumentation);
    }
    if (proto.receipt) {
      m.receipt = File.fromProto(proto.receipt);
    }
    if (proto.uncategorizedFile) {
      m.uncategorizedFile = File.fromProto(proto.uncategorizedFile);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerCommunication !== 'undefined' && this.customerCommunication !== null) {
      toReturn['customerCommunication'] = 'toApiJson' in this.customerCommunication ? this.customerCommunication.toApiJson() : this.customerCommunication;
    }
    if (typeof this.customerSignature !== 'undefined' && this.customerSignature !== null) {
      toReturn['customerSignature'] = 'toApiJson' in this.customerSignature ? this.customerSignature.toApiJson() : this.customerSignature;
    }
    if (typeof this.shippingDocumentation !== 'undefined' && this.shippingDocumentation !== null) {
      toReturn['shippingDocumentation'] = 'toApiJson' in this.shippingDocumentation ? this.shippingDocumentation.toApiJson() : this.shippingDocumentation;
    }
    if (typeof this.receipt !== 'undefined' && this.receipt !== null) {
      toReturn['receipt'] = 'toApiJson' in this.receipt ? this.receipt.toApiJson() : this.receipt;
    }
    if (typeof this.uncategorizedFile !== 'undefined' && this.uncategorizedFile !== null) {
      toReturn['uncategorizedFile'] = 'toApiJson' in this.uncategorizedFile ? this.uncategorizedFile.toApiJson() : this.uncategorizedFile;
    }
    if (typeof this.billingAddress !== 'undefined') {
      toReturn['billingAddress'] = this.billingAddress;
    }
    if (typeof this.customerEmailAddress !== 'undefined') {
      toReturn['customerEmailAddress'] = this.customerEmailAddress;
    }
    if (typeof this.customerName !== 'undefined') {
      toReturn['customerName'] = this.customerName;
    }
    if (typeof this.productDescription !== 'undefined') {
      toReturn['productDescription'] = this.productDescription;
    }
    return toReturn;
  }
}
class SubmitEvidenceRequestDisputeEvidence {
  static fromProto(proto) {
    let m = new SubmitEvidenceRequestDisputeEvidence();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.billingAddress !== 'undefined') {
      toReturn['billingAddress'] = this.billingAddress;
    }
    if (typeof this.customerEmailAddress !== 'undefined') {
      toReturn['customerEmailAddress'] = this.customerEmailAddress;
    }
    if (typeof this.customerName !== 'undefined') {
      toReturn['customerName'] = this.customerName;
    }
    if (typeof this.productDescription !== 'undefined') {
      toReturn['productDescription'] = this.productDescription;
    }
    if (typeof this.customerSignatureFileId !== 'undefined') {
      toReturn['customerSignatureFileId'] = this.customerSignatureFileId;
    }
    if (typeof this.customerCommunicationFileId !== 'undefined') {
      toReturn['customerCommunicationFileId'] = this.customerCommunicationFileId;
    }
    if (typeof this.receiptFileId !== 'undefined') {
      toReturn['receiptFileId'] = this.receiptFileId;
    }
    if (typeof this.shippingDocumentationFileId !== 'undefined') {
      toReturn['shippingDocumentationFileId'] = this.shippingDocumentationFileId;
    }
    if (typeof this.uncategorizedFileId !== 'undefined') {
      toReturn['uncategorizedFileId'] = this.uncategorizedFileId;
    }
    return toReturn;
  }
}
class DisputeEvidenceDetails {
  static fromProto(proto) {
    let m = new DisputeEvidenceDetails();
    m = Object.assign(m, proto);
    if (proto.dueBy) {
      m.dueBy = new Date(proto.dueBy);
    }
    if (proto.submissionCount) {
      m.submissionCount = parseInt(proto.submissionCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dueBy !== 'undefined' && this.dueBy !== null) {
      toReturn['dueBy'] = 'toApiJson' in this.dueBy ? this.dueBy.toApiJson() : this.dueBy;
    }
    if (typeof this.hasEvidence !== 'undefined') {
      toReturn['hasEvidence'] = this.hasEvidence;
    }
    if (typeof this.pastDue !== 'undefined') {
      toReturn['pastDue'] = this.pastDue;
    }
    if (typeof this.submissionCount !== 'undefined') {
      toReturn['submissionCount'] = this.submissionCount;
    }
    return toReturn;
  }
}
class File {
  static fromProto(proto) {
    let m = new File();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.filename !== 'undefined') {
      toReturn['filename'] = this.filename;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class GetRetailDisputeRequest {
  static fromProto(proto) {
    let m = new GetRetailDisputeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.disputeId !== 'undefined') {
      toReturn['disputeId'] = this.disputeId;
    }
    return toReturn;
  }
}
class GetRetailDisputeResponse {
  static fromProto(proto) {
    let m = new GetRetailDisputeResponse();
    m = Object.assign(m, proto);
    if (proto.dispute) {
      m.dispute = Dispute.fromProto(proto.dispute);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dispute !== 'undefined' && this.dispute !== null) {
      toReturn['dispute'] = 'toApiJson' in this.dispute ? this.dispute.toApiJson() : this.dispute;
    }
    return toReturn;
  }
}
class GetRetailPaymentProviderRequest {
  static fromProto(proto) {
    let m = new GetRetailPaymentProviderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetRetailPaymentProviderResponse {
  static fromProto(proto) {
    let m = new GetRetailPaymentProviderResponse();
    m = Object.assign(m, proto);
    if (proto.paymentFacilitatorType) {
      m.paymentFacilitatorType = enumStringToValue$h(PaymentFacilitatorType, proto.paymentFacilitatorType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statementDescriptor !== 'undefined') {
      toReturn['statementDescriptor'] = this.statementDescriptor;
    }
    if (typeof this.stripeConnectId !== 'undefined') {
      toReturn['stripeConnectId'] = this.stripeConnectId;
    }
    if (typeof this.paymentFacilitatorType !== 'undefined') {
      toReturn['paymentFacilitatorType'] = this.paymentFacilitatorType;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    return toReturn;
  }
}
class GetRetailPaymentRequest {
  static fromProto(proto) {
    let m = new GetRetailPaymentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.paymentId !== 'undefined') {
      toReturn['paymentId'] = this.paymentId;
    }
    return toReturn;
  }
}
class GetRetailPaymentResponse {
  static fromProto(proto) {
    let m = new GetRetailPaymentResponse();
    m = Object.assign(m, proto);
    if (proto.payment) {
      m.payment = RetailPayment.fromProto(proto.payment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.payment !== 'undefined' && this.payment !== null) {
      toReturn['payment'] = 'toApiJson' in this.payment ? this.payment.toApiJson() : this.payment;
    }
    return toReturn;
  }
}
class GetWholesaleProviderPublicKeyRequest {
  static fromProto(proto) {
    let m = new GetWholesaleProviderPublicKeyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    return toReturn;
  }
}
class GetWholesaleProviderPublicKeyResponse {
  static fromProto(proto) {
    let m = new GetWholesaleProviderPublicKeyResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.publcApiKey !== 'undefined') {
      toReturn['publcApiKey'] = this.publcApiKey;
    }
    return toReturn;
  }
}
class ListPaymentRequestListPaymentFilters {
  static fromProto(proto) {
    let m = new ListPaymentRequestListPaymentFilters();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.allocationIds !== 'undefined') {
      toReturn['allocationIds'] = this.allocationIds;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    return toReturn;
  }
}
class ListPaymentRequest {
  static fromProto(proto) {
    let m = new ListPaymentRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListPaymentRequestListPaymentFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListPaymentResponse {
  static fromProto(proto) {
    let m = new ListPaymentResponse();
    m = Object.assign(m, proto);
    if (proto.payments) {
      m.payments = proto.payments.map(Payment.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.payments !== 'undefined' && this.payments !== null) {
      toReturn['payments'] = 'toApiJson' in this.payments ? this.payments.toApiJson() : this.payments;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListRetailDisputesRequestListRetailDisputesFilters {
  static fromProto(proto) {
    let m = new ListRetailDisputesRequestListRetailDisputesFilters();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$h(DisputeStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class ListRetailDisputesRequest {
  static fromProto(proto) {
    let m = new ListRetailDisputesRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListRetailDisputesRequestListRetailDisputesFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListRetailDisputesResponse {
  static fromProto(proto) {
    let m = new ListRetailDisputesResponse();
    m = Object.assign(m, proto);
    if (proto.disputes) {
      m.disputes = proto.disputes.map(Dispute.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.disputes !== 'undefined' && this.disputes !== null) {
      toReturn['disputes'] = 'toApiJson' in this.disputes ? this.disputes.toApiJson() : this.disputes;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListRetailPaymentsRequestListRetailPaymentsFilters {
  static fromProto(proto) {
    let m = new ListRetailPaymentsRequestListRetailPaymentsFilters();
    m = Object.assign(m, proto);
    if (proto.createdDateGte) {
      m.createdDateGte = new Date(proto.createdDateGte);
    }
    if (proto.createdDateLte) {
      m.createdDateLte = new Date(proto.createdDateLte);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.payoutId !== 'undefined') {
      toReturn['payoutId'] = this.payoutId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.createdDateGte !== 'undefined' && this.createdDateGte !== null) {
      toReturn['createdDateGte'] = 'toApiJson' in this.createdDateGte ? this.createdDateGte.toApiJson() : this.createdDateGte;
    }
    if (typeof this.createdDateLte !== 'undefined' && this.createdDateLte !== null) {
      toReturn['createdDateLte'] = 'toApiJson' in this.createdDateLte ? this.createdDateLte.toApiJson() : this.createdDateLte;
    }
    return toReturn;
  }
}
class ListRetailPaymentsRequest {
  static fromProto(proto) {
    let m = new ListRetailPaymentsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListRetailPaymentsRequestListRetailPaymentsFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListRetailPaymentsResponse {
  static fromProto(proto) {
    let m = new ListRetailPaymentsResponse();
    m = Object.assign(m, proto);
    if (proto.payments) {
      m.payments = proto.payments.map(RetailPayment.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.payments !== 'undefined' && this.payments !== null) {
      toReturn['payments'] = 'toApiJson' in this.payments ? this.payments.toApiJson() : this.payments;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListRetailTransactionsRequestListRetailTransactionsFilters {
  static fromProto(proto) {
    let m = new ListRetailTransactionsRequestListRetailTransactionsFilters();
    m = Object.assign(m, proto);
    if (proto.createdDateGte) {
      m.createdDateGte = new Date(proto.createdDateGte);
    }
    if (proto.createdDateLte) {
      m.createdDateLte = new Date(proto.createdDateLte);
    }
    if (proto.type) {
      m.type = enumStringToValue$h(RetailTransactionType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.payoutId !== 'undefined') {
      toReturn['payoutId'] = this.payoutId;
    }
    if (typeof this.createdDateGte !== 'undefined' && this.createdDateGte !== null) {
      toReturn['createdDateGte'] = 'toApiJson' in this.createdDateGte ? this.createdDateGte.toApiJson() : this.createdDateGte;
    }
    if (typeof this.createdDateLte !== 'undefined' && this.createdDateLte !== null) {
      toReturn['createdDateLte'] = 'toApiJson' in this.createdDateLte ? this.createdDateLte.toApiJson() : this.createdDateLte;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
class ListRetailTransactionsRequest {
  static fromProto(proto) {
    let m = new ListRetailTransactionsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListRetailTransactionsRequestListRetailTransactionsFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListRetailTransactionsResponse {
  static fromProto(proto) {
    let m = new ListRetailTransactionsResponse();
    m = Object.assign(m, proto);
    if (proto.transactions) {
      m.transactions = proto.transactions.map(RetailTransaction.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.transactions !== 'undefined' && this.transactions !== null) {
      toReturn['transactions'] = 'toApiJson' in this.transactions ? this.transactions.toApiJson() : this.transactions;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class PrepareRetailPaymentRequestOrder {
  static fromProto(proto) {
    let m = new PrepareRetailPaymentRequestOrder();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.paymentMethodId !== 'undefined') {
      toReturn['paymentMethodId'] = this.paymentMethodId;
    }
    return toReturn;
  }
}
class Payment {
  static fromProto(proto) {
    let m = new Payment();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$h(Currency, proto.currency);
    }
    if (proto.paymentSource) {
      m.paymentSource = enumStringToValue$h(PaymentSource, proto.paymentSource);
    }
    if (proto.allocations) {
      m.allocations = proto.allocations.map(PaymentPaymentAllocation.fromProto);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue$h(PaymentStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.paymentSource !== 'undefined') {
      toReturn['paymentSource'] = this.paymentSource;
    }
    if (typeof this.allocations !== 'undefined' && this.allocations !== null) {
      toReturn['allocations'] = 'toApiJson' in this.allocations ? this.allocations.toApiJson() : this.allocations;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.externalReferenceId !== 'undefined') {
      toReturn['externalReferenceId'] = this.externalReferenceId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class PaymentPaymentAllocation {
  static fromProto(proto) {
    let m = new PaymentPaymentAllocation();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.type) {
      m.type = enumStringToValue$h(PaymentAllocationType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.referenceId !== 'undefined') {
      toReturn['referenceId'] = this.referenceId;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class PaymentIntent {
  static fromProto(proto) {
    let m = new PaymentIntent();
    m = Object.assign(m, proto);
    if (proto.paymentIntentStatus) {
      m.paymentIntentStatus = enumStringToValue$h(PaymentIntentStatus, proto.paymentIntentStatus);
    }
    if (proto.paymentMethodType) {
      m.paymentMethodType = enumStringToValue$h(PaymentMethodType, proto.paymentMethodType);
    }
    if (proto.lastErrorCode) {
      m.lastErrorCode = enumStringToValue$h(PaymentErrorCode, proto.lastErrorCode);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paymentIntentStatus !== 'undefined') {
      toReturn['paymentIntentStatus'] = this.paymentIntentStatus;
    }
    if (typeof this.paymentMethodType !== 'undefined') {
      toReturn['paymentMethodType'] = this.paymentMethodType;
    }
    if (typeof this.lastErrorCode !== 'undefined') {
      toReturn['lastErrorCode'] = this.lastErrorCode;
    }
    return toReturn;
  }
}
class PrepareRetailPaymentRequest {
  static fromProto(proto) {
    let m = new PrepareRetailPaymentRequest();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = PrepareRetailPaymentRequestOrder.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class PrepareRetailPaymentResponse {
  static fromProto(proto) {
    let m = new PrepareRetailPaymentResponse();
    m = Object.assign(m, proto);
    if (proto.paymentIntent) {
      m.paymentIntent = PaymentIntent.fromProto(proto.paymentIntent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stripeClientSecret !== 'undefined') {
      toReturn['stripeClientSecret'] = this.stripeClientSecret;
    }
    if (typeof this.intentId !== 'undefined') {
      toReturn['intentId'] = this.intentId;
    }
    if (typeof this.paymentIntent !== 'undefined' && this.paymentIntent !== null) {
      toReturn['paymentIntent'] = 'toApiJson' in this.paymentIntent ? this.paymentIntent.toApiJson() : this.paymentIntent;
    }
    return toReturn;
  }
}
class RefundRetailPaymentRequest {
  static fromProto(proto) {
    let m = new RefundRetailPaymentRequest();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.reason) {
      m.reason = enumStringToValue$h(RetailRefundReason, proto.reason);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.paymentId !== 'undefined') {
      toReturn['paymentId'] = this.paymentId;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    return toReturn;
  }
}
class RefundRetailPaymentResponse {
  static fromProto(proto) {
    let m = new RefundRetailPaymentResponse();
    m = Object.assign(m, proto);
    if (proto.payment) {
      m.payment = RetailPayment.fromProto(proto.payment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.payment !== 'undefined' && this.payment !== null) {
      toReturn['payment'] = 'toApiJson' in this.payment ? this.payment.toApiJson() : this.payment;
    }
    return toReturn;
  }
}
class RetailPayment {
  static fromProto(proto) {
    let m = new RetailPayment();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.referenceType) {
      m.referenceType = enumStringToValue$h(RetailPaymentReferenceType, proto.referenceType);
    }
    if (proto.status) {
      m.status = enumStringToValue$h(PaymentStatus, proto.status);
    }
    if (proto.applicationFee) {
      m.applicationFee = parseInt(proto.applicationFee, 10);
    }
    if (proto.dispute) {
      m.dispute = Dispute.fromProto(proto.dispute);
    }
    if (proto.cardDetails) {
      m.cardDetails = RetailPaymentCardDetails.fromProto(proto.cardDetails);
    }
    if (proto.refunds) {
      m.refunds = proto.refunds.map(RetailRefund.fromProto);
    }
    if (proto.paymentMethodDetailsType) {
      m.paymentMethodDetailsType = enumStringToValue$h(RetailPaymentPaymentMethodDetailsType, proto.paymentMethodDetailsType);
    }
    if (proto.achDebitDetails) {
      m.achDebitDetails = RetailPaymentACHDetails.fromProto(proto.achDebitDetails);
    }
    if (proto.acssDebitDetails) {
      m.acssDebitDetails = RetailPaymentACSSDetails.fromProto(proto.acssDebitDetails);
    }
    if (proto.paymentFacilitatorFee) {
      m.paymentFacilitatorFee = parseInt(proto.paymentFacilitatorFee, 10);
    }
    if (proto.paymentFacilitatorType) {
      m.paymentFacilitatorType = enumStringToValue$h(PaymentFacilitatorType, proto.paymentFacilitatorType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.referenceId !== 'undefined') {
      toReturn['referenceId'] = this.referenceId;
    }
    if (typeof this.referenceType !== 'undefined') {
      toReturn['referenceType'] = this.referenceType;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.failureCode !== 'undefined') {
      toReturn['failureCode'] = this.failureCode;
    }
    if (typeof this.failureMessage !== 'undefined') {
      toReturn['failureMessage'] = this.failureMessage;
    }
    if (typeof this.applicationFee !== 'undefined') {
      toReturn['applicationFee'] = this.applicationFee;
    }
    if (typeof this.disputed !== 'undefined') {
      toReturn['disputed'] = this.disputed;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.dispute !== 'undefined' && this.dispute !== null) {
      toReturn['dispute'] = 'toApiJson' in this.dispute ? this.dispute.toApiJson() : this.dispute;
    }
    if (typeof this.cardDetails !== 'undefined' && this.cardDetails !== null) {
      toReturn['cardDetails'] = 'toApiJson' in this.cardDetails ? this.cardDetails.toApiJson() : this.cardDetails;
    }
    if (typeof this.refunds !== 'undefined' && this.refunds !== null) {
      toReturn['refunds'] = 'toApiJson' in this.refunds ? this.refunds.toApiJson() : this.refunds;
    }
    if (typeof this.paymentMethodDetailsType !== 'undefined') {
      toReturn['paymentMethodDetailsType'] = this.paymentMethodDetailsType;
    }
    if (typeof this.achDebitDetails !== 'undefined' && this.achDebitDetails !== null) {
      toReturn['achDebitDetails'] = 'toApiJson' in this.achDebitDetails ? this.achDebitDetails.toApiJson() : this.achDebitDetails;
    }
    if (typeof this.acssDebitDetails !== 'undefined' && this.acssDebitDetails !== null) {
      toReturn['acssDebitDetails'] = 'toApiJson' in this.acssDebitDetails ? this.acssDebitDetails.toApiJson() : this.acssDebitDetails;
    }
    if (typeof this.paymentFacilitatorFee !== 'undefined') {
      toReturn['paymentFacilitatorFee'] = this.paymentFacilitatorFee;
    }
    if (typeof this.paymentFacilitatorType !== 'undefined') {
      toReturn['paymentFacilitatorType'] = this.paymentFacilitatorType;
    }
    return toReturn;
  }
}
class RetailPaymentsEnabledRequest {
  static fromProto(proto) {
    let m = new RetailPaymentsEnabledRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class RetailPaymentsEnabledResponse {
  static fromProto(proto) {
    let m = new RetailPaymentsEnabledResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    return toReturn;
  }
}
class RetailRefund {
  static fromProto(proto) {
    let m = new RetailRefund();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.refundReason) {
      m.refundReason = enumStringToValue$h(RetailRefundReason, proto.refundReason);
    }
    if (proto.status) {
      m.status = enumStringToValue$h(RetailRefundStatus, proto.status);
    }
    if (proto.failureReason) {
      m.failureReason = enumStringToValue$h(RetailRefundFailureReason, proto.failureReason);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.payment) {
      m.payment = RetailPayment.fromProto(proto.payment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.refundReason !== 'undefined') {
      toReturn['refundReason'] = this.refundReason;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.failureReason !== 'undefined') {
      toReturn['failureReason'] = this.failureReason;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.payment !== 'undefined' && this.payment !== null) {
      toReturn['payment'] = 'toApiJson' in this.payment ? this.payment.toApiJson() : this.payment;
    }
    return toReturn;
  }
}
class RetailStatusRequest {
  static fromProto(proto) {
    let m = new RetailStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class RetailStatusResponse {
  static fromProto(proto) {
    let m = new RetailStatusResponse();
    m = Object.assign(m, proto);
    if (proto.requirements) {
      m.requirements = RetailStatusResponseVerificationRequirements.fromProto(proto.requirements);
    }
    if (proto.futureRequirements) {
      m.futureRequirements = RetailStatusResponseVerificationRequirements.fromProto(proto.futureRequirements);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.supportedRegion !== 'undefined') {
      toReturn['supportedRegion'] = this.supportedRegion;
    }
    if (typeof this.canAcceptPayment !== 'undefined') {
      toReturn['canAcceptPayment'] = this.canAcceptPayment;
    }
    if (typeof this.requirements !== 'undefined' && this.requirements !== null) {
      toReturn['requirements'] = 'toApiJson' in this.requirements ? this.requirements.toApiJson() : this.requirements;
    }
    if (typeof this.disabledReason !== 'undefined') {
      toReturn['disabledReason'] = this.disabledReason;
    }
    if (typeof this.futureRequirements !== 'undefined' && this.futureRequirements !== null) {
      toReturn['futureRequirements'] = 'toApiJson' in this.futureRequirements ? this.futureRequirements.toApiJson() : this.futureRequirements;
    }
    return toReturn;
  }
}
class RetailTransaction {
  static fromProto(proto) {
    let m = new RetailTransaction();
    m = Object.assign(m, proto);
    if (proto.payment) {
      m.payment = RetailPayment.fromProto(proto.payment);
    }
    if (proto.refund) {
      m.refund = RetailRefund.fromProto(proto.refund);
    }
    if (proto.payoutFailure) {
      m.payoutFailure = RetailPayout.fromProto(proto.payoutFailure);
    }
    if (proto.adjustment) {
      m.adjustment = Adjustment.fromProto(proto.adjustment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.payment !== 'undefined' && this.payment !== null) {
      toReturn['payment'] = 'toApiJson' in this.payment ? this.payment.toApiJson() : this.payment;
    }
    if (typeof this.refund !== 'undefined' && this.refund !== null) {
      toReturn['refund'] = 'toApiJson' in this.refund ? this.refund.toApiJson() : this.refund;
    }
    if (typeof this.payoutFailure !== 'undefined' && this.payoutFailure !== null) {
      toReturn['payoutFailure'] = 'toApiJson' in this.payoutFailure ? this.payoutFailure.toApiJson() : this.payoutFailure;
    }
    if (typeof this.adjustment !== 'undefined' && this.adjustment !== null) {
      toReturn['adjustment'] = 'toApiJson' in this.adjustment ? this.adjustment.toApiJson() : this.adjustment;
    }
    return toReturn;
  }
}
class SubmitEvidenceRequest {
  static fromProto(proto) {
    let m = new SubmitEvidenceRequest();
    m = Object.assign(m, proto);
    if (proto.evidence) {
      m.evidence = SubmitEvidenceRequestDisputeEvidence.fromProto(proto.evidence);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.disputeId !== 'undefined') {
      toReturn['disputeId'] = this.disputeId;
    }
    if (typeof this.paymentId !== 'undefined') {
      toReturn['paymentId'] = this.paymentId;
    }
    if (typeof this.evidence !== 'undefined' && this.evidence !== null) {
      toReturn['evidence'] = 'toApiJson' in this.evidence ? this.evidence.toApiJson() : this.evidence;
    }
    if (typeof this.submit !== 'undefined') {
      toReturn['submit'] = this.submit;
    }
    return toReturn;
  }
}
class UpdateRetailPaymentProviderRequest {
  static fromProto(proto) {
    let m = new UpdateRetailPaymentProviderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.statementDescriptor !== 'undefined') {
      toReturn['statementDescriptor'] = this.statementDescriptor;
    }
    return toReturn;
  }
}
class RetailStatusResponseVerificationError {
  static fromProto(proto) {
    let m = new RetailStatusResponseVerificationError();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requirement !== 'undefined') {
      toReturn['requirement'] = this.requirement;
    }
    if (typeof this.code !== 'undefined') {
      toReturn['code'] = this.code;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    return toReturn;
  }
}
class RetailStatusResponseVerificationRequirements {
  static fromProto(proto) {
    let m = new RetailStatusResponseVerificationRequirements();
    m = Object.assign(m, proto);
    if (proto.error) {
      m.error = proto.error.map(RetailStatusResponseVerificationError.fromProto);
    }
    if (proto.currentDeadline) {
      m.currentDeadline = new Date(proto.currentDeadline);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.due !== 'undefined') {
      toReturn['due'] = this.due;
    }
    if (typeof this.error !== 'undefined' && this.error !== null) {
      toReturn['error'] = 'toApiJson' in this.error ? this.error.toApiJson() : this.error;
    }
    if (typeof this.currentDeadline !== 'undefined' && this.currentDeadline !== null) {
      toReturn['currentDeadline'] = 'toApiJson' in this.currentDeadline ? this.currentDeadline.toApiJson() : this.currentDeadline;
    }
    if (typeof this.eventuallyDue !== 'undefined') {
      toReturn['eventuallyDue'] = this.eventuallyDue;
    }
    return toReturn;
  }
}
function enumStringToValue$g(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreatePricingPlanProductRequest {
  static fromProto(proto) {
    let m = new CreatePricingPlanProductRequest();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$g(Frequency, proto.frequency);
    }
    if (proto.pricing) {
      m.pricing = Object.keys(proto.pricing).reduce((obj, k) => {
        obj[k] = PricingPlanProductPricing.fromProto(proto.pricing[k]);
        return obj;
      }, {});
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    if (proto.strategy) {
      m.strategy = enumStringToValue$g(BillingStrategy, proto.strategy);
    }
    if (proto.volumeCommitment) {
      m.volumeCommitment = parseInt(proto.volumeCommitment, 10);
    }
    if (proto.volumeCommitmentStartsAt) {
      m.volumeCommitmentStartsAt = new Date(proto.volumeCommitmentStartsAt);
    }
    if (proto.volumeCommitmentEndsAt) {
      m.volumeCommitmentEndsAt = new Date(proto.volumeCommitmentEndsAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.strategy !== 'undefined') {
      toReturn['strategy'] = this.strategy;
    }
    if (typeof this.volumeCommitment !== 'undefined') {
      toReturn['volumeCommitment'] = this.volumeCommitment;
    }
    if (typeof this.volumeCommitmentStartsAt !== 'undefined' && this.volumeCommitmentStartsAt !== null) {
      toReturn['volumeCommitmentStartsAt'] = 'toApiJson' in this.volumeCommitmentStartsAt ? this.volumeCommitmentStartsAt.toApiJson() : this.volumeCommitmentStartsAt;
    }
    if (typeof this.volumeCommitmentEndsAt !== 'undefined' && this.volumeCommitmentEndsAt !== null) {
      toReturn['volumeCommitmentEndsAt'] = 'toApiJson' in this.volumeCommitmentEndsAt ? this.volumeCommitmentEndsAt.toApiJson() : this.volumeCommitmentEndsAt;
    }
    return toReturn;
  }
}
class CreatePricingPlanProductResponse {
  static fromProto(proto) {
    let m = new CreatePricingPlanProductResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    return toReturn;
  }
}
class DeletePricingPlanProductRequest {
  static fromProto(proto) {
    let m = new DeletePricingPlanProductRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    return toReturn;
  }
}
class GetMultiPricingPlanProductRequest {
  static fromProto(proto) {
    let m = new GetMultiPricingPlanProductRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.skus !== 'undefined') {
      toReturn['skus'] = this.skus;
    }
    return toReturn;
  }
}
class GetMultiPricingPlanProductResponse {
  static fromProto(proto) {
    let m = new GetMultiPricingPlanProductResponse();
    m = Object.assign(m, proto);
    if (proto.pricingPlanProducts) {
      m.pricingPlanProducts = proto.pricingPlanProducts.map(PricingPlanProduct.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanProducts !== 'undefined' && this.pricingPlanProducts !== null) {
      toReturn['pricingPlanProducts'] = 'toApiJson' in this.pricingPlanProducts ? this.pricingPlanProducts.toApiJson() : this.pricingPlanProducts;
    }
    return toReturn;
  }
}
class GetPricingPlanProductRequest {
  static fromProto(proto) {
    let m = new GetPricingPlanProductRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    return toReturn;
  }
}
class GetPricingPlanProductResponse {
  static fromProto(proto) {
    let m = new GetPricingPlanProductResponse();
    m = Object.assign(m, proto);
    if (proto.pricingPlanProduct) {
      m.pricingPlanProduct = PricingPlanProduct.fromProto(proto.pricingPlanProduct);
    }
    if (proto.pricingPlanDefaultStrategy) {
      m.pricingPlanDefaultStrategy = enumStringToValue$g(BillingStrategy, proto.pricingPlanDefaultStrategy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanProduct !== 'undefined' && this.pricingPlanProduct !== null) {
      toReturn['pricingPlanProduct'] = 'toApiJson' in this.pricingPlanProduct ? this.pricingPlanProduct.toApiJson() : this.pricingPlanProduct;
    }
    if (typeof this.pricingPlanDefaultStrategy !== 'undefined') {
      toReturn['pricingPlanDefaultStrategy'] = this.pricingPlanDefaultStrategy;
    }
    return toReturn;
  }
}
class ListPricingPlanProductsRequestListPricingPlanProductsFilters {
  static fromProto(proto) {
    let m = new ListPricingPlanProductsRequestListPricingPlanProductsFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.pricingPlanIds !== 'undefined') {
      toReturn['pricingPlanIds'] = this.pricingPlanIds;
    }
    return toReturn;
  }
}
class ListPricingPlanProductsRequest {
  static fromProto(proto) {
    let m = new ListPricingPlanProductsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListPricingPlanProductsRequestListPricingPlanProductsFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListPricingPlanProductsResponse {
  static fromProto(proto) {
    let m = new ListPricingPlanProductsResponse();
    m = Object.assign(m, proto);
    if (proto.products) {
      m.products = proto.products.map(PricingPlanProduct.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.products !== 'undefined' && this.products !== null) {
      toReturn['products'] = 'toApiJson' in this.products ? this.products.toApiJson() : this.products;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class PricingPlanProductPricingEntry {
  static fromProto(proto) {
    let m = new PricingPlanProductPricingEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = PricingPlanProductPricing.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class CreatePricingPlanProductRequestPricingEntry {
  static fromProto(proto) {
    let m = new CreatePricingPlanProductRequestPricingEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = PricingPlanProductPricing.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class UpdatePricingPlanProductRequestPricingEntry {
  static fromProto(proto) {
    let m = new UpdatePricingPlanProductRequestPricingEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = PricingPlanProductPricing.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class PricingPlanProduct {
  static fromProto(proto) {
    let m = new PricingPlanProduct();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$g(Frequency, proto.frequency);
    }
    if (proto.pricing) {
      m.pricing = Object.keys(proto.pricing).reduce((obj, k) => {
        obj[k] = PricingPlanProductPricing.fromProto(proto.pricing[k]);
        return obj;
      }, {});
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.strategy) {
      m.strategy = enumStringToValue$g(BillingStrategy, proto.strategy);
    }
    if (proto.volumeCommitment) {
      m.volumeCommitment = parseInt(proto.volumeCommitment, 10);
    }
    if (proto.volumeCommitmentStartsAt) {
      m.volumeCommitmentStartsAt = new Date(proto.volumeCommitmentStartsAt);
    }
    if (proto.volumeCommitmentEndsAt) {
      m.volumeCommitmentEndsAt = new Date(proto.volumeCommitmentEndsAt);
    }
    if (proto.pricingType) {
      m.pricingType = enumStringToValue$g(ProductPricingType, proto.pricingType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.strategy !== 'undefined') {
      toReturn['strategy'] = this.strategy;
    }
    if (typeof this.volumeCommitment !== 'undefined') {
      toReturn['volumeCommitment'] = this.volumeCommitment;
    }
    if (typeof this.volumeCommitmentStartsAt !== 'undefined' && this.volumeCommitmentStartsAt !== null) {
      toReturn['volumeCommitmentStartsAt'] = 'toApiJson' in this.volumeCommitmentStartsAt ? this.volumeCommitmentStartsAt.toApiJson() : this.volumeCommitmentStartsAt;
    }
    if (typeof this.volumeCommitmentEndsAt !== 'undefined' && this.volumeCommitmentEndsAt !== null) {
      toReturn['volumeCommitmentEndsAt'] = 'toApiJson' in this.volumeCommitmentEndsAt ? this.volumeCommitmentEndsAt.toApiJson() : this.volumeCommitmentEndsAt;
    }
    if (typeof this.pricingType !== 'undefined') {
      toReturn['pricingType'] = this.pricingType;
    }
    return toReturn;
  }
}
class UpdatePricingPlanProductRequest {
  static fromProto(proto) {
    let m = new UpdatePricingPlanProductRequest();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$g(Frequency, proto.frequency);
    }
    if (proto.pricing) {
      m.pricing = Object.keys(proto.pricing).reduce((obj, k) => {
        obj[k] = PricingPlanProductPricing.fromProto(proto.pricing[k]);
        return obj;
      }, {});
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.strategy) {
      m.strategy = enumStringToValue$g(BillingStrategy, proto.strategy);
    }
    if (proto.volumeCommitment) {
      m.volumeCommitment = parseInt(proto.volumeCommitment, 10);
    }
    if (proto.volumeCommitmentStartsAt) {
      m.volumeCommitmentStartsAt = new Date(proto.volumeCommitmentStartsAt);
    }
    if (proto.volumeCommitmentEndsAt) {
      m.volumeCommitmentEndsAt = new Date(proto.volumeCommitmentEndsAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.strategy !== 'undefined') {
      toReturn['strategy'] = this.strategy;
    }
    if (typeof this.volumeCommitment !== 'undefined') {
      toReturn['volumeCommitment'] = this.volumeCommitment;
    }
    if (typeof this.volumeCommitmentStartsAt !== 'undefined' && this.volumeCommitmentStartsAt !== null) {
      toReturn['volumeCommitmentStartsAt'] = 'toApiJson' in this.volumeCommitmentStartsAt ? this.volumeCommitmentStartsAt.toApiJson() : this.volumeCommitmentStartsAt;
    }
    if (typeof this.volumeCommitmentEndsAt !== 'undefined' && this.volumeCommitmentEndsAt !== null) {
      toReturn['volumeCommitmentEndsAt'] = 'toApiJson' in this.volumeCommitmentEndsAt ? this.volumeCommitmentEndsAt.toApiJson() : this.volumeCommitmentEndsAt;
    }
    return toReturn;
  }
}
class UpdatePricingPlanProductResponse {
  static fromProto(proto) {
    let m = new UpdatePricingPlanProductResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class UpsertWholesalePricingRequest {
  static fromProto(proto) {
    let m = new UpsertWholesalePricingRequest();
    m = Object.assign(m, proto);
    if (proto.pricing) {
      m.pricing = proto.pricing.map(PricingPlanProductPricing.fromProto);
    }
    if (proto.termCommitment) {
      m.termCommitment = Commitment.fromProto(proto.termCommitment);
    }
    if (proto.strategy) {
      m.strategy = enumStringToValue$g(BillingStrategy, proto.strategy);
    }
    if (proto.volumeCommitment) {
      m.volumeCommitment = parseInt(proto.volumeCommitment, 10);
    }
    if (proto.volumeCommitmentStartsAt) {
      m.volumeCommitmentStartsAt = new Date(proto.volumeCommitmentStartsAt);
    }
    if (proto.volumeCommitmentEndsAt) {
      m.volumeCommitmentEndsAt = new Date(proto.volumeCommitmentEndsAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.termCommitment !== 'undefined' && this.termCommitment !== null) {
      toReturn['termCommitment'] = 'toApiJson' in this.termCommitment ? this.termCommitment.toApiJson() : this.termCommitment;
    }
    if (typeof this.strategy !== 'undefined') {
      toReturn['strategy'] = this.strategy;
    }
    if (typeof this.volumeCommitment !== 'undefined') {
      toReturn['volumeCommitment'] = this.volumeCommitment;
    }
    if (typeof this.volumeCommitmentStartsAt !== 'undefined' && this.volumeCommitmentStartsAt !== null) {
      toReturn['volumeCommitmentStartsAt'] = 'toApiJson' in this.volumeCommitmentStartsAt ? this.volumeCommitmentStartsAt.toApiJson() : this.volumeCommitmentStartsAt;
    }
    if (typeof this.volumeCommitmentEndsAt !== 'undefined' && this.volumeCommitmentEndsAt !== null) {
      toReturn['volumeCommitmentEndsAt'] = 'toApiJson' in this.volumeCommitmentEndsAt ? this.volumeCommitmentEndsAt.toApiJson() : this.volumeCommitmentEndsAt;
    }
    return toReturn;
  }
}
function enumStringToValue$f(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateProductRequest {
  static fromProto(proto) {
    let m = new CreateProductRequest();
    m = Object.assign(m, proto);
    if (proto.productType) {
      m.productType = enumStringToValue$f(ProductType, proto.productType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.reportingCode !== 'undefined') {
      toReturn['reportingCode'] = this.reportingCode;
    }
    if (typeof this.productType !== 'undefined') {
      toReturn['productType'] = this.productType;
    }
    if (typeof this.metered !== 'undefined') {
      toReturn['metered'] = this.metered;
    }
    return toReturn;
  }
}
class DeleteProductRequest {
  static fromProto(proto) {
    let m = new DeleteProductRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    return toReturn;
  }
}
class GetMultiProductRequest {
  static fromProto(proto) {
    let m = new GetMultiProductRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.skus !== 'undefined') {
      toReturn['skus'] = this.skus;
    }
    return toReturn;
  }
}
class GetMultiProductResponse {
  static fromProto(proto) {
    let m = new GetMultiProductResponse();
    m = Object.assign(m, proto);
    if (proto.products) {
      m.products = Object.keys(proto.products).reduce((obj, k) => {
        obj[k] = Product.fromProto(proto.products[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.products !== 'undefined' && this.products !== null) {
      toReturn['products'] = 'toApiJson' in this.products ? this.products.toApiJson() : this.products;
    }
    return toReturn;
  }
}
class ListProductsRequestListProductsFilters {
  static fromProto(proto) {
    let m = new ListProductsRequestListProductsFilters();
    m = Object.assign(m, proto);
    if (proto.productType) {
      m.productType = proto.productType.map(v => enumStringToValue$f(ProductType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hasDiscount !== 'undefined') {
      toReturn['hasDiscount'] = this.hasDiscount;
    }
    if (typeof this.hasPricingOverride !== 'undefined') {
      toReturn['hasPricingOverride'] = this.hasPricingOverride;
    }
    if (typeof this.productType !== 'undefined') {
      toReturn['productType'] = this.productType;
    }
    if (typeof this.skus !== 'undefined') {
      toReturn['skus'] = this.skus;
    }
    return toReturn;
  }
}
class ListProductsRequest {
  static fromProto(proto) {
    let m = new ListProductsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListProductsRequestListProductsFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListProductsResponse {
  static fromProto(proto) {
    let m = new ListProductsResponse();
    m = Object.assign(m, proto);
    if (proto.products) {
      m.products = proto.products.map(Product.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.products !== 'undefined' && this.products !== null) {
      toReturn['products'] = 'toApiJson' in this.products ? this.products.toApiJson() : this.products;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class Product {
  static fromProto(proto) {
    let m = new Product();
    m = Object.assign(m, proto);
    if (proto.productType) {
      m.productType = enumStringToValue$f(ProductType, proto.productType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.hasPricingOverride !== 'undefined') {
      toReturn['hasPricingOverride'] = this.hasPricingOverride;
    }
    if (typeof this.hasDiscount !== 'undefined') {
      toReturn['hasDiscount'] = this.hasDiscount;
    }
    if (typeof this.productType !== 'undefined') {
      toReturn['productType'] = this.productType;
    }
    if (typeof this.metered !== 'undefined') {
      toReturn['metered'] = this.metered;
    }
    return toReturn;
  }
}
class GetMultiProductResponseProductsEntry {
  static fromProto(proto) {
    let m = new GetMultiProductResponseProductsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = Product.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class UpdateProductRequest {
  static fromProto(proto) {
    let m = new UpdateProductRequest();
    m = Object.assign(m, proto);
    if (proto.productType) {
      m.productType = enumStringToValue$f(ProductType, proto.productType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.reportingCode !== 'undefined') {
      toReturn['reportingCode'] = this.reportingCode;
    }
    if (typeof this.productType !== 'undefined') {
      toReturn['productType'] = this.productType;
    }
    if (typeof this.metered !== 'undefined') {
      toReturn['metered'] = this.metered;
    }
    return toReturn;
  }
}
function enumStringToValue$e(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppliedCredit {
  static fromProto(proto) {
    let m = new AppliedCredit();
    m = Object.assign(m, proto);
    if (proto.appliedAmount) {
      m.appliedAmount = parseInt(proto.appliedAmount, 10);
    }
    if (proto.referenceType) {
      m.referenceType = enumStringToValue$e(CreditType, proto.referenceType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appliedAmount !== 'undefined') {
      toReturn['appliedAmount'] = this.appliedAmount;
    }
    if (typeof this.referenceId !== 'undefined') {
      toReturn['referenceId'] = this.referenceId;
    }
    if (typeof this.referenceType !== 'undefined') {
      toReturn['referenceType'] = this.referenceType;
    }
    return toReturn;
  }
}
class ListPurchaseRequestListPurchaseBillingStrategyFilter {
  static fromProto(proto) {
    let m = new ListPurchaseRequestListPurchaseBillingStrategyFilter();
    m = Object.assign(m, proto);
    if (proto.billingStrategy) {
      m.billingStrategy = proto.billingStrategy.map(v => enumStringToValue$e(BillingStrategy, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.billingStrategy !== 'undefined') {
      toReturn['billingStrategy'] = this.billingStrategy;
    }
    return toReturn;
  }
}
class ListPurchaseRequestListPurchaseFilters {
  static fromProto(proto) {
    let m = new ListPurchaseRequestListPurchaseFilters();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.billingStrategyFilter) {
      m.billingStrategyFilter = ListPurchaseRequestListPurchaseBillingStrategyFilter.fromProto(proto.billingStrategyFilter);
    }
    if (proto.state) {
      m.state = enumStringToValue$e(ListPurchaseRequestState, proto.state);
    }
    if (proto.minPrice) {
      m.minPrice = parseInt(proto.minPrice, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue$e(PurchaseStatus, proto.status);
    }
    if (proto.dunningPauseStart) {
      m.dunningPauseStart = new Date(proto.dunningPauseStart);
    }
    if (proto.dunningPauseEnd) {
      m.dunningPauseEnd = new Date(proto.dunningPauseEnd);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.purchaseId !== 'undefined') {
      toReturn['purchaseId'] = this.purchaseId;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.billingStrategyFilter !== 'undefined' && this.billingStrategyFilter !== null) {
      toReturn['billingStrategyFilter'] = 'toApiJson' in this.billingStrategyFilter ? this.billingStrategyFilter.toApiJson() : this.billingStrategyFilter;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.minPrice !== 'undefined') {
      toReturn['minPrice'] = this.minPrice;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.includeVoided !== 'undefined') {
      toReturn['includeVoided'] = this.includeVoided;
    }
    if (typeof this.dunningPauseStart !== 'undefined' && this.dunningPauseStart !== null) {
      toReturn['dunningPauseStart'] = 'toApiJson' in this.dunningPauseStart ? this.dunningPauseStart.toApiJson() : this.dunningPauseStart;
    }
    if (typeof this.dunningPauseEnd !== 'undefined' && this.dunningPauseEnd !== null) {
      toReturn['dunningPauseEnd'] = 'toApiJson' in this.dunningPauseEnd ? this.dunningPauseEnd.toApiJson() : this.dunningPauseEnd;
    }
    return toReturn;
  }
}
class ListPurchaseItemsRequestListPurchaseItemsFilters {
  static fromProto(proto) {
    let m = new ListPurchaseItemsRequestListPurchaseItemsFilters();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    return toReturn;
  }
}
class ListPurchaseItemsRequest {
  static fromProto(proto) {
    let m = new ListPurchaseItemsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListPurchaseItemsRequestListPurchaseItemsFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListPurchaseItemsResponse {
  static fromProto(proto) {
    let m = new ListPurchaseItemsResponse();
    m = Object.assign(m, proto);
    if (proto.purchaseItems) {
      m.purchaseItems = proto.purchaseItems.map(PurchaseItem.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$e(Currency, proto.currency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.purchaseItems !== 'undefined' && this.purchaseItems !== null) {
      toReturn['purchaseItems'] = 'toApiJson' in this.purchaseItems ? this.purchaseItems.toApiJson() : this.purchaseItems;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    return toReturn;
  }
}
class ListPurchaseRequest {
  static fromProto(proto) {
    let m = new ListPurchaseRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListPurchaseRequestListPurchaseFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListPurchaseResponse {
  static fromProto(proto) {
    let m = new ListPurchaseResponse();
    m = Object.assign(m, proto);
    if (proto.purchases) {
      m.purchases = proto.purchases.map(Purchase.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.purchases !== 'undefined' && this.purchases !== null) {
      toReturn['purchases'] = 'toApiJson' in this.purchases ? this.purchases.toApiJson() : this.purchases;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class PauseDunningRequest {
  static fromProto(proto) {
    let m = new PauseDunningRequest();
    m = Object.assign(m, proto);
    if (proto.pauseDunningUntil) {
      m.pauseDunningUntil = new Date(proto.pauseDunningUntil);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.purchaseId !== 'undefined') {
      toReturn['purchaseId'] = this.purchaseId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.day !== 'undefined') {
      toReturn['day'] = this.day;
    }
    if (typeof this.pauseDunningUntil !== 'undefined' && this.pauseDunningUntil !== null) {
      toReturn['pauseDunningUntil'] = 'toApiJson' in this.pauseDunningUntil ? this.pauseDunningUntil.toApiJson() : this.pauseDunningUntil;
    }
    return toReturn;
  }
}
class Purchase {
  static fromProto(proto) {
    let m = new Purchase();
    m = Object.assign(m, proto);
    if (proto.timestamp) {
      m.timestamp = new Date(proto.timestamp);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$e(Currency, proto.currency);
    }
    if (proto.items) {
      m.items = proto.items.map(PurchaseItem.fromProto);
    }
    if (proto.billingStrategy) {
      m.billingStrategy = enumStringToValue$e(BillingStrategy, proto.billingStrategy);
    }
    if (proto.dunningAttempt) {
      m.dunningAttempt = parseInt(proto.dunningAttempt, 10);
    }
    if (proto.voided) {
      m.voided = new Date(proto.voided);
    }
    if (proto.status) {
      m.status = enumStringToValue$e(PurchaseStatus, proto.status);
    }
    if (proto.creditAmount) {
      m.creditAmount = parseInt(proto.creditAmount, 10);
    }
    if (proto.appliedCredits) {
      m.appliedCredits = proto.appliedCredits.map(AppliedCredit.fromProto);
    }
    if (proto.taxAmount) {
      m.taxAmount = parseInt(proto.taxAmount, 10);
    }
    if (proto.appliedTaxRates) {
      m.appliedTaxRates = proto.appliedTaxRates.map(AppliedTaxRate.fromProto);
    }
    if (proto.pauseDunningUntil) {
      m.pauseDunningUntil = new Date(proto.pauseDunningUntil);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.timestamp !== 'undefined' && this.timestamp !== null) {
      toReturn['timestamp'] = 'toApiJson' in this.timestamp ? this.timestamp.toApiJson() : this.timestamp;
    }
    if (typeof this.purchaseId !== 'undefined') {
      toReturn['purchaseId'] = this.purchaseId;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.renewal !== 'undefined') {
      toReturn['renewal'] = this.renewal;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.billingStrategy !== 'undefined') {
      toReturn['billingStrategy'] = this.billingStrategy;
    }
    if (typeof this.isDunning !== 'undefined') {
      toReturn['isDunning'] = this.isDunning;
    }
    if (typeof this.dunningAttempt !== 'undefined') {
      toReturn['dunningAttempt'] = this.dunningAttempt;
    }
    if (typeof this.voided !== 'undefined' && this.voided !== null) {
      toReturn['voided'] = 'toApiJson' in this.voided ? this.voided.toApiJson() : this.voided;
    }
    if (typeof this.paid !== 'undefined') {
      toReturn['paid'] = this.paid;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.creditAmount !== 'undefined') {
      toReturn['creditAmount'] = this.creditAmount;
    }
    if (typeof this.appliedCredits !== 'undefined' && this.appliedCredits !== null) {
      toReturn['appliedCredits'] = 'toApiJson' in this.appliedCredits ? this.appliedCredits.toApiJson() : this.appliedCredits;
    }
    if (typeof this.taxAmount !== 'undefined') {
      toReturn['taxAmount'] = this.taxAmount;
    }
    if (typeof this.appliedTaxRates !== 'undefined' && this.appliedTaxRates !== null) {
      toReturn['appliedTaxRates'] = 'toApiJson' in this.appliedTaxRates ? this.appliedTaxRates.toApiJson() : this.appliedTaxRates;
    }
    if (typeof this.pauseDunningUntil !== 'undefined' && this.pauseDunningUntil !== null) {
      toReturn['pauseDunningUntil'] = 'toApiJson' in this.pauseDunningUntil ? this.pauseDunningUntil.toApiJson() : this.pauseDunningUntil;
    }
    return toReturn;
  }
}
class PurchaseItem {
  static fromProto(proto) {
    let m = new PurchaseItem();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.discountAmount) {
      m.discountAmount = parseInt(proto.discountAmount, 10);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.appliedDiscounts) {
      m.appliedDiscounts = proto.appliedDiscounts.map(AppliedDiscount.fromProto);
    }
    if (proto.taxAmount) {
      m.taxAmount = parseInt(proto.taxAmount, 10);
    }
    if (proto.appliedTaxRates) {
      m.appliedTaxRates = proto.appliedTaxRates.map(AppliedTaxRate.fromProto);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    if (proto.feeAmount) {
      m.feeAmount = parseInt(proto.feeAmount, 10);
    }
    if (proto.appliedFees) {
      m.appliedFees = proto.appliedFees.map(AppliedFee.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.discountAmount !== 'undefined') {
      toReturn['discountAmount'] = this.discountAmount;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.appliedDiscounts !== 'undefined' && this.appliedDiscounts !== null) {
      toReturn['appliedDiscounts'] = 'toApiJson' in this.appliedDiscounts ? this.appliedDiscounts.toApiJson() : this.appliedDiscounts;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.day !== 'undefined') {
      toReturn['day'] = this.day;
    }
    if (typeof this.purchaseId !== 'undefined') {
      toReturn['purchaseId'] = this.purchaseId;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.taxAmount !== 'undefined') {
      toReturn['taxAmount'] = this.taxAmount;
    }
    if (typeof this.appliedTaxRates !== 'undefined' && this.appliedTaxRates !== null) {
      toReturn['appliedTaxRates'] = 'toApiJson' in this.appliedTaxRates ? this.appliedTaxRates.toApiJson() : this.appliedTaxRates;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.feeAmount !== 'undefined') {
      toReturn['feeAmount'] = this.feeAmount;
    }
    if (typeof this.appliedFees !== 'undefined' && this.appliedFees !== null) {
      toReturn['appliedFees'] = 'toApiJson' in this.appliedFees ? this.appliedFees.toApiJson() : this.appliedFees;
    }
    return toReturn;
  }
}
class ResumeDunningRequest {
  static fromProto(proto) {
    let m = new ResumeDunningRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.purchaseId !== 'undefined') {
      toReturn['purchaseId'] = this.purchaseId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.day !== 'undefined') {
      toReturn['day'] = this.day;
    }
    return toReturn;
  }
}
class RetryPurchaseRequest {
  static fromProto(proto) {
    let m = new RetryPurchaseRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.purchaseId !== 'undefined') {
      toReturn['purchaseId'] = this.purchaseId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.day !== 'undefined') {
      toReturn['day'] = this.day;
    }
    if (typeof this.shouldEnterDunning !== 'undefined') {
      toReturn['shouldEnterDunning'] = this.shouldEnterDunning;
    }
    return toReturn;
  }
}
class StopDunningRequest {
  static fromProto(proto) {
    let m = new StopDunningRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.purchaseId !== 'undefined') {
      toReturn['purchaseId'] = this.purchaseId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.day !== 'undefined') {
      toReturn['day'] = this.day;
    }
    return toReturn;
  }
}
class VoidPurchaseRequest {
  static fromProto(proto) {
    let m = new VoidPurchaseRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.purchaseId !== 'undefined') {
      toReturn['purchaseId'] = this.purchaseId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.day !== 'undefined') {
      toReturn['day'] = this.day;
    }
    return toReturn;
  }
}
function enumStringToValue$d(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateRefundRequest {
  static fromProto(proto) {
    let m = new CreateRefundRequest();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.reason) {
      m.reason = enumStringToValue$d(RefundReason, proto.reason);
    }
    if (proto.referenceType) {
      m.referenceType = enumStringToValue$d(ReferenceType, proto.referenceType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.paymentId !== 'undefined') {
      toReturn['paymentId'] = this.paymentId;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.referenceType !== 'undefined') {
      toReturn['referenceType'] = this.referenceType;
    }
    if (typeof this.referenceId !== 'undefined') {
      toReturn['referenceId'] = this.referenceId;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class ListRefundsRequest {
  static fromProto(proto) {
    let m = new ListRefundsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paymentIds !== 'undefined') {
      toReturn['paymentIds'] = this.paymentIds;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class ListRefundsResponse {
  static fromProto(proto) {
    let m = new ListRefundsResponse();
    m = Object.assign(m, proto);
    if (proto.refunds) {
      m.refunds = proto.refunds.map(Refund.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.refunds !== 'undefined' && this.refunds !== null) {
      toReturn['refunds'] = 'toApiJson' in this.refunds ? this.refunds.toApiJson() : this.refunds;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class Refund {
  static fromProto(proto) {
    let m = new Refund();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.reason) {
      m.reason = enumStringToValue$d(RefundReason, proto.reason);
    }
    if (proto.status) {
      m.status = enumStringToValue$d(RefundStatus, proto.status);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.referenceType) {
      m.referenceType = enumStringToValue$d(ReferenceType, proto.referenceType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.chargeId !== 'undefined') {
      toReturn['chargeId'] = this.chargeId;
    }
    if (typeof this.refundId !== 'undefined') {
      toReturn['refundId'] = this.refundId;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.referenceType !== 'undefined') {
      toReturn['referenceType'] = this.referenceType;
    }
    if (typeof this.referenceId !== 'undefined') {
      toReturn['referenceId'] = this.referenceId;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateSalesCreditNoteRequest {
  static fromProto(proto) {
    let m = new CreateSalesCreditNoteRequest();
    m = Object.assign(m, proto);
    if (proto.creditNoteDate) {
      m.creditNoteDate = new Date(proto.creditNoteDate);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.creditNoteReason !== 'undefined') {
      toReturn['creditNoteReason'] = this.creditNoteReason;
    }
    if (typeof this.creditNoteDate !== 'undefined' && this.creditNoteDate !== null) {
      toReturn['creditNoteDate'] = 'toApiJson' in this.creditNoteDate ? this.creditNoteDate.toApiJson() : this.creditNoteDate;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    return toReturn;
  }
}
class ListSalesCreditNoteRequestListSalesCreditNoteFilters {
  static fromProto(proto) {
    let m = new ListSalesCreditNoteRequestListSalesCreditNoteFilters();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$c(SalesCreditNoteStatus, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    return toReturn;
  }
}
class ListSalesCreditNoteRequest {
  static fromProto(proto) {
    let m = new ListSalesCreditNoteRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSalesCreditNoteRequestListSalesCreditNoteFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListSalesCreditNoteResponse {
  static fromProto(proto) {
    let m = new ListSalesCreditNoteResponse();
    m = Object.assign(m, proto);
    if (proto.creditNote) {
      m.creditNote = proto.creditNote.map(SalesCreditNote.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.creditNote !== 'undefined' && this.creditNote !== null) {
      toReturn['creditNote'] = 'toApiJson' in this.creditNote ? this.creditNote.toApiJson() : this.creditNote;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class SalesCreditNote {
  static fromProto(proto) {
    let m = new SalesCreditNote();
    m = Object.assign(m, proto);
    if (proto.creditNoteDate) {
      m.creditNoteDate = new Date(proto.creditNoteDate);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$c(Currency, proto.currency);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.outstanding) {
      m.outstanding = parseInt(proto.outstanding, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue$c(SalesCreditNoteStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.creditNoteId !== 'undefined') {
      toReturn['creditNoteId'] = this.creditNoteId;
    }
    if (typeof this.creditNoteNumber !== 'undefined') {
      toReturn['creditNoteNumber'] = this.creditNoteNumber;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.creditNoteReason !== 'undefined') {
      toReturn['creditNoteReason'] = this.creditNoteReason;
    }
    if (typeof this.creditNoteDate !== 'undefined' && this.creditNoteDate !== null) {
      toReturn['creditNoteDate'] = 'toApiJson' in this.creditNoteDate ? this.creditNoteDate.toApiJson() : this.creditNoteDate;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.outstanding !== 'undefined') {
      toReturn['outstanding'] = this.outstanding;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.invoiceNumber !== 'undefined') {
      toReturn['invoiceNumber'] = this.invoiceNumber;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.paymentStatus !== 'undefined') {
      toReturn['paymentStatus'] = this.paymentStatus;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetSalesInvoiceRequest {
  static fromProto(proto) {
    let m = new GetSalesInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetSalesInvoiceResponse {
  static fromProto(proto) {
    let m = new GetSalesInvoiceResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = SalesInvoice.fromProto(proto.invoice);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    return toReturn;
  }
}
class ListSalesInvoiceRequestListSalesInvoiceFilters {
  static fromProto(proto) {
    let m = new ListSalesInvoiceRequestListSalesInvoiceFilters();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$b(SalesInvoiceStatus, v));
    }
    if (proto.paymentStatuses) {
      m.paymentStatuses = proto.paymentStatuses.map(v => enumStringToValue$b(PaymentStatuses, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.paymentStatuses !== 'undefined') {
      toReturn['paymentStatuses'] = this.paymentStatuses;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
class ListSalesInvoiceRequest {
  static fromProto(proto) {
    let m = new ListSalesInvoiceRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSalesInvoiceRequestListSalesInvoiceFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListSalesInvoiceResponse {
  static fromProto(proto) {
    let m = new ListSalesInvoiceResponse();
    m = Object.assign(m, proto);
    if (proto.invoice) {
      m.invoice = proto.invoice.map(SalesInvoice.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoice !== 'undefined' && this.invoice !== null) {
      toReturn['invoice'] = 'toApiJson' in this.invoice ? this.invoice.toApiJson() : this.invoice;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class PostSalesInvoiceRequest {
  static fromProto(proto) {
    let m = new PostSalesInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
class SalesInvoice {
  static fromProto(proto) {
    let m = new SalesInvoice();
    m = Object.assign(m, proto);
    if (proto.invoiceDate) {
      m.invoiceDate = new Date(proto.invoiceDate);
    }
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$b(Currency, proto.currency);
    }
    if (proto.status) {
      m.status = enumStringToValue$b(SalesInvoiceStatus, proto.status);
    }
    if (proto.outstanding) {
      m.outstanding = parseInt(proto.outstanding, 10);
    }
    if (proto.type) {
      m.type = enumStringToValue$b(SalesInvoiceType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    if (typeof this.invoiceNumber !== 'undefined') {
      toReturn['invoiceNumber'] = this.invoiceNumber;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceDate !== 'undefined' && this.invoiceDate !== null) {
      toReturn['invoiceDate'] = 'toApiJson' in this.invoiceDate ? this.invoiceDate.toApiJson() : this.invoiceDate;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.paymentStatus !== 'undefined') {
      toReturn['paymentStatus'] = this.paymentStatus;
    }
    if (typeof this.outstanding !== 'undefined') {
      toReturn['outstanding'] = this.outstanding;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class SendSalesInvoiceEmailRequest {
  static fromProto(proto) {
    let m = new SendSalesInvoiceEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
class SendSalesInvoiceReceiptEmailRequest {
  static fromProto(proto) {
    let m = new SendSalesInvoiceReceiptEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkReplaceTaxRulesRequest {
  static fromProto(proto) {
    let m = new BulkReplaceTaxRulesRequest();
    m = Object.assign(m, proto);
    if (proto.taxRules) {
      m.taxRules = proto.taxRules.map(ReplaceTaxRuleRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taxRules !== 'undefined' && this.taxRules !== null) {
      toReturn['taxRules'] = 'toApiJson' in this.taxRules ? this.taxRules.toApiJson() : this.taxRules;
    }
    return toReturn;
  }
}
class BulkReplaceTaxRulesResponse {
  static fromProto(proto) {
    let m = new BulkReplaceTaxRulesResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ids !== 'undefined') {
      toReturn['ids'] = this.ids;
    }
    return toReturn;
  }
}
class TaxRuleCustomerCustomerAddress {
  static fromProto(proto) {
    let m = new TaxRuleCustomerCustomerAddress();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    return toReturn;
  }
}
class DeleteTaxRuleRequest {
  static fromProto(proto) {
    let m = new DeleteTaxRuleRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ListTaxRulesRequestFilters {
  static fromProto(proto) {
    let m = new ListTaxRulesRequestFilters();
    m = Object.assign(m, proto);
    if (proto.consumer) {
      m.consumer = enumStringToValue$a(Consumer, proto.consumer);
    }
    if (proto.entityType) {
      m.entityType = enumStringToValue$a(TaxRuleEntityType, proto.entityType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.consumer !== 'undefined') {
      toReturn['consumer'] = this.consumer;
    }
    if (typeof this.entityType !== 'undefined') {
      toReturn['entityType'] = this.entityType;
    }
    return toReturn;
  }
}
class GetTaxRuleRequest {
  static fromProto(proto) {
    let m = new GetTaxRuleRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetTaxRuleResponse {
  static fromProto(proto) {
    let m = new GetTaxRuleResponse();
    m = Object.assign(m, proto);
    if (proto.taxRule) {
      m.taxRule = TaxRule.fromProto(proto.taxRule);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taxRule !== 'undefined' && this.taxRule !== null) {
      toReturn['taxRule'] = 'toApiJson' in this.taxRule ? this.taxRule.toApiJson() : this.taxRule;
    }
    return toReturn;
  }
}
class ListTaxRulesRequest {
  static fromProto(proto) {
    let m = new ListTaxRulesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListTaxRulesRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListTaxRulesResponse {
  static fromProto(proto) {
    let m = new ListTaxRulesResponse();
    m = Object.assign(m, proto);
    if (proto.taxRules) {
      m.taxRules = proto.taxRules.map(TaxRule.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taxRules !== 'undefined' && this.taxRules !== null) {
      toReturn['taxRules'] = 'toApiJson' in this.taxRules ? this.taxRules.toApiJson() : this.taxRules;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class TaxRuleProductProductIdentifier {
  static fromProto(proto) {
    let m = new TaxRuleProductProductIdentifier();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$a(ProductType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    return toReturn;
  }
}
class ReplaceTaxRuleRequest {
  static fromProto(proto) {
    let m = new ReplaceTaxRuleRequest();
    m = Object.assign(m, proto);
    if (proto.entityType) {
      m.entityType = enumStringToValue$a(TaxRuleEntityType, proto.entityType);
    }
    if (proto.type) {
      m.type = enumStringToValue$a(TaxRuleType, proto.type);
    }
    if (proto.consumer) {
      m.consumer = enumStringToValue$a(Consumer, proto.consumer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.entityType !== 'undefined') {
      toReturn['entityType'] = this.entityType;
    }
    if (typeof this.entityId !== 'undefined') {
      toReturn['entityId'] = this.entityId;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.taxRateIds !== 'undefined') {
      toReturn['taxRateIds'] = this.taxRateIds;
    }
    if (typeof this.consumer !== 'undefined') {
      toReturn['consumer'] = this.consumer;
    }
    return toReturn;
  }
}
class ReplaceTaxRuleResponse {
  static fromProto(proto) {
    let m = new ReplaceTaxRuleResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class TaxRule {
  static fromProto(proto) {
    let m = new TaxRule();
    m = Object.assign(m, proto);
    if (proto.entityType) {
      m.entityType = enumStringToValue$a(TaxRuleEntityType, proto.entityType);
    }
    if (proto.entity) {
      m.entity = TaxRuleTaxRuleEntity.fromProto(proto.entity);
    }
    if (proto.type) {
      m.type = enumStringToValue$a(TaxRuleType, proto.type);
    }
    if (proto.taxRates) {
      m.taxRates = proto.taxRates.map(TaxRate.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.entityId !== 'undefined') {
      toReturn['entityId'] = this.entityId;
    }
    if (typeof this.entityType !== 'undefined') {
      toReturn['entityType'] = this.entityType;
    }
    if (typeof this.entity !== 'undefined' && this.entity !== null) {
      toReturn['entity'] = 'toApiJson' in this.entity ? this.entity.toApiJson() : this.entity;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.taxRates !== 'undefined' && this.taxRates !== null) {
      toReturn['taxRates'] = 'toApiJson' in this.taxRates ? this.taxRates.toApiJson() : this.taxRates;
    }
    return toReturn;
  }
}
class TaxRuleCustomer {
  static fromProto(proto) {
    let m = new TaxRuleCustomer();
    m = Object.assign(m, proto);
    if (proto.address) {
      m.address = TaxRuleCustomerCustomerAddress.fromProto(proto.address);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.address !== 'undefined' && this.address !== null) {
      toReturn['address'] = 'toApiJson' in this.address ? this.address.toApiJson() : this.address;
    }
    return toReturn;
  }
}
class TaxRuleTaxRuleEntity {
  static fromProto(proto) {
    let m = new TaxRuleTaxRuleEntity();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = TaxRuleCustomer.fromProto(proto.customer);
    }
    if (proto.product) {
      m.product = TaxRuleProduct.fromProto(proto.product);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    if (typeof this.product !== 'undefined' && this.product !== null) {
      toReturn['product'] = 'toApiJson' in this.product ? this.product.toApiJson() : this.product;
    }
    return toReturn;
  }
}
class TaxRuleProduct {
  static fromProto(proto) {
    let m = new TaxRuleProduct();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = TaxRuleProductProductIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ContractDocument {
  static fromProto(proto) {
    let m = new ContractDocument();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.filename !== 'undefined') {
      toReturn['filename'] = this.filename;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class DeleteContractDocumentRequest {
  static fromProto(proto) {
    let m = new DeleteContractDocumentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ListContractDocumentsRequestFilters {
  static fromProto(proto) {
    let m = new ListContractDocumentsRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class ListContractDocumentsRequest {
  static fromProto(proto) {
    let m = new ListContractDocumentsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListContractDocumentsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListContractDocumentsResponse {
  static fromProto(proto) {
    let m = new ListContractDocumentsResponse();
    m = Object.assign(m, proto);
    if (proto.contractDocuments) {
      m.contractDocuments = proto.contractDocuments.map(ContractDocument.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contractDocuments !== 'undefined' && this.contractDocuments !== null) {
      toReturn['contractDocuments'] = 'toApiJson' in this.contractDocuments ? this.contractDocuments.toApiJson() : this.contractDocuments;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetRetailCustomerConfigurationRequest {
  static fromProto(proto) {
    let m = new GetRetailCustomerConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetRetailCustomerConfigurationResponse {
  static fromProto(proto) {
    let m = new GetRetailCustomerConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = RetailCustomerConfiguration.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class RetailCustomerConfiguration {
  static fromProto(proto) {
    let m = new RetailCustomerConfiguration();
    m = Object.assign(m, proto);
    if (proto.invoiceDay) {
      m.invoiceDay = parseInt(proto.invoiceDay, 10);
    }
    if (proto.nextInvoiceDate) {
      m.nextInvoiceDate = new Date(proto.nextInvoiceDate);
    }
    if (proto.netD) {
      m.netD = parseInt(proto.netD, 10);
    }
    if (proto.paymentMethodTypes) {
      m.paymentMethodTypes = proto.paymentMethodTypes.map(v => enumStringToValue$8(PaymentMethodType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceDay !== 'undefined') {
      toReturn['invoiceDay'] = this.invoiceDay;
    }
    if (typeof this.nextInvoiceDate !== 'undefined' && this.nextInvoiceDate !== null) {
      toReturn['nextInvoiceDate'] = 'toApiJson' in this.nextInvoiceDate ? this.nextInvoiceDate.toApiJson() : this.nextInvoiceDate;
    }
    if (typeof this.autoPost !== 'undefined') {
      toReturn['autoPost'] = this.autoPost;
    }
    if (typeof this.collectionMethod !== 'undefined') {
      toReturn['collectionMethod'] = this.collectionMethod;
    }
    if (typeof this.netD !== 'undefined') {
      toReturn['netD'] = this.netD;
    }
    if (typeof this.autoGenerate !== 'undefined') {
      toReturn['autoGenerate'] = this.autoGenerate;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.useTemplateInvoice !== 'undefined') {
      toReturn['useTemplateInvoice'] = this.useTemplateInvoice;
    }
    if (typeof this.memo !== 'undefined') {
      toReturn['memo'] = this.memo;
    }
    if (typeof this.additionalContactIds !== 'undefined') {
      toReturn['additionalContactIds'] = this.additionalContactIds;
    }
    if (typeof this.autoGenerateRetailSubscriptions !== 'undefined') {
      toReturn['autoGenerateRetailSubscriptions'] = this.autoGenerateRetailSubscriptions;
    }
    if (typeof this.paymentMethodTypes !== 'undefined') {
      toReturn['paymentMethodTypes'] = this.paymentMethodTypes;
    }
    return toReturn;
  }
}
class UpsertRetailCustomerConfigurationRequest {
  static fromProto(proto) {
    let m = new UpsertRetailCustomerConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.invoiceDay) {
      m.invoiceDay = parseInt(proto.invoiceDay, 10);
    }
    if (proto.netD) {
      m.netD = parseInt(proto.netD, 10);
    }
    if (proto.paymentMethodTypes) {
      m.paymentMethodTypes = proto.paymentMethodTypes.map(v => enumStringToValue$8(PaymentMethodType, v));
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.invoiceDay !== 'undefined') {
      toReturn['invoiceDay'] = this.invoiceDay;
    }
    if (typeof this.autoPost !== 'undefined') {
      toReturn['autoPost'] = this.autoPost;
    }
    if (typeof this.netD !== 'undefined') {
      toReturn['netD'] = this.netD;
    }
    if (typeof this.autoGenerate !== 'undefined') {
      toReturn['autoGenerate'] = this.autoGenerate;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.collectionMethod !== 'undefined') {
      toReturn['collectionMethod'] = this.collectionMethod;
    }
    if (typeof this.useTemplateInvoice !== 'undefined') {
      toReturn['useTemplateInvoice'] = this.useTemplateInvoice;
    }
    if (typeof this.memo !== 'undefined') {
      toReturn['memo'] = this.memo;
    }
    if (typeof this.additionalContactIds !== 'undefined') {
      toReturn['additionalContactIds'] = this.additionalContactIds;
    }
    if (typeof this.autoGenerateRetailSubscriptions !== 'undefined') {
      toReturn['autoGenerateRetailSubscriptions'] = this.autoGenerateRetailSubscriptions;
    }
    if (typeof this.paymentMethodTypes !== 'undefined') {
      toReturn['paymentMethodTypes'] = this.paymentMethodTypes;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddCreditRequest {
  static fromProto(proto) {
    let m = new AddCreditRequest();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.memo !== 'undefined') {
      toReturn['memo'] = this.memo;
    }
    return toReturn;
  }
}
class CreditBalance {
  static fromProto(proto) {
    let m = new CreditBalance();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    return toReturn;
  }
}
class GetBalanceRequest {
  static fromProto(proto) {
    let m = new GetBalanceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetBalanceResponse {
  static fromProto(proto) {
    let m = new GetBalanceResponse();
    m = Object.assign(m, proto);
    if (proto.creditBalance) {
      m.creditBalance = CreditBalance.fromProto(proto.creditBalance);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.creditBalance !== 'undefined' && this.creditBalance !== null) {
      toReturn['creditBalance'] = 'toApiJson' in this.creditBalance ? this.creditBalance.toApiJson() : this.creditBalance;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class RecurringInvoiceCustomerAddress {
  static fromProto(proto) {
    let m = new RecurringInvoiceCustomerAddress();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    return toReturn;
  }
}
class ListRecurringInvoicesFiltersDateFilter {
  static fromProto(proto) {
    let m = new ListRecurringInvoicesFiltersDateFilter();
    m = Object.assign(m, proto);
    if (proto.dateLte) {
      m.dateLte = new Date(proto.dateLte);
    }
    if (proto.dateGte) {
      m.dateGte = new Date(proto.dateGte);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dateLte !== 'undefined' && this.dateLte !== null) {
      toReturn['dateLte'] = 'toApiJson' in this.dateLte ? this.dateLte.toApiJson() : this.dateLte;
    }
    if (typeof this.dateGte !== 'undefined' && this.dateGte !== null) {
      toReturn['dateGte'] = 'toApiJson' in this.dateGte ? this.dateGte.toApiJson() : this.dateGte;
    }
    return toReturn;
  }
}
class DeleteRecurringInvoiceRequest {
  static fromProto(proto) {
    let m = new DeleteRecurringInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ListRecurringInvoicesFiltersDetailedInterval {
  static fromProto(proto) {
    let m = new ListRecurringInvoicesFiltersDetailedInterval();
    m = Object.assign(m, proto);
    if (proto.interval) {
      m.interval = enumStringToValue$6(Interval, proto.interval);
    }
    if (proto.intervalCount) {
      m.intervalCount = parseInt(proto.intervalCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.interval !== 'undefined') {
      toReturn['interval'] = this.interval;
    }
    if (typeof this.intervalCount !== 'undefined') {
      toReturn['intervalCount'] = this.intervalCount;
    }
    return toReturn;
  }
}
class GetRecurringInvoiceRequest {
  static fromProto(proto) {
    let m = new GetRecurringInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ListRecurringInvoicesFilters {
  static fromProto(proto) {
    let m = new ListRecurringInvoicesFilters();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$6(RecurringInvoiceStatus, v));
    }
    if (proto.intervals) {
      m.intervals = proto.intervals.map(ListRecurringInvoicesFiltersDetailedInterval.fromProto);
    }
    if (proto.nextIssuedDate) {
      m.nextIssuedDate = ListRecurringInvoicesFiltersDateFilter.fromProto(proto.nextIssuedDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.intervals !== 'undefined' && this.intervals !== null) {
      toReturn['intervals'] = 'toApiJson' in this.intervals ? this.intervals.toApiJson() : this.intervals;
    }
    if (typeof this.nextIssuedDate !== 'undefined' && this.nextIssuedDate !== null) {
      toReturn['nextIssuedDate'] = 'toApiJson' in this.nextIssuedDate ? this.nextIssuedDate.toApiJson() : this.nextIssuedDate;
    }
    return toReturn;
  }
}
class ListRecurringInvoicesRequest {
  static fromProto(proto) {
    let m = new ListRecurringInvoicesRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListRecurringInvoicesFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListRecurringInvoicesResponse {
  static fromProto(proto) {
    let m = new ListRecurringInvoicesResponse();
    m = Object.assign(m, proto);
    if (proto.recurringInvoices) {
      m.recurringInvoices = proto.recurringInvoices.map(RecurringInvoice.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recurringInvoices !== 'undefined' && this.recurringInvoices !== null) {
      toReturn['recurringInvoices'] = 'toApiJson' in this.recurringInvoices ? this.recurringInvoices.toApiJson() : this.recurringInvoices;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class RecurringInvoice {
  static fromProto(proto) {
    let m = new RecurringInvoice();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.status) {
      m.status = enumStringToValue$6(RecurringInvoiceStatus, proto.status);
    }
    if (proto.nextIssue) {
      m.nextIssue = new Date(proto.nextIssue);
    }
    if (proto.intervalCount) {
      m.intervalCount = parseInt(proto.intervalCount, 10);
    }
    if (proto.interval) {
      m.interval = enumStringToValue$6(Interval, proto.interval);
    }
    if (proto.repeatOnDayOfMonth) {
      m.repeatOnDayOfMonth = parseInt(proto.repeatOnDayOfMonth, 10);
    }
    if (proto.collectionMethod) {
      m.collectionMethod = enumStringToValue$6(CollectionMethod, proto.collectionMethod);
    }
    if (proto.paymentProcessor) {
      m.paymentProcessor = enumStringToValue$6(PaymentProcessor, proto.paymentProcessor);
    }
    if (proto.items) {
      m.items = proto.items.map(RecurringInvoiceItem.fromProto);
    }
    if (proto.totalAmount) {
      m.totalAmount = parseInt(proto.totalAmount, 10);
    }
    if (proto.endsAt) {
      m.endsAt = new Date(proto.endsAt);
    }
    if (proto.customerAddress) {
      m.customerAddress = RecurringInvoiceCustomerAddress.fromProto(proto.customerAddress);
    }
    if (proto.netD) {
      m.netD = parseInt(proto.netD, 10);
    }
    if (proto.paymentMethodTypes) {
      m.paymentMethodTypes = proto.paymentMethodTypes.map(v => enumStringToValue$6(PaymentMethodType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.nextIssue !== 'undefined' && this.nextIssue !== null) {
      toReturn['nextIssue'] = 'toApiJson' in this.nextIssue ? this.nextIssue.toApiJson() : this.nextIssue;
    }
    if (typeof this.intervalCount !== 'undefined') {
      toReturn['intervalCount'] = this.intervalCount;
    }
    if (typeof this.interval !== 'undefined') {
      toReturn['interval'] = this.interval;
    }
    if (typeof this.repeatOnDayOfMonth !== 'undefined') {
      toReturn['repeatOnDayOfMonth'] = this.repeatOnDayOfMonth;
    }
    if (typeof this.collectionMethod !== 'undefined') {
      toReturn['collectionMethod'] = this.collectionMethod;
    }
    if (typeof this.recipientUserId !== 'undefined') {
      toReturn['recipientUserId'] = this.recipientUserId;
    }
    if (typeof this.paymentProcessor !== 'undefined') {
      toReturn['paymentProcessor'] = this.paymentProcessor;
    }
    if (typeof this.paymentProcessorId !== 'undefined') {
      toReturn['paymentProcessorId'] = this.paymentProcessorId;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.totalAmount !== 'undefined') {
      toReturn['totalAmount'] = this.totalAmount;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.memo !== 'undefined') {
      toReturn['memo'] = this.memo;
    }
    if (typeof this.endsAt !== 'undefined' && this.endsAt !== null) {
      toReturn['endsAt'] = 'toApiJson' in this.endsAt ? this.endsAt.toApiJson() : this.endsAt;
    }
    if (typeof this.customerName !== 'undefined') {
      toReturn['customerName'] = this.customerName;
    }
    if (typeof this.customerAddress !== 'undefined' && this.customerAddress !== null) {
      toReturn['customerAddress'] = 'toApiJson' in this.customerAddress ? this.customerAddress.toApiJson() : this.customerAddress;
    }
    if (typeof this.netD !== 'undefined') {
      toReturn['netD'] = this.netD;
    }
    if (typeof this.additionalRecipientIds !== 'undefined') {
      toReturn['additionalRecipientIds'] = this.additionalRecipientIds;
    }
    if (typeof this.paymentMethodTypes !== 'undefined') {
      toReturn['paymentMethodTypes'] = this.paymentMethodTypes;
    }
    return toReturn;
  }
}
class RecurringInvoiceBundle {
  static fromProto(proto) {
    let m = new RecurringInvoiceBundle();
    m = Object.assign(m, proto);
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(RecurringInvoiceLineItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.hideLineItems !== 'undefined') {
      toReturn['hideLineItems'] = this.hideLineItems;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    return toReturn;
  }
}
class RecurringInvoiceItem {
  static fromProto(proto) {
    let m = new RecurringInvoiceItem();
    m = Object.assign(m, proto);
    if (proto.lineItem) {
      m.lineItem = RecurringInvoiceLineItem.fromProto(proto.lineItem);
    }
    if (proto.bundle) {
      m.bundle = RecurringInvoiceBundle.fromProto(proto.bundle);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lineItem !== 'undefined' && this.lineItem !== null) {
      toReturn['lineItem'] = 'toApiJson' in this.lineItem ? this.lineItem.toApiJson() : this.lineItem;
    }
    if (typeof this.bundle !== 'undefined' && this.bundle !== null) {
      toReturn['bundle'] = 'toApiJson' in this.bundle ? this.bundle.toApiJson() : this.bundle;
    }
    return toReturn;
  }
}
class RecurringInvoiceLineItem {
  static fromProto(proto) {
    let m = new RecurringInvoiceLineItem();
    m = Object.assign(m, proto);
    if (proto.unitPrice) {
      m.unitPrice = parseInt(proto.unitPrice, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.unitPrice !== 'undefined') {
      toReturn['unitPrice'] = this.unitPrice;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.taxRateIds !== 'undefined') {
      toReturn['taxRateIds'] = this.taxRateIds;
    }
    return toReturn;
  }
}
class UpdateRecurringInvoiceRequest {
  static fromProto(proto) {
    let m = new UpdateRecurringInvoiceRequest();
    m = Object.assign(m, proto);
    if (proto.recurringInvoice) {
      m.recurringInvoice = RecurringInvoice.fromProto(proto.recurringInvoice);
    }
    if (proto.updateMask) {
      m.updateMask = FieldMask.fromProto(proto.updateMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recurringInvoice !== 'undefined' && this.recurringInvoice !== null) {
      toReturn['recurringInvoice'] = 'toApiJson' in this.recurringInvoice ? this.recurringInvoice.toApiJson() : this.recurringInvoice;
    }
    if (typeof this.updateMask !== 'undefined' && this.updateMask !== null) {
      toReturn['updateMask'] = 'toApiJson' in this.updateMask ? this.updateMask.toApiJson() : this.updateMask;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateMerchantServicesReportRun {
  static fromProto(proto) {
    let m = new CreateMerchantServicesReportRun();
    m = Object.assign(m, proto);
    if (proto.reportType) {
      m.reportType = enumStringToValue$5(MerchantServicesReportRunType, proto.reportType);
    }
    if (proto.intervalStart) {
      m.intervalStart = new Date(proto.intervalStart);
    }
    if (proto.intervalEnd) {
      m.intervalEnd = new Date(proto.intervalEnd);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.reportType !== 'undefined') {
      toReturn['reportType'] = this.reportType;
    }
    if (typeof this.intervalStart !== 'undefined' && this.intervalStart !== null) {
      toReturn['intervalStart'] = 'toApiJson' in this.intervalStart ? this.intervalStart.toApiJson() : this.intervalStart;
    }
    if (typeof this.intervalEnd !== 'undefined' && this.intervalEnd !== null) {
      toReturn['intervalEnd'] = 'toApiJson' in this.intervalEnd ? this.intervalEnd.toApiJson() : this.intervalEnd;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    return toReturn;
  }
}
class GetMerchantServicesReportRun {
  static fromProto(proto) {
    let m = new GetMerchantServicesReportRun();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class MerchantServicesReportRun {
  static fromProto(proto) {
    let m = new MerchantServicesReportRun();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.reportType) {
      m.reportType = enumStringToValue$5(MerchantServicesReportRunType, proto.reportType);
    }
    if (proto.status) {
      m.status = enumStringToValue$5(MerchantServicesReportRunStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.reportType !== 'undefined') {
      toReturn['reportType'] = this.reportType;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.error !== 'undefined') {
      toReturn['error'] = this.error;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ListSubscriptionRelationshipsRequestFilters {
  static fromProto(proto) {
    let m = new ListSubscriptionRelationshipsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.originType) {
      m.originType = enumStringToValue$3(EntityType, proto.originType);
    }
    if (proto.targetType) {
      m.targetType = enumStringToValue$3(EntityType, proto.targetType);
    }
    if (proto.relationshipType) {
      m.relationshipType = enumStringToValue$3(RelationshipType, proto.relationshipType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.originId !== 'undefined') {
      toReturn['originId'] = this.originId;
    }
    if (typeof this.originType !== 'undefined') {
      toReturn['originType'] = this.originType;
    }
    if (typeof this.targetId !== 'undefined') {
      toReturn['targetId'] = this.targetId;
    }
    if (typeof this.targetType !== 'undefined') {
      toReturn['targetType'] = this.targetType;
    }
    if (typeof this.relationshipType !== 'undefined') {
      toReturn['relationshipType'] = this.relationshipType;
    }
    return toReturn;
  }
}
class GetMultiSubscriptionRelationshipsRequest {
  static fromProto(proto) {
    let m = new GetMultiSubscriptionRelationshipsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionRelationshipIds !== 'undefined') {
      toReturn['subscriptionRelationshipIds'] = this.subscriptionRelationshipIds;
    }
    return toReturn;
  }
}
class GetMultiSubscriptionRelationshipsResponse {
  static fromProto(proto) {
    let m = new GetMultiSubscriptionRelationshipsResponse();
    m = Object.assign(m, proto);
    if (proto.subscriptionRelationships) {
      m.subscriptionRelationships = proto.subscriptionRelationships.map(SubscriptionRelationship.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionRelationships !== 'undefined' && this.subscriptionRelationships !== null) {
      toReturn['subscriptionRelationships'] = 'toApiJson' in this.subscriptionRelationships ? this.subscriptionRelationships.toApiJson() : this.subscriptionRelationships;
    }
    return toReturn;
  }
}
class ListSubscriptionRelationshipsRequest {
  static fromProto(proto) {
    let m = new ListSubscriptionRelationshipsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSubscriptionRelationshipsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListSubscriptionRelationshipsResponse {
  static fromProto(proto) {
    let m = new ListSubscriptionRelationshipsResponse();
    m = Object.assign(m, proto);
    if (proto.subscriptionRelationships) {
      m.subscriptionRelationships = proto.subscriptionRelationships.map(SubscriptionRelationship.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionRelationships !== 'undefined' && this.subscriptionRelationships !== null) {
      toReturn['subscriptionRelationships'] = 'toApiJson' in this.subscriptionRelationships ? this.subscriptionRelationships.toApiJson() : this.subscriptionRelationships;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ReplaceSubscriptionRelationshipsRequest {
  static fromProto(proto) {
    let m = new ReplaceSubscriptionRelationshipsRequest();
    m = Object.assign(m, proto);
    if (proto.toAdd) {
      m.toAdd = proto.toAdd.map(SubscriptionRelationship.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.toAdd !== 'undefined' && this.toAdd !== null) {
      toReturn['toAdd'] = 'toApiJson' in this.toAdd ? this.toAdd.toApiJson() : this.toAdd;
    }
    if (typeof this.toRemove !== 'undefined') {
      toReturn['toRemove'] = this.toRemove;
    }
    return toReturn;
  }
}
class ReplaceSubscriptionRelationshipsResponse {
  static fromProto(proto) {
    let m = new ReplaceSubscriptionRelationshipsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addedSubscriptionRelationshipIds !== 'undefined') {
      toReturn['addedSubscriptionRelationshipIds'] = this.addedSubscriptionRelationshipIds;
    }
    return toReturn;
  }
}
class SubscriptionRelationship {
  static fromProto(proto) {
    let m = new SubscriptionRelationship();
    m = Object.assign(m, proto);
    if (proto.originType) {
      m.originType = enumStringToValue$3(EntityType, proto.originType);
    }
    if (proto.targetType) {
      m.targetType = enumStringToValue$3(EntityType, proto.targetType);
    }
    if (proto.relationshipType) {
      m.relationshipType = enumStringToValue$3(RelationshipType, proto.relationshipType);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionRelationshipId !== 'undefined') {
      toReturn['subscriptionRelationshipId'] = this.subscriptionRelationshipId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.originId !== 'undefined') {
      toReturn['originId'] = this.originId;
    }
    if (typeof this.originType !== 'undefined') {
      toReturn['originType'] = this.originType;
    }
    if (typeof this.targetId !== 'undefined') {
      toReturn['targetId'] = this.targetId;
    }
    if (typeof this.targetType !== 'undefined') {
      toReturn['targetType'] = this.targetType;
    }
    if (typeof this.relationshipType !== 'undefined') {
      toReturn['relationshipType'] = this.relationshipType;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ReplaceSubscriptionPresetsRequest {
  static fromProto(proto) {
    let m = new ReplaceSubscriptionPresetsRequest();
    m = Object.assign(m, proto);
    if (proto.presets) {
      m.presets = proto.presets.map(SubscriptionPreset.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.presets !== 'undefined' && this.presets !== null) {
      toReturn['presets'] = 'toApiJson' in this.presets ? this.presets.toApiJson() : this.presets;
    }
    return toReturn;
  }
}
class ReplaceSubscriptionPresetsResponse {
  static fromProto(proto) {
    let m = new ReplaceSubscriptionPresetsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionIds !== 'undefined') {
      toReturn['subscriptionIds'] = this.subscriptionIds;
    }
    return toReturn;
  }
}
class SubscriptionPreset {
  static fromProto(proto) {
    let m = new SubscriptionPreset();
    m = Object.assign(m, proto);
    if (proto.billingStart) {
      m.billingStart = new Date(proto.billingStart);
    }
    if (proto.renewalStart) {
      m.renewalStart = new Date(proto.renewalStart);
    }
    if (proto.expiry) {
      m.expiry = new Date(proto.expiry);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    if (typeof this.autoBillable !== 'undefined') {
      toReturn['autoBillable'] = this.autoBillable;
    }
    if (typeof this.salesOrderId !== 'undefined') {
      toReturn['salesOrderId'] = this.salesOrderId;
    }
    if (typeof this.paymentIntentId !== 'undefined') {
      toReturn['paymentIntentId'] = this.paymentIntentId;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.billingStart !== 'undefined' && this.billingStart !== null) {
      toReturn['billingStart'] = 'toApiJson' in this.billingStart ? this.billingStart.toApiJson() : this.billingStart;
    }
    if (typeof this.renewalStart !== 'undefined' && this.renewalStart !== null) {
      toReturn['renewalStart'] = 'toApiJson' in this.renewalStart ? this.renewalStart.toApiJson() : this.renewalStart;
    }
    if (typeof this.expiry !== 'undefined' && this.expiry !== null) {
      toReturn['expiry'] = 'toApiJson' in this.expiry ? this.expiry.toApiJson() : this.expiry;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppliedTo {
  static fromProto(proto) {
    let m = new AppliedTo();
    m = Object.assign(m, proto);
    if (proto.referenceType) {
      m.referenceType = enumStringToValue$1(AppliedReferenceType, proto.referenceType);
    }
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.creditNoteType) {
      m.creditNoteType = enumStringToValue$1(CreditNoteType, proto.creditNoteType);
    }
    if (proto.appliedAt) {
      m.appliedAt = new Date(proto.appliedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.referenceId !== 'undefined') {
      toReturn['referenceId'] = this.referenceId;
    }
    if (typeof this.referenceType !== 'undefined') {
      toReturn['referenceType'] = this.referenceType;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.creditNoteType !== 'undefined') {
      toReturn['creditNoteType'] = this.creditNoteType;
    }
    if (typeof this.appliedAt !== 'undefined' && this.appliedAt !== null) {
      toReturn['appliedAt'] = 'toApiJson' in this.appliedAt ? this.appliedAt.toApiJson() : this.appliedAt;
    }
    if (typeof this.referenceNumber !== 'undefined') {
      toReturn['referenceNumber'] = this.referenceNumber;
    }
    if (typeof this.shouldRefund !== 'undefined') {
      toReturn['shouldRefund'] = this.shouldRefund;
    }
    return toReturn;
  }
}
class CalculateCreditNoteRequest {
  static fromProto(proto) {
    let m = new CalculateCreditNoteRequest();
    m = Object.assign(m, proto);
    if (proto.creditNote) {
      m.creditNote = CreditNote.fromProto(proto.creditNote);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.creditNote !== 'undefined' && this.creditNote !== null) {
      toReturn['creditNote'] = 'toApiJson' in this.creditNote ? this.creditNote.toApiJson() : this.creditNote;
    }
    return toReturn;
  }
}
class CalculateCreditNoteResponse {
  static fromProto(proto) {
    let m = new CalculateCreditNoteResponse();
    m = Object.assign(m, proto);
    if (proto.creditNote) {
      m.creditNote = CreditNote.fromProto(proto.creditNote);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.creditNote !== 'undefined' && this.creditNote !== null) {
      toReturn['creditNote'] = 'toApiJson' in this.creditNote ? this.creditNote.toApiJson() : this.creditNote;
    }
    return toReturn;
  }
}
class CreateCreditNoteRequest {
  static fromProto(proto) {
    let m = new CreateCreditNoteRequest();
    m = Object.assign(m, proto);
    if (proto.creditNote) {
      m.creditNote = CreditNote.fromProto(proto.creditNote);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.creditNote !== 'undefined' && this.creditNote !== null) {
      toReturn['creditNote'] = 'toApiJson' in this.creditNote ? this.creditNote.toApiJson() : this.creditNote;
    }
    return toReturn;
  }
}
class CreateCreditNoteResponse {
  static fromProto(proto) {
    let m = new CreateCreditNoteResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreditNote {
  static fromProto(proto) {
    let m = new CreditNote();
    m = Object.assign(m, proto);
    if (proto.subtotal) {
      m.subtotal = parseInt(proto.subtotal, 10);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.items) {
      m.items = proto.items.map(LineItem.fromProto);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$1(Currency, proto.currency);
    }
    if (proto.amountTax) {
      m.amountTax = parseInt(proto.amountTax, 10);
    }
    if (proto.appliedTaxes) {
      m.appliedTaxes = proto.appliedTaxes.map(AppliedTaxRate.fromProto);
    }
    if (proto.notes) {
      m.notes = proto.notes.map(Note.fromProto);
    }
    if (proto.reason) {
      m.reason = enumStringToValue$1(CreditNoteReason, proto.reason);
    }
    if (proto.appliedTo) {
      m.appliedTo = proto.appliedTo.map(AppliedTo.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.number !== 'undefined') {
      toReturn['number'] = this.number;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.subtotal !== 'undefined') {
      toReturn['subtotal'] = this.subtotal;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.amountTax !== 'undefined') {
      toReturn['amountTax'] = this.amountTax;
    }
    if (typeof this.appliedTaxes !== 'undefined' && this.appliedTaxes !== null) {
      toReturn['appliedTaxes'] = 'toApiJson' in this.appliedTaxes ? this.appliedTaxes.toApiJson() : this.appliedTaxes;
    }
    if (typeof this.customerName !== 'undefined') {
      toReturn['customerName'] = this.customerName;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.memo !== 'undefined') {
      toReturn['memo'] = this.memo;
    }
    if (typeof this.notes !== 'undefined' && this.notes !== null) {
      toReturn['notes'] = 'toApiJson' in this.notes ? this.notes.toApiJson() : this.notes;
    }
    if (typeof this.additionalContactIds !== 'undefined') {
      toReturn['additionalContactIds'] = this.additionalContactIds;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.appliedTo !== 'undefined' && this.appliedTo !== null) {
      toReturn['appliedTo'] = 'toApiJson' in this.appliedTo ? this.appliedTo.toApiJson() : this.appliedTo;
    }
    return toReturn;
  }
}
class ListCreditNotesRequestFilters {
  static fromProto(proto) {
    let m = new ListCreditNotesRequestFilters();
    m = Object.assign(m, proto);
    if (proto.createdLte) {
      m.createdLte = new Date(proto.createdLte);
    }
    if (proto.createdGte) {
      m.createdGte = new Date(proto.createdGte);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.number !== 'undefined') {
      toReturn['number'] = this.number;
    }
    if (typeof this.createdLte !== 'undefined' && this.createdLte !== null) {
      toReturn['createdLte'] = 'toApiJson' in this.createdLte ? this.createdLte.toApiJson() : this.createdLte;
    }
    if (typeof this.createdGte !== 'undefined' && this.createdGte !== null) {
      toReturn['createdGte'] = 'toApiJson' in this.createdGte ? this.createdGte.toApiJson() : this.createdGte;
    }
    return toReturn;
  }
}
class GetCreditNoteRequest {
  static fromProto(proto) {
    let m = new GetCreditNoteRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetCreditNoteResponse {
  static fromProto(proto) {
    let m = new GetCreditNoteResponse();
    m = Object.assign(m, proto);
    if (proto.creditNote) {
      m.creditNote = CreditNote.fromProto(proto.creditNote);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.creditNote !== 'undefined' && this.creditNote !== null) {
      toReturn['creditNote'] = 'toApiJson' in this.creditNote ? this.creditNote.toApiJson() : this.creditNote;
    }
    return toReturn;
  }
}
class GetMultiCreditNoteRequest {
  static fromProto(proto) {
    let m = new GetMultiCreditNoteRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ids !== 'undefined') {
      toReturn['ids'] = this.ids;
    }
    return toReturn;
  }
}
class GetMultiCreditNoteResponse {
  static fromProto(proto) {
    let m = new GetMultiCreditNoteResponse();
    m = Object.assign(m, proto);
    if (proto.creditNotes) {
      m.creditNotes = proto.creditNotes.map(CreditNote.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.creditNotes !== 'undefined' && this.creditNotes !== null) {
      toReturn['creditNotes'] = 'toApiJson' in this.creditNotes ? this.creditNotes.toApiJson() : this.creditNotes;
    }
    return toReturn;
  }
}
class LineItem {
  static fromProto(proto) {
    let m = new LineItem();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.appliedTaxes) {
      m.appliedTaxes = proto.appliedTaxes.map(AppliedTaxRate.fromProto);
    }
    if (proto.taxRates) {
      m.taxRates = proto.taxRates.map(TaxRate.fromProto);
    }
    if (proto.subtotal) {
      m.subtotal = parseInt(proto.subtotal, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.appliedTaxes !== 'undefined' && this.appliedTaxes !== null) {
      toReturn['appliedTaxes'] = 'toApiJson' in this.appliedTaxes ? this.appliedTaxes.toApiJson() : this.appliedTaxes;
    }
    if (typeof this.taxRates !== 'undefined' && this.taxRates !== null) {
      toReturn['taxRates'] = 'toApiJson' in this.taxRates ? this.taxRates.toApiJson() : this.taxRates;
    }
    if (typeof this.subtotal !== 'undefined') {
      toReturn['subtotal'] = this.subtotal;
    }
    return toReturn;
  }
}
class ListCreditNotesRequest {
  static fromProto(proto) {
    let m = new ListCreditNotesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListCreditNotesRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListCreditNotesResponse {
  static fromProto(proto) {
    let m = new ListCreditNotesResponse();
    m = Object.assign(m, proto);
    if (proto.creditNotes) {
      m.creditNotes = proto.creditNotes.map(CreditNote.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.creditNotes !== 'undefined' && this.creditNotes !== null) {
      toReturn['creditNotes'] = 'toApiJson' in this.creditNotes ? this.creditNotes.toApiJson() : this.creditNotes;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class SendCreditNoteRequest {
  static fromProto(proto) {
    let m = new SendCreditNoteRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.emailAddresses !== 'undefined') {
      toReturn['emailAddresses'] = this.emailAddresses;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DeleteRetailPricingRequest {
  static fromProto(proto) {
    let m = new DeleteRetailPricingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    return toReturn;
  }
}
class GenerateBillableItemsCSVRequest {
  static fromProto(proto) {
    let m = new GenerateBillableItemsCSVRequest();
    m = Object.assign(m, proto);
    if (proto.periodStart) {
      m.periodStart = new Date(proto.periodStart);
    }
    if (proto.periodEnd) {
      m.periodEnd = new Date(proto.periodEnd);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.periodStart !== 'undefined' && this.periodStart !== null) {
      toReturn['periodStart'] = 'toApiJson' in this.periodStart ? this.periodStart.toApiJson() : this.periodStart;
    }
    if (typeof this.periodEnd !== 'undefined' && this.periodEnd !== null) {
      toReturn['periodEnd'] = 'toApiJson' in this.periodEnd ? this.periodEnd.toApiJson() : this.periodEnd;
    }
    return toReturn;
  }
}
class GenerateBillableItemsCSVResponse {
  static fromProto(proto) {
    let m = new GenerateBillableItemsCSVResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class GenerateVendorReportRequest {
  static fromProto(proto) {
    let m = new GenerateVendorReportRequest();
    m = Object.assign(m, proto);
    if (proto.periodStart) {
      m.periodStart = new Date(proto.periodStart);
    }
    if (proto.periodEnd) {
      m.periodEnd = new Date(proto.periodEnd);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.skus !== 'undefined') {
      toReturn['skus'] = this.skus;
    }
    if (typeof this.periodStart !== 'undefined' && this.periodStart !== null) {
      toReturn['periodStart'] = 'toApiJson' in this.periodStart ? this.periodStart.toApiJson() : this.periodStart;
    }
    if (typeof this.periodEnd !== 'undefined' && this.periodEnd !== null) {
      toReturn['periodEnd'] = 'toApiJson' in this.periodEnd ? this.periodEnd.toApiJson() : this.periodEnd;
    }
    if (typeof this.vendorName !== 'undefined') {
      toReturn['vendorName'] = this.vendorName;
    }
    if (typeof this.markAsApproved !== 'undefined') {
      toReturn['markAsApproved'] = this.markAsApproved;
    }
    return toReturn;
  }
}
class GenerateVendorReportResponse {
  static fromProto(proto) {
    let m = new GenerateVendorReportResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.bucket !== 'undefined') {
      toReturn['bucket'] = this.bucket;
    }
    if (typeof this.filename !== 'undefined') {
      toReturn['filename'] = this.filename;
    }
    return toReturn;
  }
}
class GetMultiBundleRetailPricingRequest {
  static fromProto(proto) {
    let m = new GetMultiBundleRetailPricingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.storeId !== 'undefined') {
      toReturn['storeId'] = this.storeId;
    }
    if (typeof this.bundleIds !== 'undefined') {
      toReturn['bundleIds'] = this.bundleIds;
    }
    return toReturn;
  }
}
class GetMultiBundleRetailPricingResponse {
  static fromProto(proto) {
    let m = new GetMultiBundleRetailPricingResponse();
    m = Object.assign(m, proto);
    if (proto.prices) {
      m.prices = Object.keys(proto.prices).reduce((obj, k) => {
        obj[k] = BundlePricing.fromProto(proto.prices[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prices !== 'undefined' && this.prices !== null) {
      toReturn['prices'] = 'toApiJson' in this.prices ? this.prices.toApiJson() : this.prices;
    }
    return toReturn;
  }
}
class GetMultiProductPricingRequest {
  static fromProto(proto) {
    let m = new GetMultiProductPricingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.skus !== 'undefined') {
      toReturn['skus'] = this.skus;
    }
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    return toReturn;
  }
}
class GetMultiProductPricingResponse {
  static fromProto(proto) {
    let m = new GetMultiProductPricingResponse();
    m = Object.assign(m, proto);
    if (proto.productPrices) {
      m.productPrices = Object.keys(proto.productPrices).reduce((obj, k) => {
        obj[k] = ProductPricing.fromProto(proto.productPrices[k]);
        return obj;
      }, {});
    }
    if (proto.prices) {
      m.prices = proto.prices.map(ProductPrices.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productPrices !== 'undefined' && this.productPrices !== null) {
      toReturn['productPrices'] = 'toApiJson' in this.productPrices ? this.productPrices.toApiJson() : this.productPrices;
    }
    if (typeof this.prices !== 'undefined' && this.prices !== null) {
      toReturn['prices'] = 'toApiJson' in this.prices ? this.prices.toApiJson() : this.prices;
    }
    return toReturn;
  }
}
class GetMultiRetailPricingRequest {
  static fromProto(proto) {
    let m = new GetMultiRetailPricingRequest();
    m = Object.assign(m, proto);
    if (proto.currency) {
      m.currency = enumStringToValue(Currency, proto.currency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.skus !== 'undefined') {
      toReturn['skus'] = this.skus;
    }
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class GetMultiRetailPricingResponse {
  static fromProto(proto) {
    let m = new GetMultiRetailPricingResponse();
    m = Object.assign(m, proto);
    if (proto.productPrices) {
      m.productPrices = Object.keys(proto.productPrices).reduce((obj, k) => {
        obj[k] = ProductPricing.fromProto(proto.productPrices[k]);
        return obj;
      }, {});
    }
    if (proto.prices) {
      m.prices = proto.prices.map(ProductPrices.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productPrices !== 'undefined' && this.productPrices !== null) {
      toReturn['productPrices'] = 'toApiJson' in this.productPrices ? this.productPrices.toApiJson() : this.productPrices;
    }
    if (typeof this.prices !== 'undefined' && this.prices !== null) {
      toReturn['prices'] = 'toApiJson' in this.prices ? this.prices.toApiJson() : this.prices;
    }
    return toReturn;
  }
}
class GetMultiWholesaleCostRequest {
  static fromProto(proto) {
    let m = new GetMultiWholesaleCostRequest();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(WholesaleCostItemRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class GetMultiWholesaleCostResponse {
  static fromProto(proto) {
    let m = new GetMultiWholesaleCostResponse();
    m = Object.assign(m, proto);
    if (proto.costs) {
      m.costs = proto.costs.map(GetPurchaseCostResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.costs !== 'undefined' && this.costs !== null) {
      toReturn['costs'] = 'toApiJson' in this.costs ? this.costs.toApiJson() : this.costs;
    }
    return toReturn;
  }
}
class GetPurchaseCostRequest {
  static fromProto(proto) {
    let m = new GetPurchaseCostRequest();
    m = Object.assign(m, proto);
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue(Frequency, proto.frequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    return toReturn;
  }
}
class GetPurchaseCostResponse {
  static fromProto(proto) {
    let m = new GetPurchaseCostResponse();
    m = Object.assign(m, proto);
    if (proto.totalCost) {
      m.totalCost = parseInt(proto.totalCost, 10);
    }
    if (proto.currency) {
      m.currency = enumStringToValue(Currency, proto.currency);
    }
    if (proto.strategy) {
      m.strategy = enumStringToValue(BillingStrategy, proto.strategy);
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    if (proto.discountAmount) {
      m.discountAmount = parseInt(proto.discountAmount, 10);
    }
    if (proto.subtotalCost) {
      m.subtotalCost = parseInt(proto.subtotalCost, 10);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.totalCost !== 'undefined') {
      toReturn['totalCost'] = this.totalCost;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.strategy !== 'undefined') {
      toReturn['strategy'] = this.strategy;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.isStartingPrice !== 'undefined') {
      toReturn['isStartingPrice'] = this.isStartingPrice;
    }
    if (typeof this.discountAmount !== 'undefined') {
      toReturn['discountAmount'] = this.discountAmount;
    }
    if (typeof this.subtotalCost !== 'undefined') {
      toReturn['subtotalCost'] = this.subtotalCost;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    return toReturn;
  }
}
class GetRevenueStatsRequest {
  static fromProto(proto) {
    let m = new GetRevenueStatsRequest();
    m = Object.assign(m, proto);
    if (proto.periodStart) {
      m.periodStart = new Date(proto.periodStart);
    }
    if (proto.periodEnd) {
      m.periodEnd = new Date(proto.periodEnd);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.skus !== 'undefined') {
      toReturn['skus'] = this.skus;
    }
    if (typeof this.periodStart !== 'undefined' && this.periodStart !== null) {
      toReturn['periodStart'] = 'toApiJson' in this.periodStart ? this.periodStart.toApiJson() : this.periodStart;
    }
    if (typeof this.periodEnd !== 'undefined' && this.periodEnd !== null) {
      toReturn['periodEnd'] = 'toApiJson' in this.periodEnd ? this.periodEnd.toApiJson() : this.periodEnd;
    }
    return toReturn;
  }
}
class GetRevenueStatsResponse {
  static fromProto(proto) {
    let m = new GetRevenueStatsResponse();
    m = Object.assign(m, proto);
    if (proto.totalRevenue) {
      m.totalRevenue = parseInt(proto.totalRevenue, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.totalRevenue !== 'undefined') {
      toReturn['totalRevenue'] = this.totalRevenue;
    }
    return toReturn;
  }
}
class GetStatisticsRequest {
  static fromProto(proto) {
    let m = new GetStatisticsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    return toReturn;
  }
}
class GetStatisticsResponse {
  static fromProto(proto) {
    let m = new GetStatisticsResponse();
    m = Object.assign(m, proto);
    if (proto.totalBillableCustomers) {
      m.totalBillableCustomers = parseInt(proto.totalBillableCustomers, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.totalBillableCustomers !== 'undefined') {
      toReturn['totalBillableCustomers'] = this.totalBillableCustomers;
    }
    if (typeof this.currentBasketSize !== 'undefined') {
      toReturn['currentBasketSize'] = this.currentBasketSize;
    }
    if (typeof this.changeInBasketSize30Days !== 'undefined') {
      toReturn['changeInBasketSize30Days'] = this.changeInBasketSize30Days;
    }
    return toReturn;
  }
}
class GetWholesaleComparisonRequestGetWholesaleComparisonFilters {
  static fromProto(proto) {
    let m = new GetWholesaleComparisonRequestGetWholesaleComparisonFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    return toReturn;
  }
}
class GetWholesaleComparisonRequest {
  static fromProto(proto) {
    let m = new GetWholesaleComparisonRequest();
    m = Object.assign(m, proto);
    if (proto.filter) {
      m.filter = GetWholesaleComparisonRequestGetWholesaleComparisonFilters.fromProto(proto.filter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    return toReturn;
  }
}
class GetWholesaleComparisonResponse {
  static fromProto(proto) {
    let m = new GetWholesaleComparisonResponse();
    m = Object.assign(m, proto);
    if (proto.results) {
      m.results = proto.results.map(GetWholesaleComparisonResponseGetWholesaleComparisonResult.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    return toReturn;
  }
}
class GetWholesaleComparisonResponseGetWholesaleComparisonResult {
  static fromProto(proto) {
    let m = new GetWholesaleComparisonResponseGetWholesaleComparisonResult();
    m = Object.assign(m, proto);
    if (proto.productPricing) {
      m.productPricing = ProductPricing.fromProto(proto.productPricing);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingPlanId !== 'undefined') {
      toReturn['pricingPlanId'] = this.pricingPlanId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.productPricing !== 'undefined' && this.productPricing !== null) {
      toReturn['productPricing'] = 'toApiJson' in this.productPricing ? this.productPricing.toApiJson() : this.productPricing;
    }
    return toReturn;
  }
}
class GetMultiBundleRetailPricingResponsePricesEntry {
  static fromProto(proto) {
    let m = new GetMultiBundleRetailPricingResponsePricesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = BundlePricing.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class UpsertRetailPricingRequestPricingEntry {
  static fromProto(proto) {
    let m = new UpsertRetailPricingRequestPricingEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = PricingPlanProductPricing.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class GetMultiRetailPricingResponseProductPricesEntry {
  static fromProto(proto) {
    let m = new GetMultiRetailPricingResponseProductPricesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ProductPricing.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class GetMultiProductPricingResponseProductPricesEntry {
  static fromProto(proto) {
    let m = new GetMultiProductPricingResponseProductPricesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ProductPricing.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class SetWholesaleProductStrategyRequest {
  static fromProto(proto) {
    let m = new SetWholesaleProductStrategyRequest();
    m = Object.assign(m, proto);
    if (proto.strategy) {
      m.strategy = enumStringToValue(BillingStrategy, proto.strategy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.strategy !== 'undefined') {
      toReturn['strategy'] = this.strategy;
    }
    return toReturn;
  }
}
class SetWholesaleProductVolumeCommitmentRequest {
  static fromProto(proto) {
    let m = new SetWholesaleProductVolumeCommitmentRequest();
    m = Object.assign(m, proto);
    if (proto.volumeCommitment) {
      m.volumeCommitment = parseInt(proto.volumeCommitment, 10);
    }
    if (proto.volumeCommitmentStartsAt) {
      m.volumeCommitmentStartsAt = new Date(proto.volumeCommitmentStartsAt);
    }
    if (proto.volumeCommitmentEndsAt) {
      m.volumeCommitmentEndsAt = new Date(proto.volumeCommitmentEndsAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.volumeCommitment !== 'undefined') {
      toReturn['volumeCommitment'] = this.volumeCommitment;
    }
    if (typeof this.volumeCommitmentStartsAt !== 'undefined' && this.volumeCommitmentStartsAt !== null) {
      toReturn['volumeCommitmentStartsAt'] = 'toApiJson' in this.volumeCommitmentStartsAt ? this.volumeCommitmentStartsAt.toApiJson() : this.volumeCommitmentStartsAt;
    }
    if (typeof this.volumeCommitmentEndsAt !== 'undefined' && this.volumeCommitmentEndsAt !== null) {
      toReturn['volumeCommitmentEndsAt'] = 'toApiJson' in this.volumeCommitmentEndsAt ? this.volumeCommitmentEndsAt.toApiJson() : this.volumeCommitmentEndsAt;
    }
    return toReturn;
  }
}
class StartRevRecTemplateBackfillRequest {
  static fromProto(proto) {
    let m = new StartRevRecTemplateBackfillRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class UpsertRetailPricingRequest {
  static fromProto(proto) {
    let m = new UpsertRetailPricingRequest();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue(Frequency, proto.frequency);
    }
    if (proto.pricing) {
      m.pricing = Object.keys(proto.pricing).reduce((obj, k) => {
        obj[k] = PricingPlanProductPricing.fromProto(proto.pricing[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.merchantId !== 'undefined') {
      toReturn['merchantId'] = this.merchantId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.subscriptionId !== 'undefined') {
      toReturn['subscriptionId'] = this.subscriptionId;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'billing-api.vendasta-local.com',
  'test': '',
  'demo': 'billing-demo.apigateway.co',
  'prod': 'billing-prod.apigateway.co',
  'production': 'billing-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
    static {
      this.ɵfac = function HostService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HostService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: HostService,
        factory: HostService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let BankReconciliationApiService = /*#__PURE__*/(() => {
  class BankReconciliationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listPayouts(r) {
      const request = r.toApiJson ? r : new ListPayoutsRequest(r);
      return this.http.post(this._host + "/billing.v1.BankReconciliationService/ListPayouts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPayoutsResponse.fromProto(resp)));
    }
    reconcilePayout(r) {
      const request = r.toApiJson ? r : new ReconcilePayoutRequest(r);
      return this.http.post(this._host + "/billing.v1.BankReconciliationService/ReconcilePayout", request.toApiJson(), this.apiOptions()).pipe(map(resp => ReconcilePayoutResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function BankReconciliationApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BankReconciliationApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BankReconciliationApiService,
        factory: BankReconciliationApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BankReconciliationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let BillingApiService = /*#__PURE__*/(() => {
  class BillingApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    canBillItem(r) {
      const request = r.toApiJson ? r : new CanBillItemRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/CanBillItem", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    canCreateSubscriptions(r) {
      const request = r.toApiJson ? r : new CanCreateSubscriptionsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/CanCreateSubscriptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => CanCreateSubscriptionsResponse.fromProto(resp)));
    }
    createSubscription(r) {
      const request = r.toApiJson ? r : new CreateSubscriptionRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/CreateSubscription", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSubscriptionResponse.fromProto(resp)));
    }
    createSubscriptions(r) {
      const request = r.toApiJson ? r : new CreateSubscriptionsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/CreateSubscriptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSubscriptionsResponse.fromProto(resp)));
    }
    reverseSubscription(r) {
      const request = r.toApiJson ? r : new ReverseSubscriptionRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ReverseSubscription", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setAutoBillable(r) {
      const request = r.toApiJson ? r : new SetAutoBillableRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/SetAutoBillable", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setRenewalStart(r) {
      const request = r.toApiJson ? r : new SetRenewalStartRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/SetRenewalStart", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    billItem(r) {
      const request = r.toApiJson ? r : new BillItemRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/BillItem", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    billMultipleItems(r) {
      const request = r.toApiJson ? r : new BillMultipleItemsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/BillMultipleItems", request.toApiJson(), this.apiOptions()).pipe(map(resp => BillMultipleItemsResponse.fromProto(resp)));
    }
    getBillableItem(r) {
      const request = r.toApiJson ? r : new GetBillableItemRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GetBillableItem", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBillableItemResponse.fromProto(resp)));
    }
    getMultiSubscriptions(r) {
      const request = r.toApiJson ? r : new GetMultiSubscriptionsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GetMultiSubscriptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiSubscriptionsResponse.fromProto(resp)));
    }
    listSubscriptions(r) {
      const request = r.toApiJson ? r : new ListSubscriptionsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ListSubscriptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSubscriptionsResponse.fromProto(resp)));
    }
    exportSubscriptions(r) {
      const request = r.toApiJson ? r : new ExportSubscriptionsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ExportSubscriptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ExportResponse.fromProto(resp)));
    }
    listRetailSubscriptions(r) {
      const request = r.toApiJson ? r : new ListSubscriptionsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ListRetailSubscriptions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSubscriptionsResponse.fromProto(resp)));
    }
    listBillableItems(r) {
      const request = r.toApiJson ? r : new ListBillableItemsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ListBillableItems", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBillableItemsResponse.fromProto(resp)));
    }
    expireBillableItem(r) {
      const request = r.toApiJson ? r : new ExpireBillableItemRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ExpireBillableItem", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unexpireBillableItem(r) {
      const request = r.toApiJson ? r : new UnexpireBillableItemRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/UnexpireBillableItem", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteBillableItem(r) {
      const request = r.toApiJson ? r : new DeleteBillableItemRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/DeleteBillableItem", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listMerchantBillingReports(r) {
      const request = r.toApiJson ? r : new ListMerchantBillingReportsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ListMerchantBillingReports", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMerchantBillingReportsResponse.fromProto(resp)));
    }
    listProductSummaries(r) {
      const request = r.toApiJson ? r : new ListProductSummariesRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ListProductSummaries", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListProductSummariesResponse.fromProto(resp)));
    }
    getProductSummariesTotal(r) {
      const request = r.toApiJson ? r : new GetProductSummariesTotalRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GetProductSummariesTotal", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetProductSummariesTotalResponse.fromProto(resp)));
    }
    generateBillableItemsCsv(r) {
      const request = r.toApiJson ? r : new GenerateBillableItemsCSVRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GenerateBillableItemsCSV", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateBillableItemsCSVResponse.fromProto(resp)));
    }
    createPricingPlan(r) {
      const request = r.toApiJson ? r : new CreatePricingPlanRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/CreatePricingPlan", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreatePricingPlanResponse.fromProto(resp)));
    }
    updatePricingPlan(r) {
      const request = r.toApiJson ? r : new UpdatePricingPlanRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/UpdatePricingPlan", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdatePricingPlanResponse.fromProto(resp)));
    }
    getMultiPricingPlan(r) {
      const request = r.toApiJson ? r : new GetMultiPricingPlanRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GetMultiPricingPlan", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiPricingPlanResponse.fromProto(resp)));
    }
    createPricingPlanProduct(r) {
      const request = r.toApiJson ? r : new CreatePricingPlanProductRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/CreatePricingPlanProduct", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreatePricingPlanProductResponse.fromProto(resp)));
    }
    updatePricingPlanProduct(r) {
      const request = r.toApiJson ? r : new UpdatePricingPlanProductRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/UpdatePricingPlanProduct", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdatePricingPlanProductResponse.fromProto(resp)));
    }
    deletePricingPlanProduct(r) {
      const request = r.toApiJson ? r : new DeletePricingPlanProductRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/DeletePricingPlanProduct", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listPricingPlanProducts(r) {
      const request = r.toApiJson ? r : new ListPricingPlanProductsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ListPricingPlanProducts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPricingPlanProductsResponse.fromProto(resp)));
    }
    getPricingPlanProduct(r) {
      const request = r.toApiJson ? r : new GetPricingPlanProductRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GetPricingPlanProduct", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPricingPlanProductResponse.fromProto(resp)));
    }
    getMultiPricingPlanProduct(r) {
      const request = r.toApiJson ? r : new GetMultiPricingPlanProductRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GetMultiPricingPlanProduct", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiPricingPlanProductResponse.fromProto(resp)));
    }
    getMultiProductPricing(r) {
      const request = r.toApiJson ? r : new GetMultiProductPricingRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GetMultiProductPricing", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiProductPricingResponse.fromProto(resp)));
    }
    tickComponentUsage(r) {
      const request = r.toApiJson ? r : new TickComponentUsageRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/TickComponentUsage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createMeteredComponent(r) {
      const request = r.toApiJson ? r : new CreateMeteredComponentRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/CreateMeteredComponent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createUsage(r) {
      const request = r.toApiJson ? r : new CreateUsageRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/CreateUsage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listContracts(r) {
      const request = r.toApiJson ? r : new ListContractsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ListContracts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListContractsResponse.fromProto(resp)));
    }
    getMultiContract(r) {
      const request = r.toApiJson ? r : new GetMultiContractsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GetMultiContract", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiContractsResponse.fromProto(resp)));
    }
    getMerchantWholesaleCurrency(r) {
      const request = r.toApiJson ? r : new GetMerchantWholesaleCurrencyRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GetMerchantWholesaleCurrency", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMerchantWholesaleCurrencyResponse.fromProto(resp)));
    }
    listProducts(r) {
      const request = r.toApiJson ? r : new ListProductsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ListProducts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListProductsResponse.fromProto(resp)));
    }
    getMultiProduct(r) {
      const request = r.toApiJson ? r : new GetMultiProductRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GetMultiProduct", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiProductResponse.fromProto(resp)));
    }
    resetContractPricing(r) {
      const request = r.toApiJson ? r : new ResetContractPricingRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ResetContractPricing", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getPurchaseCost(r) {
      const request = r.toApiJson ? r : new GetPurchaseCostRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/GetPurchaseCost", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPurchaseCostResponse.fromProto(resp)));
    }
    changeFrequency(r) {
      const request = r.toApiJson ? r : new ChangeFrequencyRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ChangeFrequency", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    changeRenewalDate(r) {
      const request = r.toApiJson ? r : new ChangeRenewalDateRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ChangeRenewalDate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    changeCustomUnitPrice(r) {
      const request = r.toApiJson ? r : new ChangeCustomUnitPriceRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ChangeCustomUnitPrice", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    startRevRecTemplateBackfill(r) {
      const request = r.toApiJson ? r : new StartRevRecTemplateBackfillRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/StartRevRecTemplateBackfill", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    replaceSubscriptionPresets(r) {
      const request = r.toApiJson ? r : new ReplaceSubscriptionPresetsRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/ReplaceSubscriptionPresets", request.toApiJson(), this.apiOptions()).pipe(map(resp => ReplaceSubscriptionPresetsResponse.fromProto(resp)));
    }
    updateSubscription(r) {
      const request = r.toApiJson ? r : new UpdateSubscriptionRequest(r);
      return this.http.post(this._host + "/billing.v1.Billing/UpdateSubscription", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateSubscriptionResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function BillingApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BillingApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BillingApiService,
        factory: BillingApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BillingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let BundleApiService = /*#__PURE__*/(() => {
  class BundleApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsert(r) {
      const request = r.toApiJson ? r : new UpsertBundleRequest(r);
      return this.http.post(this._host + "/billing.v1.BundleService/Upsert", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiBundleRequest(r);
      return this.http.post(this._host + "/billing.v1.BundleService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiBundleResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListBundlesRequest(r);
      return this.http.post(this._host + "/billing.v1.BundleService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBundlesResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function BundleApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BundleApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BundleApiService,
        factory: BundleApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BundleApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ContractDocumentApiService = /*#__PURE__*/(() => {
  class ContractDocumentApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListContractDocumentsRequest(r);
      return this.http.post(this._host + "/billing.v1.ContractDocumentService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListContractDocumentsResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteContractDocumentRequest(r);
      return this.http.post(this._host + "/billing.v1.ContractDocumentService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    static {
      this.ɵfac = function ContractDocumentApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContractDocumentApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ContractDocumentApiService,
        factory: ContractDocumentApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ContractDocumentApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ContractApiService = /*#__PURE__*/(() => {
  class ContractApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetContractRequest(r);
      return this.http.post(this._host + "/billing.v1.ContractService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetContractResponse.fromProto(resp)));
    }
    updateSubscription(r) {
      const request = r.toApiJson ? r : new UpdateContractSubscriptionRequest(r);
      return this.http.post(this._host + "/billing.v1.ContractService/UpdateSubscription", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateContractRequest(r);
      return this.http.post(this._host + "/billing.v1.ContractService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateContractResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateContractRequest(r);
      return this.http.post(this._host + "/billing.v1.ContractService/Update", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateContractResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function ContractApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContractApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ContractApiService,
        factory: ContractApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ContractApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CreditNoteApiService = /*#__PURE__*/(() => {
  class CreditNoteApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateCreditNoteRequest(r);
      return this.http.post(this._host + "/billing.v1.CreditNoteService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCreditNoteResponse.fromProto(resp)));
    }
    calculate(r) {
      const request = r.toApiJson ? r : new CalculateCreditNoteRequest(r);
      return this.http.post(this._host + "/billing.v1.CreditNoteService/Calculate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CalculateCreditNoteResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetCreditNoteRequest(r);
      return this.http.post(this._host + "/billing.v1.CreditNoteService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCreditNoteResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiCreditNoteRequest(r);
      return this.http.post(this._host + "/billing.v1.CreditNoteService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCreditNoteResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListCreditNotesRequest(r);
      return this.http.post(this._host + "/billing.v1.CreditNoteService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCreditNotesResponse.fromProto(resp)));
    }
    send(r) {
      const request = r.toApiJson ? r : new SendCreditNoteRequest(r);
      return this.http.post(this._host + "/billing.v1.CreditNoteService/Send", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    static {
      this.ɵfac = function CreditNoteApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CreditNoteApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CreditNoteApiService,
        factory: CreditNoteApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CreditNoteApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CreditApiService = /*#__PURE__*/(() => {
  class CreditApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    add(r) {
      const request = r.toApiJson ? r : new AddCreditRequest(r);
      return this.http.post(this._host + "/billing.v1.CreditService/Add", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getBalance(r) {
      const request = r.toApiJson ? r : new GetBalanceRequest(r);
      return this.http.post(this._host + "/billing.v1.CreditService/GetBalance", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBalanceResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function CreditApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CreditApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CreditApiService,
        factory: CreditApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CreditApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let DiscountApiService = /*#__PURE__*/(() => {
  class DiscountApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListDiscountsRequest(r);
      return this.http.post(this._host + "/billing.v1.DiscountService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDiscountsResponse.fromProto(resp)));
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateDiscountRequest(r);
      return this.http.post(this._host + "/billing.v1.DiscountService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateDiscountResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateDiscountRequest(r);
      return this.http.post(this._host + "/billing.v1.DiscountService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    expire(r) {
      const request = r.toApiJson ? r : new ExpireDiscountRequest(r);
      return this.http.post(this._host + "/billing.v1.DiscountService/Expire", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    static {
      this.ɵfac = function DiscountApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DiscountApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DiscountApiService,
        factory: DiscountApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DiscountApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let InvoiceApiService = /*#__PURE__*/(() => {
  class InvoiceApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    addBundle(r) {
      const request = r.toApiJson ? r : new AddBundleRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/AddBundle", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddBundleResponse.fromProto(resp)));
    }
    addLineItem(r) {
      const request = r.toApiJson ? r : new AddLineItemRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/AddLineItem", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddLineItemResponse.fromProto(resp)));
    }
    charge(r) {
      const request = r.toApiJson ? r : new ChargeInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/Charge", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateInvoiceResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteLineItem(r) {
      const request = r.toApiJson ? r : new DeleteLineItemRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/DeleteLineItem", request.toApiJson(), this.apiOptions()).pipe(map(resp => DeleteLineItemResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetInvoiceResponse.fromProto(resp)));
    }
    removeBundle(r) {
      const request = r.toApiJson ? r : new RemoveBundleRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/RemoveBundle", request.toApiJson(), this.apiOptions()).pipe(map(resp => RemoveBundleResponse.fromProto(resp)));
    }
    send(r) {
      const request = r.toApiJson ? r : new SendInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/Send", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListInvoicesRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListInvoicesResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/Update", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateInvoiceResponse.fromProto(resp)));
    }
    pay(r) {
      const request = r.toApiJson ? r : new PayInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/Pay", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateDefaultTaxRates(r) {
      const request = r.toApiJson ? r : new UpdateDefaultTaxRatesRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/UpdateDefaultTaxRates", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateDefaultTaxRatesResponse.fromProto(resp)));
    }
    updateLineItem(r) {
      const request = r.toApiJson ? r : new UpdateLineItemRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/UpdateLineItem", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateLineItemResponse.fromProto(resp)));
    }
    void(r) {
      const request = r.toApiJson ? r : new VoidInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/Void", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    duplicate(r) {
      const request = r.toApiJson ? r : new DuplicateInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/Duplicate", request.toApiJson(), this.apiOptions()).pipe(map(resp => DuplicateInvoiceResponse.fromProto(resp)));
    }
    updateBundle(r) {
      const request = r.toApiJson ? r : new UpdateBundleRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/UpdateBundle", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateBundleResponse.fromProto(resp)));
    }
    createPaymentLink(r) {
      const request = r.toApiJson ? r : new CreatePaymentLinkRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/CreatePaymentLink", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreatePaymentLinkResponse.fromProto(resp)));
    }
    getUpcomingInvoicePreview(r) {
      const request = r.toApiJson ? r : new GetUpcomingInvoicePreviewRequest(r);
      return this.http.post(this._host + "/billing.v1.InvoiceService/GetUpcomingInvoicePreview", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUpcomingInvoicePreviewResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function InvoiceApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InvoiceApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: InvoiceApiService,
        factory: InvoiceApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return InvoiceApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let MerchantApiService = /*#__PURE__*/(() => {
  class MerchantApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateMerchantRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/Create", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetMerchantRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMerchantResponse.fromProto(resp)));
    }
    getOutstandingBalance(r) {
      const request = r.toApiJson ? r : new GetOutstandingBalanceRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/GetOutstandingBalance", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOutstandingBalanceResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateMerchantRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createPaymentCard(r) {
      const request = r.toApiJson ? r : new CreatePaymentCardRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/CreatePaymentCard", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setDefaultPaymentCard(r) {
      const request = r.toApiJson ? r : new SetDefaultPaymentCardRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/SetDefaultPaymentCard", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listPaymentCards(r) {
      const request = r.toApiJson ? r : new ListPaymentCardsRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/ListPaymentCards", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPaymentCardsResponse.fromProto(resp)));
    }
    updatePaymentCard(r) {
      const request = r.toApiJson ? r : new UpdatePaymentCardRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/UpdatePaymentCard", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getStatistics(r) {
      const request = r.toApiJson ? r : new GetStatisticsRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/GetStatistics", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetStatisticsResponse.fromProto(resp)));
    }
    search(r) {
      const request = r.toApiJson ? r : new SearchMerchantsRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/Search", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchMerchantsResponse.fromProto(resp)));
    }
    setAutoPostInvoices(r) {
      const request = r.toApiJson ? r : new SetAutoPostInvoicesRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/SetAutoPostInvoices", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setAutoChargeInvoices(r) {
      const request = r.toApiJson ? r : new SetAutoChargeInvoicesRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/SetAutoChargeInvoices", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setIncludeInFinancialRecords(r) {
      const request = r.toApiJson ? r : new SetIncludeInFinancialRecordsRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/SetIncludeInFinancialRecords", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setHasAlternativePaymentMethod(r) {
      const request = r.toApiJson ? r : new SetHasAlternativePaymentMethodRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/SetHasAlternativePaymentMethod", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendSalesInvoiceEmail(r) {
      const request = r.toApiJson ? r : new SendSalesInvoiceEmailRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/SendSalesInvoiceEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    chargeSalesInvoice(r) {
      const request = r.toApiJson ? r : new ChargeSalesInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/ChargeSalesInvoice", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendSalesInvoiceReceiptEmail(r) {
      const request = r.toApiJson ? r : new SendSalesInvoiceReceiptEmailRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/SendSalesInvoiceReceiptEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createStripeExternalAccount(r) {
      const request = r.toApiJson ? r : new CreateStripeExternalAccountRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/CreateStripeExternalAccount", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listBankAccounts(r) {
      const request = r.toApiJson ? r : new ListBankAccountsRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/ListBankAccounts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBankAccountsResponse.fromProto(resp)));
    }
    setDefaultBankAccount(r) {
      const request = r.toApiJson ? r : new SetDefaultBankAccountRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/SetDefaultBankAccount", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteBankAccount(r) {
      const request = r.toApiJson ? r : new DeleteBankAccountRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/DeleteBankAccount", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiRetailConfigurations(r) {
      const request = r.toApiJson ? r : new GetMultiRetailConfigurationsRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/GetMultiRetailConfigurations", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiRetailConfigurationsResponse.fromProto(resp)));
    }
    upsertRetailConfiguration(r) {
      const request = r.toApiJson ? r : new UpsertRetailConfigurationRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/UpsertRetailConfiguration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    upsertDefaultRetailCustomerConfiguration(r) {
      const request = r.toApiJson ? r : new UpsertDefaultRetailCustomerConfigurationRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/UpsertDefaultRetailCustomerConfiguration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getRetailBalance(r) {
      const request = r.toApiJson ? r : new GetRetailBalanceRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/GetRetailBalance", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRetailBalanceResponse.fromProto(resp)));
    }
    getPayoutSummary(r) {
      const request = r.toApiJson ? r : new GetPayoutSummaryRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/GetPayoutSummary", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPayoutSummaryResponse.fromProto(resp)));
    }
    listRetailPayouts(r) {
      const request = r.toApiJson ? r : new ListRetailPayoutsRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/ListRetailPayouts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListRetailPayoutsResponse.fromProto(resp)));
    }
    getRetailPayout(r) {
      const request = r.toApiJson ? r : new GetRetailPayoutRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/GetRetailPayout", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRetailPayoutResponse.fromProto(resp)));
    }
    createReportRun(r) {
      const request = r.toApiJson ? r : new CreateMerchantServicesReportRun(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/CreateReportRun", request.toApiJson(), this.apiOptions()).pipe(map(resp => MerchantServicesReportRun.fromProto(resp)));
    }
    getReportRun(r) {
      const request = r.toApiJson ? r : new GetMerchantServicesReportRun(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/GetReportRun", request.toApiJson(), this.apiOptions()).pipe(map(resp => MerchantServicesReportRun.fromProto(resp)));
    }
    getRetailAccountBalance(r) {
      const request = r.toApiJson ? r : new GetRetailAccountBalanceRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/GetRetailAccountBalance", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRetailAccountBalanceResponse.fromProto(resp)));
    }
    cancelRetailBilling(r) {
      const request = r.toApiJson ? r : new CancelRetailBillingRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/CancelRetailBilling", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setNextRetailInvoiceSequence(r) {
      const request = r.toApiJson ? r : new SetNextRetailInvoiceSequenceRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/SetNextRetailInvoiceSequence", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getNextRetailInvoiceSequence(r) {
      const request = r.toApiJson ? r : new GetNextRetailInvoiceSequenceRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/GetNextRetailInvoiceSequence", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetNextRetailInvoiceSequenceResponse.fromProto(resp)));
    }
    resetPaymentFacilitator(r) {
      const request = r.toApiJson ? r : new ResetPaymentFacilitatorRequest(r);
      return this.http.post(this._host + "/billing.v1.MerchantService/ResetPaymentFacilitator", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    static {
      this.ɵfac = function MerchantApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MerchantApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MerchantApiService,
        factory: MerchantApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MerchantApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PaymentMethodApiService = /*#__PURE__*/(() => {
  class PaymentMethodApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listPaymentCards(r) {
      const request = r.toApiJson ? r : new ListPaymentCardsRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentMethodService/ListPaymentCards", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPaymentCardsResponse.fromProto(resp)));
    }
    deletePaymentCard(r) {
      const request = r.toApiJson ? r : new DeletePaymentCardRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentMethodService/DeletePaymentCard", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setDefaultPaymentMethod(r) {
      const request = r.toApiJson ? r : new SetDefaultPaymentMethodRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentMethodService/SetDefaultPaymentMethod", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListPaymentMethodsRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentMethodService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPaymentMethodsResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function PaymentMethodApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentMethodApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PaymentMethodApiService,
        factory: PaymentMethodApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PaymentMethodApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PaymentApiService = /*#__PURE__*/(() => {
  class PaymentApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListPaymentRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPaymentResponse.fromProto(resp)));
    }
    getRetail(r) {
      const request = r.toApiJson ? r : new GetRetailPaymentRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/GetRetail", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRetailPaymentResponse.fromProto(resp)));
    }
    listRetail(r) {
      const request = r.toApiJson ? r : new ListRetailPaymentsRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/ListRetail", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListRetailPaymentsResponse.fromProto(resp)));
    }
    listRetailTransactions(r) {
      const request = r.toApiJson ? r : new ListRetailTransactionsRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/ListRetailTransactions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListRetailTransactionsResponse.fromProto(resp)));
    }
    listRetailDisputes(r) {
      const request = r.toApiJson ? r : new ListRetailDisputesRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/ListRetailDisputes", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListRetailDisputesResponse.fromProto(resp)));
    }
    getRetailDispute(r) {
      const request = r.toApiJson ? r : new GetRetailDisputeRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/GetRetailDispute", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRetailDisputeResponse.fromProto(resp)));
    }
    closeRetailDispute(r) {
      const request = r.toApiJson ? r : new CloseRetailDisputeRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/CloseRetailDispute", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    prepareRetail(r) {
      const request = r.toApiJson ? r : new PrepareRetailPaymentRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/PrepareRetail", request.toApiJson(), this.apiOptions()).pipe(map(resp => PrepareRetailPaymentResponse.fromProto(resp)));
    }
    confirmRetail(r) {
      const request = r.toApiJson ? r : new ConfirmRetailPaymentRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/ConfirmRetail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    retailStatus(r) {
      const request = r.toApiJson ? r : new RetailStatusRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/RetailStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => RetailStatusResponse.fromProto(resp)));
    }
    retailPaymentsEnabled(r) {
      const request = r.toApiJson ? r : new RetailPaymentsEnabledRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/RetailPaymentsEnabled", request.toApiJson(), this.apiOptions()).pipe(map(resp => RetailPaymentsEnabledResponse.fromProto(resp)));
    }
    configureRetailProvider(r) {
      const request = r.toApiJson ? r : new ConfigureRetailPaymentProviderRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/ConfigureRetailProvider", request.toApiJson(), this.apiOptions()).pipe(map(resp => ConfigureRetailPaymentProviderResponse.fromProto(resp)));
    }
    updateRetailProvider(r) {
      const request = r.toApiJson ? r : new UpdateRetailPaymentProviderRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/UpdateRetailProvider", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getRetailProvider(r) {
      const request = r.toApiJson ? r : new GetRetailPaymentProviderRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/GetRetailProvider", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRetailPaymentProviderResponse.fromProto(resp)));
    }
    submitEvidence(r) {
      const request = r.toApiJson ? r : new SubmitEvidenceRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/SubmitEvidence", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getWholesaleProviderPublicKey(r) {
      const request = r.toApiJson ? r : new GetWholesaleProviderPublicKeyRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/GetWholesaleProviderPublicKey", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWholesaleProviderPublicKeyResponse.fromProto(resp)));
    }
    refundRetail(r) {
      const request = r.toApiJson ? r : new RefundRetailPaymentRequest(r);
      return this.http.post(this._host + "/billing.v1.PaymentService/RefundRetail", request.toApiJson(), this.apiOptions()).pipe(map(resp => RefundRetailPaymentResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function PaymentApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PaymentApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PaymentApiService,
        factory: PaymentApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PaymentApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PricingApiService = /*#__PURE__*/(() => {
  class PricingApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMultiRetail(r) {
      const request = r.toApiJson ? r : new GetMultiRetailPricingRequest(r);
      return this.http.post(this._host + "/billing.v1.PricingService/GetMultiRetail", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiRetailPricingResponse.fromProto(resp)));
    }
    upsertRetail(r) {
      const request = r.toApiJson ? r : new UpsertRetailPricingRequest(r);
      return this.http.post(this._host + "/billing.v1.PricingService/UpsertRetail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteRetail(r) {
      const request = r.toApiJson ? r : new DeleteRetailPricingRequest(r);
      return this.http.post(this._host + "/billing.v1.PricingService/DeleteRetail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiBundleRetail(r) {
      const request = r.toApiJson ? r : new GetMultiBundleRetailPricingRequest(r);
      return this.http.post(this._host + "/billing.v1.PricingService/GetMultiBundleRetail", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiBundleRetailPricingResponse.fromProto(resp)));
    }
    getWholesaleComparison(r) {
      const request = r.toApiJson ? r : new GetWholesaleComparisonRequest(r);
      return this.http.post(this._host + "/billing.v1.PricingService/GetWholesaleComparison", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWholesaleComparisonResponse.fromProto(resp)));
    }
    setWholesaleProductStrategy(r) {
      const request = r.toApiJson ? r : new SetWholesaleProductStrategyRequest(r);
      return this.http.post(this._host + "/billing.v1.PricingService/SetWholesaleProductStrategy", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setWholesaleProductVolumeCommitment(r) {
      const request = r.toApiJson ? r : new SetWholesaleProductVolumeCommitmentRequest(r);
      return this.http.post(this._host + "/billing.v1.PricingService/SetWholesaleProductVolumeCommitment", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getPurchaseCost(r) {
      const request = r.toApiJson ? r : new GetPurchaseCostRequest(r);
      return this.http.post(this._host + "/billing.v1.PricingService/GetPurchaseCost", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPurchaseCostResponse.fromProto(resp)));
    }
    getMultiWholesaleCost(r) {
      const request = r.toApiJson ? r : new GetMultiWholesaleCostRequest(r);
      return this.http.post(this._host + "/billing.v1.PricingService/GetMultiWholesaleCost", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiWholesaleCostResponse.fromProto(resp)));
    }
    upsertWholesale(r) {
      const request = r.toApiJson ? r : new UpsertWholesalePricingRequest(r);
      return this.http.post(this._host + "/billing.v1.PricingService/UpsertWholesale", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    static {
      this.ɵfac = function PricingApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PricingApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PricingApiService,
        factory: PricingApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PricingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ProductApiService = /*#__PURE__*/(() => {
  class ProductApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateProductRequest(r);
      return this.http.post(this._host + "/billing.v1.ProductService/Create", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateProductRequest(r);
      return this.http.post(this._host + "/billing.v1.ProductService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteProductRequest(r);
      return this.http.post(this._host + "/billing.v1.ProductService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    static {
      this.ɵfac = function ProductApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ProductApiService,
        factory: ProductApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ProductApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ProductSummaryApiService = /*#__PURE__*/(() => {
  class ProductSummaryApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listSubscriptionRetentionByGroup(r) {
      const request = r.toApiJson ? r : new ListSubscriptionRetentionRequest(r);
      return this.http.post(this._host + "/billing.v1.ProductSummaryService/ListSubscriptionRetentionByGroup", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSubscriptionRetentionByGroupResponse.fromProto(resp)));
    }
    listSubscriptionRetentionBySku(r) {
      const request = r.toApiJson ? r : new ListSubscriptionRetentionRequest(r);
      return this.http.post(this._host + "/billing.v1.ProductSummaryService/ListSubscriptionRetentionBySKU", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSubscriptionRetentionBySKUResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function ProductSummaryApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductSummaryApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ProductSummaryApiService,
        factory: ProductSummaryApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ProductSummaryApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PurchaseApiService = /*#__PURE__*/(() => {
  class PurchaseApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListPurchaseRequest(r);
      return this.http.post(this._host + "/billing.v1.PurchaseService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPurchaseResponse.fromProto(resp)));
    }
    getMultiCustomerSummaries(r) {
      const request = r.toApiJson ? r : new GetMultiCustomerSummariesRequest(r);
      return this.http.post(this._host + "/billing.v1.PurchaseService/GetMultiCustomerSummaries", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCustomerSummariesResponse.fromProto(resp)));
    }
    listPurchaseItems(r) {
      const request = r.toApiJson ? r : new ListPurchaseItemsRequest(r);
      return this.http.post(this._host + "/billing.v1.PurchaseService/ListPurchaseItems", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPurchaseItemsResponse.fromProto(resp)));
    }
    retry(r) {
      const request = r.toApiJson ? r : new RetryPurchaseRequest(r);
      return this.http.post(this._host + "/billing.v1.PurchaseService/Retry", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    void(r) {
      const request = r.toApiJson ? r : new VoidPurchaseRequest(r);
      return this.http.post(this._host + "/billing.v1.PurchaseService/Void", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    pauseDunning(r) {
      const request = r.toApiJson ? r : new PauseDunningRequest(r);
      return this.http.post(this._host + "/billing.v1.PurchaseService/PauseDunning", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    resumeDunning(r) {
      const request = r.toApiJson ? r : new ResumeDunningRequest(r);
      return this.http.post(this._host + "/billing.v1.PurchaseService/ResumeDunning", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    stopDunning(r) {
      const request = r.toApiJson ? r : new StopDunningRequest(r);
      return this.http.post(this._host + "/billing.v1.PurchaseService/StopDunning", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    static {
      this.ɵfac = function PurchaseApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PurchaseApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PurchaseApiService,
        factory: PurchaseApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PurchaseApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let RecurringInvoiceApiService = /*#__PURE__*/(() => {
  class RecurringInvoiceApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createRecurringInvoice(r) {
      const request = r.toApiJson ? r : new RecurringInvoice(r);
      return this.http.post(this._host + "/billing.v1.RecurringInvoiceService/CreateRecurringInvoice", request.toApiJson(), this.apiOptions()).pipe(map(resp => RecurringInvoice.fromProto(resp)));
    }
    updateRecurringInvoice(r) {
      const request = r.toApiJson ? r : new UpdateRecurringInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.RecurringInvoiceService/UpdateRecurringInvoice", request.toApiJson(), this.apiOptions()).pipe(map(resp => RecurringInvoice.fromProto(resp)));
    }
    getRecurringInvoice(r) {
      const request = r.toApiJson ? r : new GetRecurringInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.RecurringInvoiceService/GetRecurringInvoice", request.toApiJson(), this.apiOptions()).pipe(map(resp => RecurringInvoice.fromProto(resp)));
    }
    listRecurringInvoices(r) {
      const request = r.toApiJson ? r : new ListRecurringInvoicesRequest(r);
      return this.http.post(this._host + "/billing.v1.RecurringInvoiceService/ListRecurringInvoices", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListRecurringInvoicesResponse.fromProto(resp)));
    }
    deleteRecurringInvoice(r) {
      const request = r.toApiJson ? r : new DeleteRecurringInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.RecurringInvoiceService/DeleteRecurringInvoice", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    static {
      this.ɵfac = function RecurringInvoiceApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RecurringInvoiceApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RecurringInvoiceApiService,
        factory: RecurringInvoiceApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RecurringInvoiceApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let RefundApiService = /*#__PURE__*/(() => {
  class RefundApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateRefundRequest(r);
      return this.http.post(this._host + "/billing.v1.RefundService/Create", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListRefundsRequest(r);
      return this.http.post(this._host + "/billing.v1.RefundService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListRefundsResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function RefundApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RefundApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RefundApiService,
        factory: RefundApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RefundApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let RetailCustomerConfigurationApiService = /*#__PURE__*/(() => {
  class RetailCustomerConfigurationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetRetailCustomerConfigurationRequest(r);
      return this.http.post(this._host + "/billing.v1.RetailCustomerConfigurationService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRetailCustomerConfigurationResponse.fromProto(resp)));
    }
    upsert(r) {
      const request = r.toApiJson ? r : new UpsertRetailCustomerConfigurationRequest(r);
      return this.http.post(this._host + "/billing.v1.RetailCustomerConfigurationService/Upsert", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    static {
      this.ɵfac = function RetailCustomerConfigurationApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RetailCustomerConfigurationApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RetailCustomerConfigurationApiService,
        factory: RetailCustomerConfigurationApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RetailCustomerConfigurationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SalesCreditNoteApiService = /*#__PURE__*/(() => {
  class SalesCreditNoteApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateSalesCreditNoteRequest(r);
      return this.http.post(this._host + "/billing.v1.SalesCreditNoteService/Create", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListSalesCreditNoteRequest(r);
      return this.http.post(this._host + "/billing.v1.SalesCreditNoteService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSalesCreditNoteResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function SalesCreditNoteApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SalesCreditNoteApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SalesCreditNoteApiService,
        factory: SalesCreditNoteApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SalesCreditNoteApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SalesInvoiceApiService = /*#__PURE__*/(() => {
  class SalesInvoiceApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListSalesInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.SalesInvoiceService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSalesInvoiceResponse.fromProto(resp)));
    }
    post(r) {
      const request = r.toApiJson ? r : new PostSalesInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.SalesInvoiceService/Post", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSalesInvoiceRequest(r);
      return this.http.post(this._host + "/billing.v1.SalesInvoiceService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesInvoiceResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function SalesInvoiceApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SalesInvoiceApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SalesInvoiceApiService,
        factory: SalesInvoiceApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SalesInvoiceApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SubscriptionRelationshipApiService = /*#__PURE__*/(() => {
  class SubscriptionRelationshipApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    replace(r) {
      const request = r.toApiJson ? r : new ReplaceSubscriptionRelationshipsRequest(r);
      return this.http.post(this._host + "/billing.v1.SubscriptionRelationshipService/Replace", request.toApiJson(), this.apiOptions()).pipe(map(resp => ReplaceSubscriptionRelationshipsResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListSubscriptionRelationshipsRequest(r);
      return this.http.post(this._host + "/billing.v1.SubscriptionRelationshipService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSubscriptionRelationshipsResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiSubscriptionRelationshipsRequest(r);
      return this.http.post(this._host + "/billing.v1.SubscriptionRelationshipService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiSubscriptionRelationshipsResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function SubscriptionRelationshipApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SubscriptionRelationshipApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SubscriptionRelationshipApiService,
        factory: SubscriptionRelationshipApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SubscriptionRelationshipApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let TaxApiService = /*#__PURE__*/(() => {
  class TaxApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    calculate(r) {
      const request = r.toApiJson ? r : new CalculateTaxRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/Calculate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CalculateTaxResponse.fromProto(resp)));
    }
    calculateLineItems(r) {
      const request = r.toApiJson ? r : new CalculateLineItemTaxesRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/CalculateLineItems", request.toApiJson(), this.apiOptions()).pipe(map(resp => CalculateLineItemTaxesResponse.fromProto(resp)));
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateTaxRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateTaxResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiTaxRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiTaxResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateTaxRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListTaxRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTaxResponse.fromProto(resp)));
    }
    archive(r) {
      const request = r.toApiJson ? r : new ArchiveTaxRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/Archive", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    replaceTaxRule(r) {
      const request = r.toApiJson ? r : new ReplaceTaxRuleRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/ReplaceTaxRule", request.toApiJson(), this.apiOptions()).pipe(map(resp => ReplaceTaxRuleResponse.fromProto(resp)));
    }
    bulkReplaceTaxRules(r) {
      const request = r.toApiJson ? r : new BulkReplaceTaxRulesRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/BulkReplaceTaxRules", request.toApiJson(), this.apiOptions()).pipe(map(resp => BulkReplaceTaxRulesResponse.fromProto(resp)));
    }
    getTaxRule(r) {
      const request = r.toApiJson ? r : new GetTaxRuleRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/GetTaxRule", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTaxRuleResponse.fromProto(resp)));
    }
    listTaxRules(r) {
      const request = r.toApiJson ? r : new ListTaxRulesRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/ListTaxRules", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTaxRulesResponse.fromProto(resp)));
    }
    deleteTaxRule(r) {
      const request = r.toApiJson ? r : new DeleteTaxRuleRequest(r);
      return this.http.post(this._host + "/billing.v1.TaxService/DeleteTaxRule", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    static {
      this.ɵfac = function TaxApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TaxApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TaxApiService,
        factory: TaxApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TaxApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let VendorApiService = /*#__PURE__*/(() => {
  class VendorApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    generateReport(r) {
      const request = r.toApiJson ? r : new GenerateVendorReportRequest(r);
      return this.http.post(this._host + "/billing.v1.VendorService/GenerateReport", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateVendorReportResponse.fromProto(resp)));
    }
    getRevenueStats(r) {
      const request = r.toApiJson ? r : new GetRevenueStatsRequest(r);
      return this.http.post(this._host + "/billing.v1.VendorService/GetRevenueStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRevenueStatsResponse.fromProto(resp)));
    }
    static {
      this.ɵfac = function VendorApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VendorApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VendorApiService,
        factory: VendorApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VendorApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

// Hardcoded conversion rate of 1.4 for our currently supported currencies (CAD and AUD)
const usdConversionRate = 1.4;

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AccountBalance, AddBundleRequest, AddBundleResponse, AddCreditRequest, AddLineItemRequest, AddLineItemResponse, Adjustment, AlignmentSubscription, AppliedBundle, AppliedBundleItem, AppliedCredit, AppliedCreditNote, AppliedDiscount, AppliedFee, AppliedReferenceType, AppliedTaxRate, AppliedTo, ArchiveTaxRequest, Balance, BalanceAmount, BankAccount, BankReconciliationApiService, BillItemRequest, BillMultipleItemsRequest, BillMultipleItemsResponse, BillableItem, BillableItemCustomerAddress, BillingApiService, BillingStrategy, BulkReplaceTaxRulesRequest, BulkReplaceTaxRulesResponse, Bundle, BundleApiService, BundleItem, BundleItemPrice, BundlePricing, BundlePricingPriceAndFrequency, CalculateCreditNoteRequest, CalculateCreditNoteResponse, CalculateLineItemTaxesRequest, CalculateLineItemTaxesRequestLineItem, CalculateLineItemTaxesResponse, CalculateLineItemTaxesResponseLineItemTaxes, CalculateTaxRequest, CalculateTaxResponse, CanBillItemRequest, CanCreateSubscriptionsRequest, CanCreateSubscriptionsRequestSkusEntry, CanCreateSubscriptionsRequestSubscriptionItem, CanCreateSubscriptionsResponse, CancelRetailBillingRequest, CardType, ChangeCustomUnitPriceRequest, ChangeFrequencyRequest, ChangeRenewalDateRequest, ChargeInvoiceRequest, ChargeSalesInvoiceRequest, CloseRetailDisputeRequest, CollectionMethod, Commitment, ComponentPricing, ConfigureRetailPaymentProviderRequest, ConfigureRetailPaymentProviderResponse, ConfirmRetailPaymentRequest, ConnectStripeAccountRequest, ConnectStripeAccountResponse, Consumer, Contract, ContractApiService, ContractDocument, ContractDocumentApiService, ContractSubscriptionStatus, CreateContractRequest, CreateContractResponse, CreateCreditNoteRequest, CreateCreditNoteResponse, CreateDiscountRequest, CreateDiscountResponse, CreateInvoiceRequest, CreateInvoiceResponse, CreateMerchantRequest, CreateMerchantRequestIncludeInFinancialRecords, CreateMerchantServicesReportRun, CreateMeteredComponentRequest, CreatePaymentCardRequest, CreatePaymentLinkRequest, CreatePaymentLinkResponse, CreatePricingPlanProductRequest, CreatePricingPlanProductRequestPricingEntry, CreatePricingPlanProductResponse, CreatePricingPlanRequest, CreatePricingPlanResponse, CreateProductRequest, CreateRefundRequest, CreateSalesCreditNoteRequest, CreateStripeExternalAccountRequest, CreateSubscriptionRequest, CreateSubscriptionResponse, CreateSubscriptionsRequest, CreateSubscriptionsResponse, CreateTaxRequest, CreateTaxResponse, CreateUsageRequest, CreditApiService, CreditBalance, CreditNote, CreditNoteApiService, CreditNoteReason, CreditNoteType, CreditType, Currency, CustomerSummary, DateRange, DefaultCustomerConfiguration, DeleteBankAccountRequest, DeleteBillableItemRequest, DeleteContractDocumentRequest, DeleteInvoiceRequest, DeleteLineItemRequest, DeleteLineItemResponse, DeletePaymentCardRequest, DeletePricingPlanProductRequest, DeleteProductRequest, DeleteRecurringInvoiceRequest, DeleteRetailPricingRequest, DeleteTaxRuleRequest, Discount, DiscountApiService, DiscountType, Dispute, DisputeEvidence, DisputeEvidenceDetails, DisputeStatus, DuplicateInvoiceRequest, DuplicateInvoiceResponse, EntityType, ExpireBillableItemRequest, ExpireDiscountRequest, ExportResponse, ExportSubscriptionsRequest, Fee, FeeAmountType, FeeType, FieldMask, File, Frequency, GenerateBillableItemsCSVRequest, GenerateBillableItemsCSVResponse, GenerateVendorReportRequest, GenerateVendorReportResponse, GetBalanceRequest, GetBalanceResponse, GetBillableItemRequest, GetBillableItemResponse, GetContractRequest, GetContractResponse, GetCreditNoteRequest, GetCreditNoteResponse, GetInvoiceRequest, GetInvoiceResponse, GetMerchantRequest, GetMerchantResponse, GetMerchantServicesReportRun, GetMerchantWholesaleCurrencyRequest, GetMerchantWholesaleCurrencyResponse, GetMultiBundleRequest, GetMultiBundleResponse, GetMultiBundleResponseBundlesEntry, GetMultiBundleRetailPricingRequest, GetMultiBundleRetailPricingResponse, GetMultiBundleRetailPricingResponsePricesEntry, GetMultiContractsRequest, GetMultiContractsResponse, GetMultiContractsResponseContractsEntry, GetMultiCreditNoteRequest, GetMultiCreditNoteResponse, GetMultiCustomerSummariesRequest, GetMultiCustomerSummariesResponse, GetMultiPricingPlanProductRequest, GetMultiPricingPlanProductResponse, GetMultiPricingPlanRequest, GetMultiPricingPlanResponse, GetMultiProductPricingRequest, GetMultiProductPricingResponse, GetMultiProductPricingResponseProductPricesEntry, GetMultiProductRequest, GetMultiProductResponse, GetMultiProductResponseProductsEntry, GetMultiRetailConfigurationsRequest, GetMultiRetailConfigurationsResponse, GetMultiRetailConfigurationsResponseRetailConfigurationsEntry, GetMultiRetailPricingRequest, GetMultiRetailPricingResponse, GetMultiRetailPricingResponseProductPricesEntry, GetMultiSubscriptionRelationshipsRequest, GetMultiSubscriptionRelationshipsResponse, GetMultiSubscriptionsRequest, GetMultiSubscriptionsRequestKey, GetMultiSubscriptionsResponse, GetMultiTaxRequest, GetMultiTaxResponse, GetMultiWholesaleCostRequest, GetMultiWholesaleCostResponse, GetNextRetailInvoiceSequenceRequest, GetNextRetailInvoiceSequenceResponse, GetOutstandingBalanceRequest, GetOutstandingBalanceResponse, GetPayoutSummaryRequest, GetPayoutSummaryResponse, GetPricingPlanProductRequest, GetPricingPlanProductResponse, GetProductSummariesTotalRequest, GetProductSummariesTotalResponse, GetPurchaseCostRequest, GetPurchaseCostResponse, GetRecurringInvoiceRequest, GetRetailAccountBalanceRequest, GetRetailAccountBalanceResponse, GetRetailBalanceRequest, GetRetailBalanceResponse, GetRetailCustomerConfigurationRequest, GetRetailCustomerConfigurationResponse, GetRetailDisputeRequest, GetRetailDisputeResponse, GetRetailPaymentProviderRequest, GetRetailPaymentProviderResponse, GetRetailPaymentRequest, GetRetailPaymentResponse, GetRetailPayoutRequest, GetRetailPayoutResponse, GetRevenueStatsRequest, GetRevenueStatsResponse, GetSalesInvoiceRequest, GetSalesInvoiceResponse, GetStatisticsRequest, GetStatisticsResponse, GetTaxRuleRequest, GetTaxRuleResponse, GetUpcomingInvoicePreviewRequest, GetUpcomingInvoicePreviewResponse, GetWholesaleComparisonRequest, GetWholesaleComparisonRequestGetWholesaleComparisonFilters, GetWholesaleComparisonResponse, GetWholesaleComparisonResponseGetWholesaleComparisonResult, GetWholesaleProviderPublicKeyRequest, GetWholesaleProviderPublicKeyResponse, HostService, Interval, Invoice, InvoiceApiService, InvoiceCustomerAddress, InvoiceItem, InvoiceStatus, Item, LastPaymentStatus, LineItem, ListBankAccountsRequest, ListBankAccountsResponse, ListBillableItemsRequest, ListBillableItemsRequestFilters, ListBillableItemsResponse, ListBundlesRequest, ListBundlesRequestFilters, ListBundlesResponse, ListContractDocumentsRequest, ListContractDocumentsRequestFilters, ListContractDocumentsResponse, ListContractsRequest, ListContractsResponse, ListCreditNotesRequest, ListCreditNotesRequestFilters, ListCreditNotesResponse, ListDiscountsRequest, ListDiscountsRequestFilters, ListDiscountsResponse, ListInvoicesRequest, ListInvoicesRequestFilters, ListInvoicesRequestFiltersDateFilter, ListInvoicesRequestFiltersDateFilterDateField, ListInvoicesResponse, ListMerchantBillingReportsRequest, ListMerchantBillingReportsResponse, ListPaymentCardsRequest, ListPaymentCardsResponse, ListPaymentMethodsRequest, ListPaymentMethodsResponse, ListPaymentRequest, ListPaymentRequestListPaymentFilters, ListPaymentResponse, ListPayoutsRequest, ListPayoutsRequestFilters, ListPayoutsResponse, ListPricingPlanProductsRequest, ListPricingPlanProductsRequestListPricingPlanProductsFilters, ListPricingPlanProductsResponse, ListProductSummariesRequest, ListProductSummariesResponse, ListProductsRequest, ListProductsRequestListProductsFilters, ListProductsResponse, ListPurchaseItemsRequest, ListPurchaseItemsRequestListPurchaseItemsFilters, ListPurchaseItemsResponse, ListPurchaseRequest, ListPurchaseRequestListPurchaseBillingStrategyFilter, ListPurchaseRequestListPurchaseFilters, ListPurchaseRequestState, ListPurchaseResponse, ListRecurringInvoicesFilters, ListRecurringInvoicesFiltersDateFilter, ListRecurringInvoicesFiltersDetailedInterval, ListRecurringInvoicesRequest, ListRecurringInvoicesResponse, ListRefundsRequest, ListRefundsResponse, ListRetailDisputesRequest, ListRetailDisputesRequestListRetailDisputesFilters, ListRetailDisputesResponse, ListRetailPaymentsRequest, ListRetailPaymentsRequestListRetailPaymentsFilters, ListRetailPaymentsResponse, ListRetailPayoutsRequest, ListRetailPayoutsResponse, ListRetailTransactionsRequest, ListRetailTransactionsRequestListRetailTransactionsFilters, ListRetailTransactionsResponse, ListSalesCreditNoteRequest, ListSalesCreditNoteRequestListSalesCreditNoteFilters, ListSalesCreditNoteResponse, ListSalesInvoiceRequest, ListSalesInvoiceRequestListSalesInvoiceFilters, ListSalesInvoiceResponse, ListSubscriptionRelationshipsRequest, ListSubscriptionRelationshipsRequestFilters, ListSubscriptionRelationshipsResponse, ListSubscriptionRetentionByGroupResponse, ListSubscriptionRetentionByGroupResponseSubscriptionRetentionByGroup, ListSubscriptionRetentionBySKUResponse, ListSubscriptionRetentionRequest, ListSubscriptionRetentionRequestFilters, ListSubscriptionsRequest, ListSubscriptionsRequestFilters, ListSubscriptionsResponse, ListTaxRequest, ListTaxRequestFilters, ListTaxResponse, ListTaxRulesRequest, ListTaxRulesRequestFilters, ListTaxRulesResponse, Merchant, MerchantApiService, MerchantReport, MerchantReportStatus, MerchantServicesReportRun, MerchantServicesReportRunStatus, MerchantServicesReportRunType, MerchantType, MeteredComponent, Month, Note, PagedRequestOptions, PagedResponseMetadata, PauseDunningRequest, PayInvoiceRequest, Payment, PaymentACHDebit, PaymentACSSDebit, PaymentAllocationType, PaymentApiService, PaymentCard, PaymentCardCARD_TYPE, PaymentCardFUNDING_TYPE, PaymentErrorCode, PaymentFacilitatorType, PaymentIntent, PaymentIntentStatus, PaymentLinkItem, PaymentMethod, PaymentMethodApiService, PaymentMethodType, PaymentPaymentAllocation, PaymentProcessor, PaymentSource, PaymentStatus, PaymentStatuses, Payout, PayoutStatus, PayoutType, PostSalesInvoiceRequest, PrepareRetailPaymentRequest, PrepareRetailPaymentRequestOrder, PrepareRetailPaymentResponse, Pricing, PricingApiService, PricingPlan, PricingPlanProduct, PricingPlanProductPricing, PricingPlanProductPricingEntry, PricingRule, PricingRuleType, Product, ProductApiService, ProductPrices, ProductPricing, ProductPricingRule, ProductPricingType, ProductSummary, ProductSummaryApiService, ProductSummaryBillingStrategy, ProductSummaryDiscount, ProductSummaryDiscountDiscountType, ProductSummaryProductType, ProductType, Purchase, PurchaseApiService, PurchaseItem, PurchaseStatus, ReconcilePayoutRequest, ReconcilePayoutResponse, RecurringInvoice, RecurringInvoiceApiService, RecurringInvoiceBundle, RecurringInvoiceCustomerAddress, RecurringInvoiceItem, RecurringInvoiceLineItem, RecurringInvoiceStatus, ReferenceType, Refund, RefundApiService, RefundReason, RefundRetailPaymentRequest, RefundRetailPaymentResponse, RefundStatus, RelationshipType, RemoveBundleRequest, RemoveBundleResponse, RenewalState, ReplaceSubscriptionPresetsRequest, ReplaceSubscriptionPresetsResponse, ReplaceSubscriptionRelationshipsRequest, ReplaceSubscriptionRelationshipsResponse, ReplaceTaxRuleRequest, ReplaceTaxRuleResponse, ResetContractPricingRequest, ResetPaymentFacilitatorRequest, ResumeDunningRequest, RetailConfiguration, RetailCustomerConfiguration, RetailCustomerConfigurationApiService, RetailPayment, RetailPaymentACHDetails, RetailPaymentACSSDetails, RetailPaymentCardDetails, RetailPaymentPaymentMethodDetailsType, RetailPaymentReferenceType, RetailPaymentsEnabledRequest, RetailPaymentsEnabledResponse, RetailPayout, RetailRefund, RetailRefundFailureReason, RetailRefundReason, RetailRefundStatus, RetailStatusRequest, RetailStatusResponse, RetailStatusResponseVerificationError, RetailStatusResponseVerificationRequirements, RetailTransaction, RetailTransactionType, RetentionMetrics, RetryPurchaseRequest, ReverseSubscriptionRequest, SalesCreditNote, SalesCreditNoteApiService, SalesCreditNoteStatus, SalesInvoice, SalesInvoiceApiService, SalesInvoiceStatus, SalesInvoiceType, SearchMerchantsRequest, SearchMerchantsRequestSortBy, SearchMerchantsResponse, SendCreditNoteRequest, SendInvoiceRequest, SendSalesInvoiceEmailRequest, SendSalesInvoiceReceiptEmailRequest, SetAutoBillableRequest, SetAutoChargeInvoicesRequest, SetAutoPostInvoicesRequest, SetDefaultBankAccountRequest, SetDefaultPaymentCardRequest, SetDefaultPaymentMethodRequest, SetHasAlternativePaymentMethodRequest, SetIncludeInFinancialRecordsRequest, SetNextRetailInvoiceSequenceRequest, SetRenewalStartRequest, SetWholesaleProductStrategyRequest, SetWholesaleProductVolumeCommitmentRequest, SortDirection, Source, StartRevRecTemplateBackfillRequest, StopDunningRequest, SubmitEvidenceRequest, SubmitEvidenceRequestDisputeEvidence, SubscribeValidation, SubscribeValidationStatus, Subscription, SubscriptionPreset, SubscriptionProjectionFilter, SubscriptionRelationship, SubscriptionRelationshipApiService, SubscriptionStatus, TaxApiService, TaxRate, TaxRule, TaxRuleCustomer, TaxRuleCustomerCustomerAddress, TaxRuleEntityType, TaxRuleProduct, TaxRuleProductProductIdentifier, TaxRuleTaxRuleEntity, TaxRuleType, TickComponentUsageRequest, UnexpireBillableItemRequest, UpdateBundleRequest, UpdateBundleResponse, UpdateContractRequest, UpdateContractRequestMutation, UpdateContractResponse, UpdateContractSubscriptionRequest, UpdateDefaultTaxRatesRequest, UpdateDefaultTaxRatesResponse, UpdateDiscountRequest, UpdateInvoiceRequest, UpdateInvoiceResponse, UpdateLineItemRequest, UpdateLineItemResponse, UpdateMerchantRequest, UpdateMerchantRequestIncludeInFinancialRecords, UpdatePaymentCardRequest, UpdatePricingPlanProductRequest, UpdatePricingPlanProductRequestPricingEntry, UpdatePricingPlanProductResponse, UpdatePricingPlanRequest, UpdatePricingPlanResponse, UpdateProductRequest, UpdateRecurringInvoiceRequest, UpdateRetailPaymentProviderRequest, UpdateSubscriptionRequest, UpdateSubscriptionRequestSubscription, UpdateSubscriptionResponse, UpdateTaxRequest, UpsertBundleRequest, UpsertDefaultRetailCustomerConfigurationRequest, UpsertRetailConfigurationRequest, UpsertRetailCustomerConfigurationRequest, UpsertRetailPricingRequest, UpsertRetailPricingRequestPricingEntry, UpsertWholesalePricingRequest, ValidateResponse, VendorApiService, VoidInvoiceRequest, VoidPurchaseRequest, WholesaleCostItemRequest, usdConversionRate };
